const municipioCodigos = {
"Alta Floresta D'Oeste|RO": "1100015",
"Ariquemes|RO": "1100023",
"Jaru|RO": "1100114",
"Alto Paraíso|RO": "1100403",
"Machadinho D'Oeste|RO": "1100130",
"Itapuã do Oeste|RO": "1101104",
"Cujubim|RO": "1100940",
"Buritis|RO": "1100452",
"Monte Negro|RO": "1101401",
"Theobroma|RO": "1101609",
"Campo Novo de Rondônia|RO": "1100700",
"Candeias do Jamari|RO": "1100809",
"Cacaulândia|RO": "1100601",
"Mirante da Serra|RO": "1101302",
"Vale do Anari|RO": "1101757",
"Governador Jorge Teixeira|RO": "1101005",
"Rio Crespo|RO": "1100262",
"Nova Mamoré|RO": "1100338",
"Cabixi|RO": "1100031",
"Cacoal|RO": "1100049",
"Espigão D'Oeste|RO": "1100098",
"Rondolândia|MT": "5107578",
"Porto Velho|RO": "1100205",
"Juína|MT": "5105150",
"Colorado do Oeste|RO": "1100064",
"Costa Marques|RO": "1100080",
"Ji-Paraná|RO": "1100122",
"Pimenta Bueno|RO": "1100189",
"Ministro Andreazza|RO": "1101203",
"Vilhena|RO": "1100304",
"Presidente Médici|RO": "1100254",
"Castanheiras|RO": "1100908",
"Nova Brasilândia D'Oeste|RO": "1100148",
"Parecis|RO": "1101450",
"Lábrea|AM": "1302405",
"São Miguel do Guaporé|RO": "1100320",
"Rolim de Moura|RO": "1100288",
"Cerejeiras|RO": "1100056",
"Chupinguaia|RO": "1100924",
"Corumbiara|RO": "1100072",
"Guajará-Mirim|RO": "1100106",
"Humaitá|AM": "1301704",
"Teixeirópolis|RO": "1101559",
"Aripuanã|MT": "5101407",
"Vale do Paraíso|RO": "1101807",
"São Francisco do Guaporé|RO": "1101492",
"Ouro Preto do Oeste|RO": "1100155",
"Primavera de Rondônia|RO": "1101476",
"Santa Luzia D'Oeste|RO": "1100296",
"Manaus|AM": "1302603",
"Apuí|AM": "1300144",
"Seringueiras|RO": "1101500",
"Rio Branco|AC": "1200401",
"Comodoro|MT": "5103304",
"Manicoré|AM": "1302702",
"Alvorada D'Oeste|RO": "1100346",
"Canutama|AM": "1300904",
"Acrelândia|AC": "1200013",
"Plácido de Castro|AC": "1200385",
"Bernardo do Mearim|MA": "2101939",
"Aparecida de Goiânia|GO": "5201405",
"Novo Horizonte do Oeste|RO": "1100502",
"Frecheirinha|CE": "2304509",
"Brasiléia|AC": "1200104",
"Cáceres|MT": "5102504",
"Nova União|RO": "1101435",
"Pimenteiras do Oeste|RO": "1101468",
"Alto Alegre dos Parecis|RO": "1100379",
"Picos|PI": "2208007",
"Itaporanga|SP": "3522802",
"Altamira|PA": "1500602",
"São Felipe D'Oeste|RO": "1101484",
"Colniza|MT": "5103254",
"Cuiabá|MT": "5103403",
"Urupá|RO": "1101708",
"Senador Guiomard|AC": "1200450",
"Assis Brasil|AC": "1200054",
"Rio de Janeiro|RJ": "3304557",
"Bujari|AC": "1200138",
"Capixaba|AC": "1200179",
"Ipixuna|AM": "1301803",
"Cruzeiro do Sul|AC": "1200203",
"Porto Walter|AC": "1200393",
"Marechal Thaumaturgo|AC": "1200351",
"Rodrigues Alves|AC": "1200427",
"Mâncio Lima|AC": "1200336",
"Guajará|AM": "1301654",
"Tarauacá|AC": "1200609",
"Feijó|AC": "1200302",
"Epitaciolândia|AC": "1200252",
"Itamarati|AM": "1301951",
"Jordão|AC": "1200328",
"Manoel Urbano|AC": "1200344",
"Santa Rosa do Purus|AC": "1200435",
"Boca do Acre|AM": "1300706",
"Sena Madureira|AC": "1200500",
"Xapuri|AC": "1200708",
"Pauini|AM": "1303502",
"Boa Vista|RR": "1400100",
"Porto Acre|AC": "1200807",
"Envira|AM": "1301506",
"Juiz de Fora|MG": "3136702",
"Itaituba|PA": "1503606",
"Belém|PA": "1501402",
"Alvarães|AM": "1300029",
"Uarini|AM": "1304260",
"Fonte Boa|AM": "1301605",
"Japurá|AM": "1302108",
"Amaturá|AM": "1300060",
"Santo Antônio do Içá|AM": "1303700",
"Anamã|AM": "1300086",
"Beruri|AM": "1300631",
"Caapiranga|AM": "1300839",
"Anori|AM": "1300102",
"Novo Aripuanã|AM": "1303304",
"Atalaia do Norte|AM": "1300201",
"Autazes|AM": "1300300",
"Barcelos|AM": "1300409",
"Barreirinha|AM": "1300508",
"Juruti|PA": "1503903",
"Benjamin Constant|AM": "1300607",
"Boa Vista do Ramos|AM": "1300680",
"Borba|AM": "1300805",
"Nova Olinda do Norte|AM": "1303106",
"Manacapuru|AM": "1302504",
"Tapauá|AM": "1304104",
"Carauari|AM": "1301001",
"Careiro|AM": "1301100",
"Careiro da Várzea|AM": "1301159",
"Coari|AM": "1301209",
"Tefé|AM": "1304203",
"Codajás|AM": "1301308",
"Eirunepé|AM": "1301407",
"Iranduba|AM": "1301852",
"Maués|AM": "1302900",
"Itacoatiara|AM": "1301902",
"Itapiranga|AM": "1302009",
"Urucurituba|AM": "1304401",
"Silves|AM": "1304005",
"Tabatinga|AM": "1304062",
"Juruá|AM": "1302207",
"Jutaí|AM": "1302306",
"Manaquiri|AM": "1302553",
"Rio Preto da Eva|AM": "1303569",
"São Paulo de Olivença|AM": "1303908",
"Presidente Figueiredo|AM": "1303536",
"Óbidos|PA": "1505106",
"São Gabriel da Cachoeira|AM": "1303809",
"Parintins|AM": "1303403",
"Parauapebas|PA": "1505536",
"Niterói|RJ": "3303302",
"Amapá|AP": "1600105",
"Santa Isabel do Rio Negro|AM": "1303601",
"Novo Airão|AM": "1303205",
"Nhamundá|AM": "1303007",
"São Luís|MA": "2111300",
"Rorainópolis|RR": "1400472",
"Oriximiná|PA": "1505304",
"Urucará|AM": "1304302",
"Castanhal|PA": "1502400",
"Jaú|SP": "3525300",
"São Paulo|SP": "3550308",
"Terra Santa|PA": "1507979",
"Santarém|PA": "1506807",
"Salvaterra|PA": "1506302",
"Palmas|TO": "1721000",
"Uruará|PA": "1508159",
"Rurópolis|PA": "1506195",
"Goiânia|GO": "5208707",
"São Sebastião do Uatumã|AM": "1303957",
"Maraã|AM": "1302801",
"Joinville|SC": "4209102",
"Santa Izabel do Oeste|PR": "4123808",
"Monte Alegre|PA": "1504802",
"Alenquer|PA": "1500404",
"Tonantins|AM": "1304237",
"Faro|PA": "1503002",
"Belterra|PA": "1501451",
"Recife|PE": "2611606",
"Aquiraz|CE": "2301000",
"Brasília|DF": "5300108",
"Medicilândia|PA": "1504455",
"Sapucaia|PA": "1507755",
"Rio Pardo|RS": "4315701",
"Caracaraí|RR": "1400209",
"Governador Nunes Freire|MA": "2104677",
"Bauru|SP": "3506003",
"Porto Alegre|RS": "4314902",
"Floresta Azul|BA": "2911006",
"Florianópolis|SC": "4205407",
"São Luiz do Anauá|RR": "1400605",
"Maringá|PR": "4115200",
"Curuá|PA": "1502855",
"Vigia|PA": "1508209",
"Pacaraima|RR": "1400456",
"Amajari|RR": "1400027",
"Mucajaí|RR": "1400308",
"Alto Alegre|RR": "1400050",
"Cantá|RR": "1400175",
"Caroebe|RR": "1400233",
"Iracema|RR": "1400282",
"Bonfim|RR": "1400159",
"São João da Baliza|RR": "1400506",
"Uiramutã|RR": "1400704",
"Marabá|PA": "1504208",
"Normandia|RR": "1400407",
"Santa Inês|MA": "2109908",
"Santa Luzia|MA": "2110005",
"Abaetetuba|PA": "1500107",
"Moju|PA": "1504703",
"Igarapé-Miri|PA": "1503309",
"Breves|PA": "1501808",
"Barcarena|PA": "1501303",
"Acará|PA": "1500206",
"Tailândia|PA": "1507953",
"Muaná|PA": "1504901",
"Tucuruí|PA": "1508100",
"Bagre|PA": "1501105",
"Mocajuba|PA": "1504604",
"Concórdia do Pará|PA": "1502756",
"Mãe do Rio|PA": "1504059",
"Capanema|PA": "1502202",
"Marituba|PA": "1504422",
"Ananindeua|PA": "1500800",
"Oeiras do Pará|PA": "1505205",
"Portel|PA": "1505809",
"Abel Figueiredo|PA": "1500131",
"Rondon do Pará|PA": "1506187",
"Bom Jesus do Tocantins|PA": "1501576",
"Afuá|PA": "1500305",
"Chaves|PA": "1502509",
"Água Azul do Norte|PA": "1500347",
"Almeirim|PA": "1500503",
"Laranjal do Jari|AP": "1600279",
"Porto de Moz|PA": "1505908",
"Prainha|PA": "1506005",
"Brasil Novo|PA": "1501725",
"Senador José Porfírio|PA": "1507805",
"Novo Progresso|PA": "1505031",
"Anapu|PA": "1500859",
"Vitória do Xingu|PA": "1508357",
"Presidente Sarney|MA": "2109270",
"Gurupi|TO": "1709500",
"Ferraz de Vasconcelos|SP": "3515707",
"Mata de São João|BA": "2921005",
"Águas Lindas de Goiás|GO": "5200258",
"Breu Branco|PA": "1501782",
"Pacajá|PA": "1505486",
"Colares|PA": "1502608",
"São Félix do Xingu|PA": "1507300",
"Anajás|PA": "1500701",
"Cametá|PA": "1502103",
"Santa Bárbara do Pará|PA": "1506351",
"Tracuateua|PA": "1508035",
"Salinópolis|PA": "1506203",
"Bonito|PA": "1501600",
"Bujaru|PA": "1501907",
"Gurupá|PA": "1503101",
"Bragança|PA": "1501709",
"Benevides|PA": "1501501",
"Santo Antônio do Tauá|PA": "1507003",
"Tomé-Açu|PA": "1508001",
"Magalhães Barata|PA": "1504109",
"Igarapé-Açu|PA": "1503200",
"Garrafão do Norte|PA": "1503077",
"São Sebastião da Boa Vista|PA": "1507706",
"Curralinho|PA": "1502806",
"Terra Alta|PA": "1507961",
"Marapanim|PA": "1504406",
"Tucumã|PA": "1508084",
"Santa Izabel do Pará|PA": "1506500",
"Baião|PA": "1501204",
"Maracanã|PA": "1504307",
"Curuçá|PA": "1502905",
"Ulianópolis|PA": "1508126",
"Ourém|PA": "1505403",
"Augusto Corrêa|PA": "1500909",
"Aurora do Pará|PA": "1500958",
"Aveiro|PA": "1501006",
"Bannach|PA": "1501253",
"Ponta de Pedras|PA": "1505700",
"São João da Ponta|PA": "1507466",
"Peixe-Boi|PA": "1505601",
"Nova Timboteua|PA": "1505007",
"Paragominas|PA": "1505502",
"Cândido Mendes|MA": "2102606",
"Cururupu|MA": "2103703",
"Soure|PA": "1507904",
"Macapá|AP": "1600303",
"Santarém Novo|PA": "1506906",
"Irituia|PA": "1503507",
"Santa Maria do Pará|PA": "1506609",
"Primavera|PA": "1506104",
"Capitão Poço|PA": "1502301",
"Santa Cruz do Arari|PA": "1506401",
"Ourilândia do Norte|PA": "1505437",
"Dom Eliseu|PA": "1502939",
"São Caetano de Odivelas|PA": "1507102",
"Balneário Camboriú|SC": "4202008",
"São Domingos do Capim|PA": "1507201",
"Viseu|PA": "1508308",
"São Miguel do Guamá|PA": "1507607",
"Jacareacanga|PA": "1503754",
"Inhangapi|PA": "1503408",
"Maceió|AL": "2704302",
"Novo Repartimento|PA": "1505064",
"Nova Ipixuna|PA": "1504976",
"Melgaço|PA": "1504505",
"Santa Luzia do Pará|PA": "1506559",
"São Francisco do Pará|PA": "1507409",
"Itupiranga|PA": "1503705",
"Nova Esperança do Piriá|PA": "1504950",
"São João de Pirabas|PA": "1507474",
"Jacundá|PA": "1503804",
"Cachoeira do Arari|PA": "1502004",
"Carutapera|MA": "2102903",
"Cachoeira do Piriá|PA": "1501956",
"Ipixuna do Pará|PA": "1503457",
"Limoeiro do Ajuru|PA": "1504000",
"Redenção|PA": "1506138",
"Santa Luzia do Paruá|MA": "2110039",
"Goianésia do Pará|PA": "1503093",
"Porto Grande|AP": "1600535",
"Quatipuru|PA": "1506112",
"Imperatriz|MA": "2105302",
"Canaã dos Carajás|PA": "1502152",
"Angico|TO": "1701051",
"Boa Vista do Gurupi|MA": "2101970",
"Xinguara|PA": "1508407",
"Apicum-Açu|MA": "2100832",
"Oiapoque|AP": "1600501",
"Aracaju|SE": "2800308",
"Piçarra|PA": "1505635",
"Uberlândia|MG": "3170206",
"Brejo Grande do Araguaia|PA": "1501758",
"São João do Araguaia|PA": "1507508",
"Eldorado do Carajás|PA": "1502954",
"Conceição do Araguaia|PA": "1502707",
"Rio Maria|PA": "1506161",
"Cumaru do Norte|PA": "1502764",
"Curionópolis|PA": "1502772",
"Floresta do Araguaia|PA": "1503044",
"Trairão|PA": "1508050",
"Placas|PA": "1505650",
"Peixoto de Azevedo|MT": "5106422",
"São Domingos do Araguaia|PA": "1507151",
"Açailândia|MA": "2100055",
"Palestina do Pará|PA": "1505494",
"Mojuí dos Campos|PA": "1504752",
"Igarassu|PE": "2606804",
"Buriti|MA": "2102200",
"Alto Santo|CE": "2300705",
"Cascavel|PR": "4104808",
"São Geraldo do Araguaia|PA": "1507458",
"Pau D'Arco|PA": "1505551",
"Santa Maria das Barreiras|PA": "1506583",
"Santana do Araguaia|PA": "1506708",
"Colinas do Tocantins|TO": "1705508",
"Feira de Santana|BA": "2910800",
"Maranhãozinho|MA": "2106375",
"Teresina|PI": "2211001",
"Serra do Navio|AP": "1600055",
"Pedra Branca do Amapari|AP": "1600154",
"Calçoene|AP": "1600204",
"Cutias|AP": "1600212",
"Ferreira Gomes|AP": "1600238",
"Itaubal|AP": "1600253",
"Vitória do Jari|AP": "1600808",
"Santana|AP": "1600600",
"Mazagão|AP": "1600402",
"Tartarugalzinho|AP": "1600709",
"Pracuúba|AP": "1600550",
"Campo Grande|MS": "5002704",
"Abreulândia|TO": "1700251",
"Aguiarnópolis|TO": "1700301",
"Crixás do Tocantins|TO": "1706258",
"Aliança do Tocantins|TO": "1700350",
"Almas|TO": "1700400",
"Alvorada|TO": "1700707",
"Ananás|TO": "1701002",
"Aparecida do Rio Negro|TO": "1701101",
"Aragominas|TO": "1701309",
"Araguacema|TO": "1701903",
"Araguaçu|TO": "1702000",
"Araguaína|TO": "1702109",
"Pequizeiro|TO": "1716653",
"Nova Olinda|TO": "1714880",
"Carolina|MA": "2102804",
"Governador Edison Lobão|MA": "2104552",
"Colméia|TO": "1716703",
"Axixá do Tocantins|TO": "1702901",
"Tocantinópolis|TO": "1721208",
"Goiatins|TO": "1709005",
"Filadélfia|TO": "1707702",
"Estreito|MA": "2104057",
"Araguanã|TO": "1702158",
"Sampaio|TO": "1718808",
"Wanderlândia|TO": "1722081",
"Xambioá|TO": "1722107",
"Campos Lindos|TO": "1703842",
"Araguatins|TO": "1702208",
"Sítio Novo do Tocantins|TO": "1720804",
"Augustinópolis|TO": "1702554",
"Piraquê|TO": "1717206",
"Palmeirante|TO": "1715705",
"Dianópolis|TO": "1707009",
"Barra do Ouro|TO": "1703073",
"Feira Nova do Maranhão|MA": "2104073",
"Porto Franco|MA": "2109007",
"Tabocão|TO": "1708254",
"Muricilândia|TO": "1713957",
"Carmolândia|TO": "1703883",
"Couto Magalhães|TO": "1706001",
"Itacajá|TO": "1710508",
"Riachinho|TO": "1718550",
"Balsas|MA": "2101400",
"Guaraí|TO": "1709302",
"Arapoema|TO": "1702307",
"Brasilândia do Tocantins|TO": "1703602",
"Juarina|TO": "1711803",
"Itaguatins|TO": "1710706",
"Santa Fé do Araguaia|TO": "1718865",
"Darcinópolis|TO": "1706506",
"Santa Terezinha do Tocantins|TO": "1720002",
"Babaçulândia|TO": "1703008",
"Bernardo Sayão|TO": "1703206",
"Presidente Kennedy|TO": "1718402",
"Paraíso do Tocantins|TO": "1716109",
"Pedro Afonso|TO": "1716505",
"Recursolândia|TO": "1718501",
"Esperantina|TO": "1707405",
"Pau D'Arco|TO": "1716307",
"São Bento do Tocantins|TO": "1720101",
"Ribeirão das Neves|MG": "3154606",
"Arraias|TO": "1702406",
"Combinado|TO": "1705557",
"Buriti do Tocantins|TO": "1703800",
"Praia Norte|TO": "1718303",
"Luzinópolis|TO": "1712454",
"Carrasco Bonito|TO": "1703891",
"São Sebastião do Tocantins|TO": "1720309",
"Palmeiras do Tocantins|TO": "1713809",
"Aurora do Tocantins|TO": "1702703",
"Bandeirantes do Tocantins|TO": "1703057",
"Barrolândia|TO": "1703107",
"Miracema do Tocantins|TO": "1713205",
"Bom Jesus do Tocantins|TO": "1703305",
"Brejinho de Nazaré|TO": "1703701",
"Cariri do Tocantins|TO": "1703867",
"Caseara|TO": "1703909",
"Chapada de Areia|TO": "1704600",
"Chapada da Natividade|TO": "1705102",
"Conceição do Tocantins|TO": "1705607",
"Cristalândia|TO": "1706100",
"Natividade|TO": "1714203",
"Rio da Conceição|TO": "1718659",
"Taipas do Tocantins|TO": "1720937",
"Porto Alegre do Tocantins|TO": "1718006",
"Divinópolis do Tocantins|TO": "1707108",
"Dois Irmãos do Tocantins|TO": "1707207",
"Dueré|TO": "1707306",
"Fátima|TO": "1707553",
"Figueirópolis|TO": "1707652",
"Formoso do Araguaia|TO": "1708205",
"Goianorte|TO": "1708304",
"Peixe|TO": "1716604",
"Sucupira|TO": "1720853",
"Barra do Garças|MT": "5101803",
"Anápolis|GO": "5201108",
"Lagoa da Confusão|TO": "1711902",
"Palmeirópolis|TO": "1715754",
"Itapiratins|TO": "1710904",
"Itaporã do Tocantins|TO": "1711100",
"Jaú do Tocantins|TO": "1711506",
"Lagoa do Tocantins|TO": "1711951",
"Lajeado|TO": "1712009",
"Lavandeira|TO": "1712157",
"Lizarda|TO": "1712405",
"Marianópolis do Tocantins|TO": "1712504",
"Maurilândia do Tocantins|TO": "1712801",
"Miranorte|TO": "1713304",
"Rio dos Bois|TO": "1718709",
"Monte do Carmo|TO": "1713601",
"Monte Santo do Tocantins|TO": "1713700",
"Nazaré|TO": "1714302",
"Nova Rosalândia|TO": "1715002",
"Novo Acordo|TO": "1715101",
"Novo Alegre|TO": "1715150",
"Novo Jardim|TO": "1715259",
"Oliveira de Fátima|TO": "1715507",
"Pugmil|TO": "1718451",
"Pium|TO": "1717503",
"Paranã|TO": "1716208",
"Pindorama do Tocantins|TO": "1717008",
"Ponte Alta do Bom Jesus|TO": "1717800",
"Ponte Alta do Tocantins|TO": "1717909",
"Porto Nacional|TO": "1718204",
"Ipueiras|TO": "1709807",
"Silvanópolis|TO": "1720655",
"Santa Rosa do Tocantins|TO": "1718907",
"Taguatinga|TO": "1720903",
"Sandolândia|TO": "1718840",
"Santa Maria do Tocantins|TO": "1718881",
"Santa Rita do Tocantins|TO": "1718899",
"Santa Tereza do Tocantins|TO": "1719004",
"São Félix do Tocantins|TO": "1720150",
"São Miguel do Tocantins|TO": "1720200",
"São Salvador do Tocantins|TO": "1720259",
"São Valério|TO": "1720499",
"Talismã|TO": "1720978",
"Tocantínia|TO": "1721109",
"Tupiratins|TO": "1721307",
"Mateiros|TO": "1712702",
"Cotegipe|BA": "2909406",
"Confresa|MT": "5103353",
"Centenário|TO": "1704105",
"Vila Rica|MT": "5108600",
"Palmas|PR": "4117602",
"Governador Archer|MA": "2104503",
"Tupirama|TO": "1721257",
"Bom Jesus das Selvas|MA": "2102036",
"São Francisco do Brejão|MA": "2110856",
"São Pedro da Água Branca|MA": "2111532",
"Itinga do Maranhão|MA": "2105427",
"Cidelândia|MA": "2103257",
"Afonso Cunha|MA": "2100105",
"Chapadinha|MA": "2103208",
"Água Doce do Maranhão|MA": "2100154",
"Alcântara|MA": "2100204",
"Aldeias Altas|MA": "2100303",
"Altamira do Maranhão|MA": "2100402",
"Alto Alegre do Maranhão|MA": "2100436",
"São Luís Gonzaga do Maranhão|MA": "2111409",
"Alto Alegre do Pindaré|MA": "2100477",
"Bom Jardim|MA": "2102002",
"Alto Parnaíba|MA": "2100501",
"Amapá do Maranhão|MA": "2100550",
"Amarante do Maranhão|MA": "2100600",
"Anajatuba|MA": "2100709",
"Anapurus|MA": "2100808",
"Mata Roma|MA": "2106409",
"Araguanã|MA": "2100873",
"Araioses|MA": "2100907",
"Arame|MA": "2100956",
"Buriticupu|MA": "2102325",
"Arari|MA": "2101004",
"Axixá|MA": "2101103",
"Morros|MA": "2107100",
"Bacabal|MA": "2101202",
"Conceição do Lago-Açu|MA": "2103554",
"Olho d'Água das Cunhãs|MA": "2107407",
"Vitorino Freire|MA": "2113009",
"São Bento|PB": "2513901",
"Cajari|MA": "2102507",
"Lago Verde|MA": "2105906",
"Peritoró|MA": "2108454",
"Lago da Pedra|MA": "2105708",
"Bom Lugar|MA": "2102077",
"Paulo Ramos|MA": "2108108",
"Lago do Junco|MA": "2105807",
"São Mateus do Maranhão|MA": "2111508",
"Lago dos Rodrigues|MA": "2105948",
"Jatobá|MA": "2105450",
"Brejo de Areia|MA": "2102150",
"Santa Rita|MA": "2110203",
"Bacabeira|MA": "2101251",
"São Benedito do Rio Preto|MA": "2110401",
"Rosário|MA": "2109601",
"Bacuri|MA": "2101301",
"Bacurituba|MA": "2101350",
"Cajapió|MA": "2102408",
"Sambaíba|MA": "2109700",
"Riachão|MA": "2109502",
"São Raimundo das Mangabeiras|MA": "2111607",
"Barão de Grajaú|MA": "2101509",
"Barra do Corda|MA": "2101608",
"Jenipapo dos Vieiras|MA": "2105476",
"Fernando Falcão|MA": "2104081",
"Tuntum|MA": "2112308",
"Fortaleza|CE": "2304400",
"Barreirinhas|MA": "2101707",
"Paulino Neves|MA": "2108058",
"Santo Amaro do Maranhão|MA": "2110278",
"Humberto de Campos|MA": "2105005",
"Santa Quitéria do Maranhão|MA": "2110104",
"Primeira Cruz|MA": "2109403",
"Tutóia|MA": "2112506",
"Belágua|MA": "2101731",
"Bela Vista do Maranhão|MA": "2101772",
"Benedito Leite|MA": "2101806",
"Bequimão|MA": "2101905",
"Brejo|MA": "2102101",
"Milagres do Maranhão|MA": "2106672",
"Buriti Bravo|MA": "2102309",
"Buritirana|MA": "2102358",
"Cachoeira Grande|MA": "2102374",
"Viana|MA": "2112803",
"Campestre do Maranhão|MA": "2102556",
"Cantanhede|MA": "2102705",
"Matões do Norte|MA": "2106631",
"Capinzal do Norte|MA": "2102754",
"Godofredo Viana|MA": "2104305",
"Luís Domingues|MA": "2106201",
"Turiaçu|MA": "2112407",
"Caxias|MA": "2103000",
"Matões|MA": "2106607",
"Codó|MA": "2103307",
"Duque Bacelar|MA": "2103901",
"São João do Soter|MA": "2111078",
"Coelho Neto|MA": "2103406",
"Parnarama|MA": "2107803",
"Governador Eugênio Barros|MA": "2104602",
"Pedreiras|MA": "2108207",
"Colinas|MA": "2103505",
"Senador Alexandre Costa|MA": "2111748",
"Timon|MA": "2112209",
"São Domingos do Maranhão|MA": "2110708",
"Fortuna|MA": "2104206",
"São Vicente Ferrer|MA": "2111706",
"Cedral|MA": "2103109",
"Central do Maranhão|MA": "2103125",
"Centro do Guilherme|MA": "2103158",
"Centro Novo do Maranhão|MA": "2103174",
"São Bernardo|MA": "2110609",
"Itapecuru Mirim|MA": "2105401",
"Mirador|MA": "2106706",
"Coroatá|MA": "2103604",
"Zé Doca|MA": "2114007",
"São João dos Patos|MA": "2111102",
"Serrano do Maranhão|MA": "2111789",
"Mirinzal|MA": "2106805",
"Davinópolis|MA": "2103752",
"Dom Pedro|MA": "2103802",
"São Raimundo do Doca Bezerra|MA": "2111631",
"Esperantinópolis|MA": "2104008",
"Formosa da Serra Negra|MA": "2104099",
"Fortaleza dos Nogueiras|MA": "2104107",
"Gonçalves Dias|MA": "2104404",
"Governador Luiz Rocha|MA": "2104628",
"Governador Newton Bello|MA": "2104651",
"Graça Aranha|MA": "2104701",
"Grajaú|MA": "2104800",
"Sítio Novo|MA": "2111805",
"Itaipava do Grajaú|MA": "2105351",
"Guimarães|MA": "2104909",
"Icatu|MA": "2105104",
"Igarapé do Meio|MA": "2105153",
"Igarapé Grande|MA": "2105203",
"Montes Altos|MA": "2107001",
"Vila Nova dos Martírios|MA": "2112852",
"Juazeiro do Norte|CE": "2307304",
"Senador La Rocque|MA": "2111763",
"João Lisboa|MA": "2105500",
"Vargem Grande|MA": "2112704",
"Joselândia|MA": "2105609",
"Junco do Maranhão|MA": "2105658",
"Marajá do Sena|MA": "2106359",
"Trizidela do Vale|MA": "2112233",
"Lagoa do Mato|MA": "2105922",
"Lagoa Grande do Maranhão|MA": "2105963",
"Lajeado Novo|MA": "2105989",
"Lima Campos|MA": "2106003",
"Loreto|MA": "2106102",
"Magalhães de Almeida|MA": "2106300",
"Maracaçumé|MA": "2106326",
"Turilândia|MA": "2112456",
"Matinha|MA": "2106508",
"Miranda do Norte|MA": "2106755",
"Pirapemas|MA": "2108801",
"Monção|MA": "2106904",
"Presidente Juscelino|MA": "2109205",
"Nina Rodrigues|MA": "2107209",
"Nova Colinas|MA": "2107258",
"Nova Iorque|MA": "2107308",
"Nova Olinda do Maranhão|MA": "2107357",
"Olinda Nova do Maranhão|MA": "2107456",
"Paço do Lumiar|MA": "2107506",
"São José de Ribamar|MA": "2111201",
"Penalva|MA": "2108306",
"Palmeirândia|MA": "2107605",
"Paraibano|MA": "2107704",
"Passagem Franca|MA": "2107902",
"Pastos Bons|MA": "2108009",
"São Roberto|MA": "2111672",
"Poção de Pedras|MA": "2108900",
"Pedro do Rosário|MA": "2108256",
"Pindaré-Mirim|MA": "2108504",
"Peri Mirim|MA": "2108405",
"Pinheiro|MA": "2108603",
"Santa Helena|MA": "2109809",
"São Bento|MA": "2110500",
"São João Batista|MA": "2111003",
"Pio XII|MA": "2108702",
"Porto Rico do Maranhão|MA": "2109056",
"Presidente Dutra|MA": "2109106",
"Presidente Médici|MA": "2109239",
"Presidente Vargas|MA": "2109304",
"Raposa|MA": "2109452",
"Ribamar Fiquene|MA": "2109551",
"Santa Filomena do Maranhão|MA": "2109759",
"Tufilândia|MA": "2112274",
"Satubinha|MA": "2111722",
"São João do Carú|MA": "2111029",
"Santana do Maranhão|MA": "2110237",
"Santo Antônio dos Lopes|MA": "2110302",
"São Domingos do Azeitão|MA": "2110658",
"São Félix de Balsas|MA": "2110807",
"São Francisco do Maranhão|MA": "2110906",
"São João do Paraíso|MA": "2111052",
"Vitória do Mearim|MA": "2112902",
"São José dos Basílios|MA": "2111250",
"Urbano Santos|MA": "2112605",
"Tasso Fragoso|MA": "2112001",
"Timbiras|MA": "2112100",
"Sucupira do Norte|MA": "2111904",
"Curitiba|PR": "4106902",
"Taboão da Serra|SP": "3552809",
"São Pedro dos Crentes|MA": "2111573",
"Sucupira do Riachão|MA": "2111953",
"Tianguá|CE": "2313401",
"Simplício Mendes|PI": "2210805",
"Acauã|PI": "2200053",
"Agricolândia|PI": "2200103",
"Água Branca|PI": "2200202",
"Alagoinha do Piauí|PI": "2200251",
"Alegrete do Piauí|PI": "2200277",
"Alto Longá|PI": "2200301",
"Altos|PI": "2200400",
"Orocó|PE": "2609808",
"Coivaras|PI": "2202737",
"Alvorada do Gurguéia|PI": "2200459",
"Amarante|PI": "2200509",
"Angical do Piauí|PI": "2200608",
"Anísio de Abreu|PI": "2200707",
"Antônio Almeida|PI": "2200806",
"Aroazes|PI": "2200905",
"Aroeiras do Itaim|PI": "2200954",
"Arraial|PI": "2201002",
"Assunção do Piauí|PI": "2201051",
"Avelino Lopes|PI": "2201101",
"Baixa Grande do Ribeiro|PI": "2201150",
"Uruçuí|PI": "2211209",
"Barra D'Alcântara|PI": "2201176",
"Barras|PI": "2201200",
"Nossa Senhora dos Remédios|PI": "2206803",
"Cabeceiras do Piauí|PI": "2202059",
"Porto|PI": "2208502",
"Barreiras do Piauí|PI": "2201309",
"Barro Duro|PI": "2201408",
"Batalha|PI": "2201507",
"Bela Vista do Piauí|PI": "2201556",
"Belém do Piauí|PI": "2201572",
"Beneditinos|PI": "2201606",
"Bertolínia|PI": "2201705",
"Betânia do Piauí|PI": "2201739",
"Boa Hora|PI": "2201770",
"Bocaina|PI": "2201804",
"Cristino Castro|PI": "2203107",
"Bom Jesus|PI": "2201903",
"Redenção do Gurguéia|PI": "2208700",
"Palmeira do Piauí|PI": "2207405",
"Santa Luz|PI": "2209302",
"Gilbués|PI": "2204402",
"Monte Alegre do Piauí|PI": "2206605",
"Corrente|PI": "2202901",
"Cristalândia do Piauí|PI": "2203008",
"São Gonçalo do Piauí|PI": "2209807",
"Bom Princípio do Piauí|PI": "2201919",
"Bonfim do Piauí|PI": "2201929",
"Boqueirão do Piauí|PI": "2201945",
"Brasileira|PI": "2201960",
"Brejo do Piauí|PI": "2201988",
"Buriti dos Lopes|PI": "2202000",
"Buriti dos Montes|PI": "2202026",
"Cajazeiras do Piauí|PI": "2202075",
"Cajueiro da Praia|PI": "2202083",
"Caldeirão Grande do Piauí|PI": "2202091",
"Campinas do Piauí|PI": "2202109",
"Campo Alegre do Fidalgo|PI": "2202117",
"Campo Grande do Piauí|PI": "2202133",
"Campo Largo do Piauí|PI": "2202174",
"Campo Maior|PI": "2202208",
"Sigefredo Pacheco|PI": "2210656",
"Juazeiro do Piauí|PI": "2205516",
"União|PI": "2211100",
"Castelo do Piauí|PI": "2202604",
"Canavieira|PI": "2202251",
"Canto do Buriti|PI": "2202307",
"Capitão de Campos|PI": "2202406",
"Capitão Gervásio Oliveira|PI": "2202455",
"Jurema|PI": "2205532",
"Caracol|PI": "2202505",
"Caraúbas do Piauí|PI": "2202539",
"Caridade do Piauí|PI": "2202554",
"Caxingó|PI": "2202653",
"Parnaíba|PI": "2207702",
"Cocal|PI": "2202703",
"Cocal de Telha|PI": "2202711",
"Cocal dos Alves|PI": "2202729",
"Piracuruca|PI": "2208304",
"Colônia do Gurguéia|PI": "2202752",
"Colônia do Piauí|PI": "2202778",
"Conceição do Canindé|PI": "2202802",
"Coronel José Dias|PI": "2202851",
"Curimatá|PI": "2203206",
"Currais|PI": "2203230",
"Curralinhos|PI": "2203255",
"Curral Novo do Piauí|PI": "2203271",
"Demerval Lobão|PI": "2203305",
"Dirceu Arcoverde|PI": "2203354",
"Dom Expedito Lopes|PI": "2203404",
"Domingos Mourão|PI": "2203420",
"Dom Inocêncio|PI": "2203453",
"Elesbão Veloso|PI": "2203503",
"Eliseu Martins|PI": "2203602",
"Esperantina|PI": "2203701",
"Matias Olímpio|PI": "2206100",
"Luzilândia|PI": "2205805",
"Joaquim Pires|PI": "2205409",
"São João do Arraial|PI": "2209971",
"Fartura do Piauí|PI": "2203750",
"Flores do Piauí|PI": "2203800",
"Floresta do Piauí|PI": "2203859",
"Francisco Ayres|PI": "2204105",
"São Francisco do Piauí|PI": "2209708",
"Guadalupe|PI": "2204501",
"Floriano|PI": "2203909",
"Porto Alegre do Piauí|PI": "2208551",
"Itaueira|PI": "2205102",
"Rio Grande do Piauí|PI": "2209005",
"Nazaré do Piauí|PI": "2206704",
"Jerumenha|PI": "2205300",
"Manoel Emídio|PI": "2205904",
"São João do Piauí|PI": "2210003",
"Landri Sales|PI": "2205607",
"São Raimundo Nonato|PI": "2210607",
"Francinópolis|PI": "2204006",
"Francisco Macedo|PI": "2204154",
"Francisco Santos|PI": "2204204",
"Fronteiras|PI": "2204303",
"Geminiano|PI": "2204352",
"Guaribas|PI": "2204550",
"Hugo Napoleão|PI": "2204600",
"Ilha Grande|PI": "2204659",
"Inhuma|PI": "2204709",
"Ipiranga do Piauí|PI": "2204808",
"Isaías Coelho|PI": "2204907",
"Itainópolis|PI": "2205003",
"Caicó|RN": "2402006",
"Jacobina do Piauí|PI": "2205151",
"Jaicós|PI": "2205201",
"Jardim do Mulato|PI": "2205250",
"Jatobá do Piauí|PI": "2205276",
"João Costa|PI": "2205359",
"Murici dos Portelas|PI": "2206696",
"Joca Marques|PI": "2205458",
"José de Freitas|PI": "2205508",
"Júlio Borges|PI": "2205524",
"Lagoinha do Piauí|PI": "2205540",
"Lagoa Alegre|PI": "2205557",
"Lagoa de São Francisco|PI": "2205573",
"Lagoa do Piauí|PI": "2205581",
"Lagoa do Sítio|PI": "2205599",
"Luís Correia|PI": "2205706",
"Madeiro|PI": "2205854",
"Marcolândia|PI": "2205953",
"Araripina|PE": "2601102",
"Marcos Parente|PI": "2206001",
"Massapê do Piauí|PI": "2206050",
"Miguel Alves|PI": "2206209",
"Milton Brandão|PI": "2206357",
"Monsenhor Gil|PI": "2206407",
"Monsenhor Hipólito|PI": "2206506",
"Morro Cabeça no Tempo|PI": "2206654",
"Morro do Chapéu do Piauí|PI": "2206670",
"Nazária|PI": "2206720",
"Nossa Senhora de Nazaré|PI": "2206753",
"Novo Oriente do Piauí|PI": "2206902",
"Novo Santo Antônio|PI": "2206951",
"Oeiras|PI": "2207009",
"Santa Rosa do Piauí|PI": "2209377",
"São Miguel do Fidalgo|PI": "2210391",
"São João da Varjota|PI": "2209955",
"Olho D'Água do Piauí|PI": "2207108",
"Padre Marcos|PI": "2207207",
"Paes Landim|PI": "2207306",
"Pajeú do Piauí|PI": "2207355",
"Palmeirais|PI": "2207504",
"Paquetá|PI": "2207553",
"Parnaguá|PI": "2207603",
"Granja|CE": "2304707",
"Viçosa do Ceará|CE": "2314102",
"Passagem Franca do Piauí|PI": "2207751",
"Patos do Piauí|PI": "2207777",
"Pau D'Arco do Piauí|PI": "2207793",
"Paulistana|PI": "2207801",
"Pavussu|PI": "2207850",
"Pedro II|PI": "2207900",
"Pedro Laurentino|PI": "2207934",
"Nova Santa Rita|PI": "2207959",
"Simões|PI": "2210706",
"São José do Piauí|PI": "2210201",
"São Julião|PI": "2210300",
"São João da Canabrava|PI": "2209856",
"Wall Ferraz|PI": "2211704",
"Pimenteiras|PI": "2208106",
"Pio IX|PI": "2208205",
"Piripiri|PI": "2208403",
"São José do Divino|PI": "2210052",
"São João da Fronteira|PI": "2209872",
"Prata do Piauí|PI": "2208601",
"Queimada Nova|PI": "2208650",
"Regeneração|PI": "2208809",
"Riacho Frio|PI": "2208858",
"Ribeira do Piauí|PI": "2208874",
"Ribeiro Gonçalves|PI": "2208908",
"Santa Cruz do Piauí|PI": "2209104",
"Santa Cruz dos Milagres|PI": "2209153",
"Santa Filomena|PI": "2209203",
"Santana do Piauí|PI": "2209351",
"Santo Antônio de Lisboa|PI": "2209401",
"Santo Antônio dos Milagres|PI": "2209450",
"Santo Inácio do Piauí|PI": "2209500",
"São Braz do Piauí|PI": "2209559",
"São Félix do Piauí|PI": "2209609",
"São Francisco de Assis do Piauí|PI": "2209658",
"São Gonçalo do Gurguéia|PI": "2209757",
"São João da Serra|PI": "2209906",
"São José do Peixe|PI": "2210102",
"São Lourenço do Piauí|PI": "2210359",
"São Luis do Piauí|PI": "2210375",
"São Miguel da Baixa Grande|PI": "2210383",
"São Miguel do Tapuio|PI": "2210409",
"São Pedro do Piauí|PI": "2210508",
"Várzea Branca|PI": "2211357",
"Sebastião Leal|PI": "2210631",
"Socorro do Piauí|PI": "2210904",
"Sussuapara|PI": "2210938",
"Tamboril do Piauí|PI": "2210953",
"Tanque do Piauí|PI": "2210979",
"Salvador|BA": "2927408",
"Piracicaba|SP": "3538709",
"Novo Oriente|CE": "2309409",
"Valença do Piauí|PI": "2211308",
"Senador Canedo|GO": "5220454",
"Várzea Grande|PI": "2211407",
"São João de Meriti|RJ": "3305109",
"Lagoa do Barro do Piauí|PI": "2205565",
"Sebastião Barros|PI": "2210623",
"Sobral|CE": "2312908",
"Vila Nova do Piauí|PI": "2211605",
"Selvíria|MS": "5007802",
"Sento Sé|BA": "2930204",
"Jaboatão dos Guararapes|PE": "2607901",
"Senhor do Bonfim|BA": "2930105",
"Parnamirim|RN": "2403251",
"Vera Mendes|PI": "2211506",
"Praia Grande|SP": "3541000",
"Corumbá|MS": "5003207",
"Petrolina|PE": "2611101",
"Campo Novo do Parecis|MT": "5102637",
"Duque de Caxias|RJ": "3301702",
"Caucaia|CE": "2303709",
"Matupá|MT": "5105606",
"Sobradinho|BA": "2930774",
"Luís Eduardo Magalhães|BA": "2919553",
"Crateús|CE": "2304103",
"Campo Alegre de Lourdes|BA": "2905909",
"Quirinópolis|GO": "5218508",
"Abaiara|CE": "2300101",
"Acarape|CE": "2300150",
"Acaraú|CE": "2300200",
"Acopiara|CE": "2300309",
"Aiuaba|CE": "2300408",
"Alcântaras|CE": "2300507",
"Altaneira|CE": "2300606",
"Amontada|CE": "2300754",
"Antonina do Norte|CE": "2300804",
"Apuiarés|CE": "2300903",
"Aracati|CE": "2301109",
"Aracoiaba|CE": "2301208",
"Cascavel|CE": "2303501",
"Guaramiranga|CE": "2305100",
"Ararendá|CE": "2301257",
"Araripe|CE": "2301307",
"Aratuba|CE": "2301406",
"Canindé|CE": "2302800",
"Arneiroz|CE": "2301505",
"Assaré|CE": "2301604",
"Aurora|CE": "2301703",
"Umari|CE": "2313708",
"Baixio|CE": "2301802",
"Banabuiú|CE": "2301851",
"Barbalha|CE": "2301901",
"Jardim|CE": "2307106",
"Trindade|PE": "2615607",
"Missão Velha|CE": "2308401",
"Crato|CE": "2304202",
"Moreilândia|PE": "2614303",
"Várzea Alegre|CE": "2314003",
"Santana de Mangueira|PB": "2513505",
"Barro|CE": "2302008",
"Cariús|CE": "2303303",
"Iguatu|CE": "2305506",
"Cedro|CE": "2303808",
"Solonópole|CE": "2313005",
"Farias Brito|CE": "2304301",
"Mauriti|CE": "2308104",
"Barreira|CE": "2301950",
"Barroquinha|CE": "2302057",
"Baturité|CE": "2302107",
"Itapiúna|CE": "2306504",
"Beberibe|CE": "2302206",
"Quixadá|CE": "2311306",
"Bela Cruz|CE": "2302305",
"Boa Viagem|CE": "2302404",
"Brejo Santo|CE": "2302503",
"Camocim|CE": "2302602",
"Campos Sales|CE": "2302701",
"Itatira|CE": "2306603",
"Caridade|CE": "2303006",
"Capistrano|CE": "2302909",
"Cariré|CE": "2303105",
"Caririaçu|CE": "2303204",
"Carnaubal|CE": "2303402",
"Pacajus|CE": "2309607",
"Catarina|CE": "2303600",
"Catunda|CE": "2303659",
"Massapê|CE": "2308005",
"Umirim|CE": "2313757",
"Santa Quitéria|CE": "2312205",
"Maracanaú|CE": "2307650",
"Maranguape|CE": "2307700",
"São Gonçalo do Amarante|CE": "2312403",
"Hidrolândia|CE": "2305209",
"Senador Pompeu|CE": "2312700",
"Tejuçuoca|CE": "2313351",
"Itaiçaba|CE": "2306207",
"Pentecoste|CE": "2310704",
"São Luís do Curu|CE": "2312601",
"Chaval|CE": "2303907",
"Choró|CE": "2303931",
"Chorozinho|CE": "2303956",
"Coreaú|CE": "2304004",
"Nova Olinda|CE": "2309201",
"Tarrafas|CE": "2313252",
"Croatá|CE": "2304236",
"Cruz|CE": "2304251",
"Deputado Irapuan Pinheiro|CE": "2304269",
"Ereré|CE": "2304277",
"Eusébio|CE": "2304285",
"Itaitinga|CE": "2306256",
"Forquilha|CE": "2304350",
"Mulungu|CE": "2309102",
"Morada Nova|CE": "2308708",
"Itapipoca|CE": "2306405",
"Horizonte|CE": "2305233",
"Ubajara|CE": "2313609",
"Irauçuba|CE": "2306108",
"Guaiúba|CE": "2304954",
"Russas|CE": "2311801",
"Icó|CE": "2305407",
"Limoeiro do Norte|CE": "2307601",
"Paraipaba|CE": "2310258",
"Uruburetama|CE": "2313807",
"Trairi|CE": "2313500",
"Paracuru|CE": "2310209",
"Itapajé|CE": "2306306",
"Tauá|CE": "2313302",
"Saboeiro|CE": "2311900",
"Ibiapina|CE": "2305308",
"Mombaça|CE": "2308500",
"Milhã|CE": "2308351",
"Jaguaribe|CE": "2306900",
"Palhano|CE": "2310001",
"Pedra Branca|CE": "2310506",
"Redenção|CE": "2311603",
"Pacatuba|CE": "2309706",
"Quixeramobim|CE": "2311405",
"Quiterianópolis|CE": "2311264",
"Orós|CE": "2309508",
"General Sampaio|CE": "2304608",
"Jaguaretama|CE": "2306702",
"Piquet Carneiro|CE": "2310902",
"Miraíma|CE": "2308377",
"Tabuleiro do Norte|CE": "2313104",
"Jaguaruana|CE": "2307007",
"Lavras da Mangabeira|CE": "2307502",
"Lages|SC": "4209300",
"Ibaretama|CE": "2305266",
"Ocara|CE": "2309458",
"Santana do Acaraú|CE": "2312007",
"Tururu|CE": "2313559",
"Ipueiras|CE": "2305902",
"Ibicuitinga|CE": "2305332",
"Paramoti|CE": "2310407",
"Pindoretama|CE": "2310852",
"Natal|RN": "2408102",
"Guaraciaba do Norte|CE": "2305001",
"São João do Jaguaribe|CE": "2312502",
"Quixeré|CE": "2311504",
"Mossoró|RN": "2408003",
"Madalena|CE": "2307635",
"Palmácia|CE": "2310100",
"Independência|CE": "2305605",
"Pacoti|CE": "2309805",
"Icapuí|CE": "2305357",
"Monsenhor Tabosa|CE": "2308609",
"Parambu|CE": "2310308",
"Graça|CE": "2304657",
"Ipaporanga|CE": "2305654",
"Jaguaribara|CE": "2306801",
"Mucambo|CE": "2309003",
"Marco|CE": "2307809",
"Tamboril|CE": "2313203",
"Nova Russas|CE": "2309300",
"Pereiro|CE": "2310803",
"Fortim|CE": "2304459",
"Nova Cruz|RN": "2408300",
"São Benedito|CE": "2312304",
"Jucás|CE": "2307403",
"Ipaumirim|CE": "2305704",
"Pires Ferreira|CE": "2310951",
"Varjota|CE": "2313955",
"Jijoca de Jericoacoara|CE": "2307254",
"Meruoca|CE": "2308203",
"Itarema|CE": "2306553",
"Poranga|CE": "2311009",
"Granjeiro|CE": "2304806",
"Groaíras|CE": "2304905",
"Itanhaém|SP": "3522109",
"Ipu|CE": "2305803",
"Iracema|CE": "2306009",
"Jati|CE": "2307205",
"Brejo do Cruz|PB": "2502805",
"Milagres|CE": "2308302",
"Salitre|CE": "2311959",
"Exu|PE": "2605301",
"Porteiras|CE": "2311108",
"Quixelô|CE": "2311355",
"Potengi|CE": "2311207",
"Perdigão|MG": "3149705",
"Paraguaçu|MG": "3147204",
"Martinópole|CE": "2307908",
"Moraújo|CE": "2308807",
"Morrinhos|CE": "2308906",
"Pacujá|CE": "2309904",
"Penaforte|CE": "2310605",
"Doutor Severiano|RN": "2403202",
"Potiretama|CE": "2311231",
"Reriutaba|CE": "2311702",
"Santana do Cariri|CE": "2312106",
"Senador Sá|CE": "2312809",
"Uruoca|CE": "2313906",
"Acari|RN": "2400109",
"Assú|RN": "2400208",
"Ipanguaçu|RN": "2404705",
"Alto do Rodrigues|RN": "2400703",
"Pendências|RN": "2409902",
"Afonso Bezerra|RN": "2400307",
"Água Nova|RN": "2400406",
"Alexandria|RN": "2400505",
"Almino Afonso|RN": "2400604",
"Angicos|RN": "2400802",
"Antônio Martins|RN": "2400901",
"Apodi|RN": "2401008",
"Areia Branca|RN": "2401107",
"Esperança|PB": "2506004",
"Arez|RN": "2401206",
"Campo Grande|RN": "2401305",
"Baía Formosa|RN": "2401404",
"Baraúna|RN": "2401453",
"Barcelona|RN": "2401503",
"Bento Fernandes|RN": "2401602",
"Bodó|RN": "2401651",
"Bom Jesus|RN": "2401701",
"Brejinho|RN": "2401800",
"Caiçara do Norte|RN": "2401859",
"Caiçara do Rio do Vento|RN": "2401909",
"Belém do Brejo do Cruz|PB": "2502003",
"Jucurutu|RN": "2406106",
"Cruzeta|RN": "2403004",
"Jardim de Piranhas|RN": "2405603",
"Parelhas|RN": "2408904",
"Campo Redondo|RN": "2402105",
"Serra Negra do Norte|RN": "2413409",
"São José do Seridó|RN": "2412401",
"Santana do Matos|RN": "2411403",
"Timbaúba dos Batistas|RN": "2414308",
"Canguaretama|RN": "2402204",
"Caraúbas|RN": "2402303",
"Carnaúba dos Dantas|RN": "2402402",
"Carnaubais|RN": "2402501",
"Ceará-Mirim|RN": "2402600",
"Ielmo Marinho|RN": "2404606",
"Macau|RN": "2407203",
"João Câmara|RN": "2405801",
"Pombal|PB": "2512101",
"Nísia Floresta|RN": "2408201",
"Tibau do Sul|RN": "2414209",
"Pedro Velho|RN": "2409803",
"Cerro Corá|RN": "2402709",
"Coronel Ezequiel|RN": "2402808",
"Coronel João Pessoa|RN": "2402907",
"Currais Novos|RN": "2403103",
"São Vicente|RN": "2413003",
"Lagoa Nova|RN": "2406502",
"Santa Cruz|RN": "2411205",
"Lagoa de Velhos|RN": "2406403",
"Várzea|RN": "2414704",
"São José de Mipibu|RN": "2412203",
"Passa e Fica|RN": "2409100",
"Macaíba|RN": "2407104",
"São José do Campestre|RN": "2412302",
"Goianinha|RN": "2404200",
"São Gonçalo do Amarante|RN": "2412005",
"Lagoa d'Anta|RN": "2406205",
"Extremoz|RN": "2403608",
"Senador Georgino Avelino|RN": "2413201",
"Encanto|RN": "2403301",
"Equador|RN": "2403400",
"Espírito Santo|RN": "2403509",
"Felipe Guerra|RN": "2403707",
"Fernando Pedroza|RN": "2403756",
"Florânia|RN": "2403806",
"Francisco Dantas|RN": "2403905",
"Frutuoso Gomes|RN": "2404002",
"Galinhos|RN": "2404101",
"Governador Dix-Sept Rosado|RN": "2404309",
"Grossos|RN": "2404408",
"Guamaré|RN": "2404507",
"Ipueira|RN": "2404804",
"Itajá|RN": "2404853",
"Itaú|RN": "2404903",
"Jaçanã|RN": "2405009",
"Jandaíra|RN": "2405108",
"Janduís|RN": "2405207",
"Januário Cicco|RN": "2405306",
"Japi|RN": "2405405",
"Jardim de Angicos|RN": "2405504",
"Jardim do Seridó|RN": "2405702",
"Touros|RN": "2414407",
"João Dias|RN": "2405900",
"José da Penha|RN": "2406007",
"Triunfo Potiguar|RN": "2414456",
"Jundiá|RN": "2406155",
"Lagoa de Pedras|RN": "2406304",
"Lagoa Salgada|RN": "2406601",
"Lajes|RN": "2406700",
"Lajes Pintadas|RN": "2406809",
"Lucrécia|RN": "2406908",
"Luís Gomes|RN": "2407005",
"Porto do Mangue|RN": "2410256",
"Major Sales|RN": "2407252",
"Marcelino Vieira|RN": "2407302",
"Martins|RN": "2407401",
"Maxaranguape|RN": "2407500",
"Messias Targino|RN": "2407609",
"Montanhas|RN": "2407708",
"Monte Alegre|RN": "2407807",
"Monte das Gameleiras|RN": "2407906",
"Taboleiro Grande|RN": "2413805",
"Umarizal|RN": "2414506",
"Pau dos Ferros|RN": "2409407",
"Serrinha dos Pintos|RN": "2413557",
"Tenente Ananias|RN": "2414100",
"Tibau|RN": "2411056",
"Upanema|RN": "2414605",
"Patu|RN": "2409308",
"Serra do Mel|RN": "2413359",
"São Miguel|RN": "2412500",
"Portalegre|RN": "2410207",
"São Rafael|RN": "2412807",
"Rodolfo Fernandes|RN": "2411007",
"Severiano Melo|RN": "2413607",
"Paraú|RN": "2408706",
"Venha-Ver|RN": "2414753",
"Vera Cruz|RN": "2414803",
"Pureza|RN": "2410405",
"Serra Caiada|RN": "2410306",
"Pedra Grande|RN": "2409506",
"Serra de São Bento|RN": "2413300",
"Taipu|RN": "2413904",
"Santo Antônio|RN": "2411502",
"Vila Flor|RN": "2415008",
"São Bento do Norte|RN": "2411601",
"Poço Branco|RN": "2410108",
"Rio do Fogo|RN": "2408953",
"Paraná|RN": "2408607",
"São Bento do Trairí|RN": "2411700",
"São Miguel do Gostoso|RN": "2412559",
"Santana do Seridó|RN": "2411429",
"São Paulo do Potengi|RN": "2412609",
"Pedro Avelino|RN": "2409704",
"Serrinha|RN": "2413508",
"Olho d'Água do Borges|RN": "2408409",
"Pedra Preta|RN": "2409605",
"Tenente Laurentino Cruz|RN": "2414159",
"Riachuelo|RN": "2410900",
"Sítio Novo|RN": "2413706",
"Senador Elói de Souza|RN": "2413102",
"Belo Horizonte|MG": "3106200",
"Santa Maria|RN": "2409332",
"Tangará|RN": "2414001",
"São Tomé|RN": "2412906",
"Parazinho|RN": "2408805",
"Rafael Fernandes|RN": "2410504",
"São Fernando|RN": "2411809",
"Guarabira|PB": "2506301",
"São Pedro|RN": "2412708",
"Junco do Seridó|PB": "2507804",
"Ruy Barbosa|RN": "2411106",
"Passagem|RN": "2409209",
"Cabedelo|PB": "2503209",
"Ouro Branco|RN": "2408508",
"Pilões|RN": "2410009",
"Rafael Godeiro|RN": "2410603",
"Riacho da Cruz|RN": "2410702",
"Riacho de Santana|RN": "2410801",
"São Francisco do Oeste|RN": "2411908",
"São João do Sabugi|RN": "2412104",
"Viçosa|RN": "2414902",
"Água Branca|PB": "2500106",
"Aguiar|PB": "2500205",
"Alagoa Grande|PB": "2500304",
"Alagoa Nova|PB": "2500403",
"Alagoinha|PB": "2500502",
"Alcantil|PB": "2500536",
"Algodão de Jandaíra|PB": "2500577",
"Alhandra|PB": "2500601",
"Caaporã|PB": "2503001",
"São João do Rio do Peixe|PB": "2500700",
"Aparecida|PB": "2500775",
"Araçagi|PB": "2500809",
"Arara|PB": "2500908",
"Araruna|PB": "2501005",
"Areia|PB": "2501104",
"Areia de Baraúnas|PB": "2501153",
"Areial|PB": "2501203",
"Aroeiras|PB": "2501302",
"Gado Bravo|PB": "2506251",
"Assunção|PB": "2501351",
"Baía da Traição|PB": "2501401",
"Bananeiras|PB": "2501500",
"Baraúna|PB": "2501534",
"Barra de Santana|PB": "2501575",
"Barra de Santa Rosa|PB": "2501609",
"Barra de São Miguel|PB": "2501708",
"Bayeux|PB": "2501807",
"Santa Rita|PB": "2513703",
"Belém|PB": "2501906",
"Bernardino Batista|PB": "2502052",
"Boa Ventura|PB": "2502102",
"Boa Vista|PB": "2502151",
"Bom Jesus|PB": "2502201",
"Bom Sucesso|PB": "2502300",
"Bonito de Santa Fé|PB": "2502409",
"Boqueirão|PB": "2502508",
"Igaracy|PB": "2502607",
"Borborema|PB": "2502706",
"Brejo dos Santos|PB": "2502904",
"Cabaceiras|PB": "2503100",
"João Pessoa|PB": "2507507",
"Cachoeira dos Índios|PB": "2503308",
"Cacimba de Areia|PB": "2503407",
"Cacimba de Dentro|PB": "2503506",
"Cacimbas|PB": "2503555",
"Caiçara|PB": "2503605",
"Cajazeiras|PB": "2503704",
"Triunfo|PB": "2516805",
"São José de Piranhas|PB": "2514503",
"Poço de José de Moura|PB": "2512077",
"Joca Claudino|PB": "2513653",
"Uiraúna|PB": "2516904",
"Monte Horebe|PB": "2509602",
"Serra Grande|PB": "2515708",
"Cajazeirinhas|PB": "2503753",
"Caldas Brandão|PB": "2503803",
"Camalaú|PB": "2503902",
"Campina Grande|PB": "2504009",
"Queimadas|PB": "2512507",
"Prata|PB": "2512200",
"Fagundes|PB": "2506103",
"São Sebastião de Lagoa de Roça|PB": "2515104",
"Lagoa Seca|PB": "2508307",
"Matinhas|PB": "2509339",
"Puxinanã|PB": "2512408",
"Remígio|PB": "2512705",
"Patos|PB": "2510808",
"Riachão do Bacamarte|PB": "2512754",
"Caturité|PB": "2504355",
"Taperoá|PB": "2516508",
"Solânea|PB": "2516003",
"Montadas|PB": "2509503",
"Juarez Távora|PB": "2507606",
"Serra Redonda|PB": "2515807",
"Monteiro|PB": "2509701",
"Itaporanga|PB": "2507002",
"Coremas|PB": "2504801",
"Picuí|PB": "2511400",
"Massaranduba|PB": "2509206",
"Congo|PB": "2504702",
"Mogeiro|PB": "2509404",
"Ingá|PB": "2506806",
"São Vicente do Seridó|PB": "2515401",
"Cuité|PB": "2505105",
"Soledade|PB": "2516102",
"Pocinhos|PB": "2512002",
"Itatuba|PB": "2507200",
"Princesa Isabel|PB": "2512309",
"Santa Cruz do Capibaribe|PE": "2612505",
"Caraúbas|PB": "2504074",
"Livramento|PB": "2508505",
"Serra Branca|PB": "2515500",
"Sumé|PB": "2516300",
"Pilões|PB": "2511608",
"Pedra Lavrada|PB": "2511103",
"Catolé do Rocha|PB": "2504306",
"Lastro|PB": "2508406",
"Santa Cecília|PB": "2513158",
"Umbuzeiro|PB": "2517001",
"Juru|PB": "2508000",
"Nova Floresta|PB": "2510105",
"Santa Luzia|PB": "2513406",
"Cubati|PB": "2505006",
"Tenório|PB": "2516755",
"Parari|PB": "2510659",
"Juazeirinho|PB": "2507705",
"Lagoa de Dentro|PB": "2508208",
"Capim|PB": "2504033",
"Carrapateira|PB": "2504108",
"Casserengue|PB": "2504157",
"Catingueira|PB": "2504207",
"Lagoa|PB": "2508109",
"Riacho dos Cavalos|PB": "2512804",
"Mato Grosso|PB": "2509370",
"Jericó|PB": "2507408",
"Conceição|PB": "2504405",
"Santa Inês|PB": "2513356",
"Condado|PB": "2504504",
"Conde|PB": "2504603",
"Coxixola|PB": "2504850",
"Cruz do Espírito Santo|PB": "2504900",
"Cuitegi|PB": "2505204",
"Cuité de Mamanguape|PB": "2505238",
"Curral de Cima|PB": "2505279",
"Curral Velho|PB": "2505303",
"Damião|PB": "2505352",
"Desterro|PB": "2505402",
"Vista Serrana|PB": "2505501",
"Diamante|PB": "2505600",
"Dona Inês|PB": "2505709",
"Duas Estradas|PB": "2505808",
"Emas|PB": "2505907",
"Frei Martinho|PB": "2506202",
"Pilõezinhos|PB": "2511707",
"Tacima|PB": "2516409",
"Pirpirituba|PB": "2511806",
"Sertãozinho|PB": "2515930",
"Mulungu|PB": "2509800",
"Serraria|PB": "2515906",
"Mari|PB": "2509107",
"Serra da Raiz|PB": "2515609",
"Mamanguape|PB": "2508901",
"Gurinhém|PB": "2506400",
"Gurjão|PB": "2506509",
"Ibiara|PB": "2506608",
"Imaculada|PB": "2506707",
"Itabaiana|PB": "2506905",
"Itapororoca|PB": "2507101",
"Jacaraú|PB": "2507309",
"Sousa|PB": "2516201",
"Rio Tinto|PB": "2512903",
"Pitimbu|PB": "2511905",
"Tavares|PB": "2516607",
"Sobrado|PB": "2515971",
"Pilar|PB": "2511509",
"Sapé|PB": "2515302",
"Lucena|PB": "2508604",
"Itambé|PE": "2607653",
"Goiana|PE": "2606200",
"Marcação|PB": "2509057",
"Pedro Régis|PB": "2512721",
"Salgado de São Félix|PB": "2513109",
"Riachão do Poço|PB": "2512762",
"Logradouro|PB": "2508554",
"Piancó|PB": "2511301",
"Campinas|SP": "3509502",
"Olho d'Água|PB": "2510402",
"Paulista|PE": "2610707",
"São Miguel de Taipu|PB": "2515005",
"Santana dos Garrotes|PB": "2513604",
"Mataraca|PB": "2509305",
"São Mamede|PB": "2514909",
"São José dos Ramos|PB": "2514453",
"Pedras de Fogo|PB": "2511202",
"Nova Olinda|PB": "2510204",
"São José de Caiana|PB": "2514305",
"Macaparana|PE": "2609006",
"Várzea|PB": "2517100",
"Juripiranga|PB": "2507903",
"São João do Cariri|PB": "2514008",
"Barreiros|PE": "2601409",
"São José de Espinharas|PB": "2514404",
"Quixaba|PB": "2512606",
"Manaíra|PB": "2509008",
"Serra Talhada|PE": "2613909",
"São José do Sabugi|PB": "2514701",
"Santa Teresinha|PB": "2513802",
"Marizópolis|PB": "2509156",
"Timbaúba|PE": "2615300",
"São Domingos|PB": "2513968",
"Estância|SE": "2802106",
"São João do Tigre|PB": "2514107",
"Santa Cruz|PB": "2513208",
"Riacho de Santo Antônio|PB": "2512788",
"Natuba|PB": "2509909",
"Zabelê|PB": "2517407",
"Nova Palmeira|PB": "2510303",
"Santa Helena|PB": "2513307",
"Caruaru|PE": "2604106",
"Mãe d'Água|PB": "2508703",
"Nazarezinho|PB": "2510006",
"Paulista|PB": "2510907",
"Pedra Branca|PB": "2511004",
"São José dos Cordeiros|PB": "2514800",
"Malta|PB": "2508802",
"Maturéia|PB": "2509396",
"Ouro Velho|PB": "2510600",
"São Sebastião do Umbuzeiro|PB": "2515203",
"Olivedos|PB": "2510501",
"Passagem|PB": "2510709",
"Teixeira|PB": "2516706",
"São José do Bonfim|PB": "2514602",
"Poço Dantas|PB": "2512036",
"Riachão|PB": "2512747",
"Salgadinho|PB": "2513000",
"Sorocaba|SP": "3552205",
"Santo André|PB": "2513851",
"São Bentinho|PB": "2513927",
"São Domingos do Cariri|PB": "2513943",
"São Francisco|PB": "2513984",
"São José da Lagoa Tapada|PB": "2514206",
"São José do Brejo do Cruz|PB": "2514651",
"Sossêgo|PB": "2516151",
"Vieirópolis|PB": "2517209",
"Abreu e Lima|PE": "2600054",
"Olinda|PE": "2609600",
"São Lourenço da Mata|PE": "2613701",
"Vicência|PE": "2616308",
"Itapissuma|PE": "2607752",
"Ipojuca|PE": "2607208",
"São José do Egito|PE": "2613602",
"Afogados da Ingazeira|PE": "2600104",
"Solidão|PE": "2614402",
"Santa Terezinha|PE": "2612802",
"Tabira|PE": "2614600",
"Quixaba|PE": "2611533",
"Ingazeira|PE": "2607109",
"Flores|PE": "2605608",
"Brejinho|PE": "2602506",
"Custódia|PE": "2605103",
"Carnaíba|PE": "2603900",
"Iguaracy|PE": "2606903",
"Sertânia|PE": "2614105",
"Itapetim|PE": "2607703",
"Santa Cruz da Baixa Verde|PE": "2612471",
"Afrânio|PE": "2600203",
"Agrestina|PE": "2600302",
"Água Preta|PE": "2600401",
"Águas Belas|PE": "2600500",
"Alagoinha|PE": "2600609",
"Aliança|PE": "2600708",
"Altinho|PE": "2600807",
"Amaraji|PE": "2600906",
"Angelim|PE": "2601003",
"Araçoiaba|PE": "2601052",
"Ipubi|PE": "2607307",
"Parnamirim|PE": "2610400",
"Lagoa Grande|PE": "2608750",
"Bodocó|PE": "2602001",
"Arcoverde|PE": "2601201",
"Manari|PE": "2609154",
"Buíque|PE": "2602803",
"Itaíba|PE": "2607505",
"Inajá|PE": "2607000",
"Pesqueira|PE": "2610905",
"Tupanatinga|PE": "2615805",
"Ibimirim|PE": "2606606",
"Venturosa|PE": "2616001",
"Petrolândia|PE": "2611002",
"São João|PE": "2613206",
"Pedra|PE": "2610806",
"Tacaratu|PE": "2614808",
"Sanharó|PE": "2612406",
"Bom Conselho|PE": "2602100",
"Jataúba|PE": "2608008",
"Barra de Guabiraba|PE": "2601300",
"Bonito|PE": "2602308",
"Belém de Maria|PE": "2601508",
"Belém do São Francisco|PE": "2601607",
"Belo Jardim|PE": "2601706",
"Betânia|PE": "2601805",
"Bezerros|PE": "2601904",
"Camocim de São Félix|PE": "2603504",
"São Joaquim do Monte|PE": "2613305",
"Moreno|PE": "2609402",
"Terezinha|PE": "2615102",
"Bom Jardim|PE": "2602209",
"Camaragibe|PE": "2603454",
"Brejão|PE": "2602407",
"Brejo da Madre de Deus|PE": "2602605",
"Buenos Aires|PE": "2602704",
"Cabo de Santo Agostinho|PE": "2602902",
"Escada|PE": "2605202",
"Rio Formoso|PE": "2611903",
"Paudalho|PE": "2610608",
"Sirinhaém|PE": "2614204",
"Ribeirão|PE": "2611804",
"Vitória de Santo Antão|PE": "2616407",
"Gameleira|PE": "2605905",
"Xexéu|PE": "2616506",
"Primavera|PE": "2611408",
"Tamandaré|PE": "2614857",
"São José da Coroa Grande|PE": "2613404",
"Palmares|PE": "2610004",
"Cabrobó|PE": "2603009",
"Cachoeirinha|PE": "2603108",
"Caetés|PE": "2603207",
"Calçado|PE": "2603306",
"Calumbi|PE": "2603405",
"Camutanga|PE": "2603603",
"Canhotinho|PE": "2603702",
"Capoeiras|PE": "2603801",
"Carnaubeira da Penha|PE": "2603926",
"Carpina|PE": "2604007",
"Santa Cruz|PE": "2612455",
"São Caitano|PE": "2613107",
"Lagoa dos Gatos|PE": "2608701",
"Sairé|PE": "2612000",
"Cumaru|PE": "2604908",
"Garanhuns|PE": "2606002",
"Riacho das Almas|PE": "2611705",
"Toritama|PE": "2615409",
"Taquaritinga do Norte|PE": "2615003",
"Cupira|PE": "2605004",
"Lagoa do Ouro|PE": "2608602",
"Panelas|PE": "2610202",
"Gravatá|PE": "2606408",
"Surubim|PE": "2614501",
"Vertentes|PE": "2616209",
"Jurema|PE": "2608404",
"Santa Maria do Cambucá|PE": "2612703",
"Tacaimbó|PE": "2614709",
"Chã Grande|PE": "2604502",
"Lajedo|PE": "2608800",
"São Bento do Una|PE": "2613008",
"Iati|PE": "2606507",
"Batalha|AL": "2700706",
"Poção|PE": "2611200",
"Frei Miguelinho|PE": "2605806",
"Jaqueira|PE": "2607950",
"Pombos|PE": "2611309",
"Passira|PE": "2610509",
"Floresta|PE": "2605707",
"Jatobá|PE": "2608057",
"Casinhas|PE": "2604155",
"Catende|PE": "2604205",
"Cedro|PE": "2604304",
"Chã de Alegria|PE": "2604403",
"Glória do Goitá|PE": "2606101",
"Condado|PE": "2604601",
"Correntes|PE": "2604700",
"Cortês|PE": "2604809",
"Joaquim Nabuco|PE": "2608206",
"Dormentes|PE": "2605152",
"Feira Nova|PE": "2605400",
"Fernando de Noronha|PE": "2605459",
"Ferreiros|PE": "2605509",
"Paranatama|PE": "2610301",
"Jupi|PE": "2608305",
"Jucati|PE": "2608255",
"Palmeirina|PE": "2610103",
"Paulo Afonso|BA": "2924009",
"Itaquitinga|PE": "2607802",
"Granito|PE": "2606309",
"Ibirajuba|PE": "2606705",
"Ilha de Itamaracá|PE": "2607604",
"Tuparetama|PE": "2615904",
"Itacuruba|PE": "2607406",
"Jaboti|PR": "4111704",
"João Alfredo|PE": "2608107",
"Lagoa do Carro|PE": "2608453",
"Lagoa de Itaenga|PE": "2608503",
"Limoeiro|PE": "2608909",
"Machados|PE": "2609105",
"Tracunhaém|PE": "2615508",
"Maraial|PE": "2609204",
"Mirandiba|PE": "2609303",
"Nazaré da Mata|PE": "2609501",
"Orobó|PE": "2609709",
"Ouricuri|PE": "2609907",
"Colônia Leopoldina|AL": "2702108",
"Novo Lino|AL": "2705606",
"Jundiá|AL": "2703908",
"Quipapá|PE": "2611507",
"São Benedito do Sul|PE": "2612901",
"Campestre|AL": "2701357",
"Sidrolândia|MS": "5007901",
"Maragogi|AL": "2704500",
"Jeremoabo|BA": "2918100",
"Juazeiro|BA": "2918407",
"Salgueiro|PE": "2612208",
"Santa Maria da Boa Vista|PE": "2612604",
"Curaçá|BA": "2909901",
"Casa Nova|BA": "2907202",
"Triunfo|PE": "2615706",
"Remanso|BA": "2926004",
"Ponto Novo|BA": "2925253",
"Uauá|BA": "2932002",
"Filadélfia|BA": "2910859",
"Pindobaçu|BA": "2924603",
"Jaguarari|BA": "2917706",
"Campo Formoso|BA": "2906006",
"Abaré|BA": "2900207",
"Pilão Arcado|BA": "2924405",
"Itabira|MG": "3131703",
"Vertente do Lério|PE": "2616183",
"São José do Belmonte|PE": "2613503",
"São Luís do Quitunde|AL": "2708501",
"Pão de Açúcar|AL": "2706406",
"Flexeiras|AL": "2702801",
"São Vicente Férrer|PE": "2613800",
"Vitória da Conquista|BA": "2933307",
"Canapi|AL": "2701605",
"Terra Nova|PE": "2615201",
"Estrela de Alagoas|AL": "2702553",
"Palmeira dos Índios|AL": "2706307",
"Canoas|RS": "4304606",
"Penedo|AL": "2706703",
"Anadia|AL": "2700201",
"Japaratinga|AL": "2703601",
"União dos Palmares|AL": "2709301",
"Messias|AL": "2705200",
"Pilar|AL": "2706901",
"Saloá|PE": "2612307",
"Arapiraca|AL": "2700300",
"Serrita|PE": "2614006",
"Álvares Florence|SP": "3501202",
"Rio Largo|AL": "2707701",
"Resende|RJ": "3304201",
"Bonito|MS": "5002209",
"Salgadinho|PE": "2612109",
"Paripueira|AL": "2706448",
"Porto Calvo|AL": "2707305",
"Girau do Ponciano|AL": "2702900",
"São Miguel dos Campos|AL": "2708600",
"Verdejante|PE": "2616100",
"Chorrochó|BA": "2907707",
"Glória|BA": "2911402",
"Macururé|BA": "2919900",
"Santa Filomena|PE": "2612554",
"Água Branca|AL": "2700102",
"Pariconha|AL": "2706422",
"Taquarana|AL": "2709103",
"São Sebastião|AL": "2708808",
"Feira Grande|AL": "2702603",
"Igreja Nova|AL": "2703205",
"Major Isidoro|AL": "2704401",
"Maribondo|AL": "2704807",
"Junqueiro|AL": "2704005",
"Lagoa da Canoa|AL": "2704104",
"Teotônio Vilela|AL": "2709152",
"Traipu|AL": "2709202",
"Craíbas|AL": "2702355",
"Quebrangulo|AL": "2707602",
"Delmiro Gouveia|AL": "2702405",
"Campo Grande|AL": "2701506",
"Joaquim Gomes|AL": "2703809",
"Jaramataia|AL": "2703700",
"Olho d'Água das Flores|AL": "2705705",
"Campo Alegre|AL": "2701407",
"Limoeiro de Anadia|AL": "2704203",
"Coité do Nóia|AL": "2702009",
"Monteirópolis|AL": "2705408",
"Piranhas|AL": "2707107",
"Igaci|AL": "2703106",
"Belém|AL": "2700805",
"Tanque d'Arca|AL": "2709004",
"Carneiros|AL": "2701803",
"Inhapi|AL": "2703304",
"Piaçabuçu|AL": "2706802",
"Belo Monte|AL": "2700904",
"Poço das Trincheiras|AL": "2707206",
"São Brás|AL": "2708204",
"Santana do Ipanema|AL": "2708006",
"Maravilha|AL": "2704609",
"São José da Tapera|AL": "2708402",
"Feliz Deserto|AL": "2702702",
"Ouro Branco|AL": "2706109",
"Cacimbinhas|AL": "2701209",
"Senador Rui Palmeira|AL": "2708956",
"Minador do Negrão|AL": "2705309",
"Porto Real do Colégio|AL": "2707503",
"Olho d'Água Grande|AL": "2705903",
"Atalaia|AL": "2700409",
"Barra de Santo Antônio|AL": "2700508",
"Barra de São Miguel|AL": "2700607",
"Boca da Mata|AL": "2701001",
"Branquinha|AL": "2701100",
"Cajueiro|AL": "2701308",
"Capela|AL": "2701704",
"Chã Preta|AL": "2701902",
"Coqueiro Seco|AL": "2702207",
"Coruripe|AL": "2702306",
"Jequiá da Praia|AL": "2703759",
"Olho d'Água do Casado|AL": "2705804",
"Dois Riachos|AL": "2702504",
"Marechal Deodoro|AL": "2704708",
"São José da Laje|AL": "2708303",
"Roteiro|AL": "2707800",
"Santa Luzia do Norte|AL": "2707909",
"Ibateguara|AL": "2703007",
"Jacaré dos Homens|AL": "2703403",
"Jacuípe|AL": "2703502",
"Pindoba|AL": "2707008",
"Murici|AL": "2705507",
"Viçosa|AL": "2709400",
"Matriz de Camaragibe|AL": "2705101",
"Porto de Pedras|AL": "2707404",
"São Miguel dos Milagres|AL": "2708709",
"Iturama|MG": "3134400",
"Paulo Jacinto|AL": "2706604",
"Passo de Camaragibe|AL": "2706505",
"Satuba|AL": "2708907",
"Santana do Mundaú|AL": "2708105",
"Lagarto|SE": "2803500",
"Mar Vermelho|AL": "2704906",
"Mata Grande|AL": "2705002",
"Foz do Iguaçu|PR": "4108304",
"Palestina|AL": "2706208",
"Olivença|AL": "2706000",
"Santana do São Francisco|SE": "2806404",
"Amparo do São Francisco|SE": "2800100",
"Aquidabã|SE": "2800209",
"Salgado|SE": "2806206",
"Areia Branca|SE": "2800506",
"Carira|SE": "2801405",
"Cumbe|SE": "2801900",
"Muribeca|SE": "2804300",
"Propriá|SE": "2805703",
"Pedrinhas|SE": "2805109",
"Maruim|SE": "2804003",
"Barra dos Coqueiros|SE": "2800605",
"Porto da Folha|SE": "2805604",
"São Cristóvão|SE": "2806701",
"Tobias Barreto|SE": "2807402",
"Umbaúba|SE": "2807600",
"Nossa Senhora do Socorro|SE": "2804805",
"Rosário do Catete|SE": "2806107",
"Itabaiana|SE": "2802908",
"Santa Luzia do Itanhy|SE": "2806305",
"Campo do Brito|SE": "2801009",
"Malhador|SE": "2803906",
"Japaratuba|SE": "2803302",
"Gararu|SE": "2802403",
"Pacatuba|SE": "2804904",
"Itapicuru|BA": "2916500",
"Monte Alegre de Sergipe|SE": "2804201",
"Simão Dias|SE": "2807105",
"Carmópolis|SE": "2801504",
"Nossa Senhora da Glória|SE": "2804508",
"Poço Redondo|SE": "2805406",
"Canindé de São Francisco|SE": "2801207",
"Itaporanga d'Ajuda|SE": "2803203",
"Siriri|SE": "2807204",
"Itabaianinha|SE": "2803005",
"Santa Brígida|BA": "2927606",
"Laranjeiras|SE": "2803609",
"Ribeirópolis|SE": "2806008",
"Divina Pastora|SE": "2802007",
"Nossa Senhora das Dores|SE": "2804607",
"Riachuelo|SE": "2805901",
"Arauá|SE": "2800407",
"Boquim|SE": "2800670",
"Sítio do Quinto|BA": "2930766",
"Coronel João Sá|BA": "2909208",
"Cristinápolis|SE": "2801702",
"Capela|SE": "2801306",
"Itabi|SE": "2803104",
"Japoatã|SE": "2803401",
"Riachão do Dantas|SE": "2805802",
"Heliópolis|BA": "2911857",
"Paripiranga|BA": "2923803",
"Adustina|BA": "2900355",
"Macambira|SE": "2803708",
"Santo Amaro das Brotas|SE": "2806602",
"São Domingos|SE": "2806800",
"Frei Paulo|SE": "2802304",
"Neópolis|SE": "2804409",
"Pirambu|SE": "2805307",
"Poço Verde|SE": "2805505",
"General Maynard|SE": "2802502",
"Santa Rosa de Lima|SE": "2806503",
"Nossa Senhora de Lourdes|SE": "2804706",
"Pedra Mole|SE": "2805000",
"Cedro de São João|SE": "2801603",
"Pinhão|SE": "2805208",
"Fátima|BA": "2910750",
"Ilha das Flores|SE": "2802700",
"Moita Bonita|SE": "2804102",
"Rio Real|BA": "2927002",
"Indiaroba|SE": "2802809",
"Canhoba|SE": "2801108",
"Brejo Grande|SE": "2800704",
"Suzano|SP": "3552502",
"Telha|SE": "2807303",
"Conde|BA": "2908606",
"Malhada dos Bois|SE": "2803807",
"Feira Nova|SE": "2802205",
"São Miguel do Aleixo|SE": "2807006",
"Ribeira do Pombal|BA": "2926608",
"Tomar do Geru|SE": "2807501",
"Graccho Cardoso|SE": "2802601",
"Vitória|ES": "3205309",
"Nossa Senhora Aparecida|SE": "2804458",
"São Francisco|SE": "2806909",
"Abaíra|BA": "2900108",
"Acajutiba|BA": "2900306",
"Água Fria|BA": "2900405",
"Érico Cardoso|BA": "2900504",
"Aiquara|BA": "2900603",
"Alagoinhas|BA": "2900702",
"Olindina|BA": "2923100",
"Sátiro Dias|BA": "2929701",
"Aramari|BA": "2902203",
"Araçás|BA": "2902054",
"Entre Rios|BA": "2910503",
"Inhambupe|BA": "2913705",
"Esplanada|BA": "2910602",
"Alcobaça|BA": "2900801",
"Caravelas|BA": "2906907",
"Almadina|BA": "2900900",
"Amargosa|BA": "2901007",
"Milagres|BA": "2921302",
"Itacaré|BA": "2914901",
"Amélia Rodrigues|BA": "2901106",
"Camaçari|BA": "2905701",
"América Dourada|BA": "2901155",
"Anagé|BA": "2901205",
"Andaraí|BA": "2901304",
"Nova Redenção|BA": "2922854",
"Andorinha|BA": "2901353",
"Angical|BA": "2901403",
"Anguera|BA": "2901502",
"Antas|BA": "2901601",
"Novo Triunfo|BA": "2923050",
"Nova Soure|BA": "2922904",
"Aporá|BA": "2901908",
"Antônio Cardoso|BA": "2901700",
"Antônio Gonçalves|BA": "2901809",
"Apuarema|BA": "2901957",
"Aracatu|BA": "2902005",
"Araci|BA": "2902104",
"Betim|MG": "3106705",
"Tucano|BA": "2931905",
"Arataca|BA": "2902252",
"Aratuípe|BA": "2902302",
"Aurelino Leal|BA": "2902401",
"Baianópolis|BA": "2902500",
"Baixa Grande|BA": "2902609",
"Banzaê|BA": "2902658",
"Barra|BA": "2902708",
"Morpará|BA": "2921609",
"Buritirama|BA": "2904753",
"Xique-Xique|BA": "2933604",
"Mansidão|BA": "2920452",
"Ipupiara|BA": "2914109",
"Barra da Estiva|BA": "2902807",
"Ibicoara|BA": "2912202",
"Barra do Choça|BA": "2902906",
"Barra do Mendes|BA": "2903003",
"Brotas de Macaúbas|BA": "2904506",
"Barra do Rocha|BA": "2903102",
"Barreiras|BA": "2903201",
"Queimadas|BA": "2925808",
"Muquém do São Francisco|BA": "2922250",
"São Desidério|BA": "2928901",
"Riachão das Neves|BA": "2926202",
"Tabocas do Brejo Velho|BA": "2930907",
"Santana|BA": "2928208",
"Santa Maria da Vitória|BA": "2928109",
"Brejolândia|BA": "2904407",
"Formosa do Rio Preto|BA": "2911105",
"Ibotirama|BA": "2913200",
"Santa Rita de Cássia|BA": "2928406",
"Jaborandi|BA": "2917359",
"Wanderley|BA": "2933455",
"Cristópolis|BA": "2909703",
"Ilhéus|BA": "2913606",
"Feira da Mata|BA": "2910776",
"Paratinga|BA": "2923704",
"Catolândia|BA": "2907400",
"Barro Alto|BA": "2903235",
"Barrocas|BA": "2903276",
"Barro Preto|BA": "2903300",
"Belmonte|BA": "2903409",
"Belo Campo|BA": "2903508",
"Biritinga|BA": "2903607",
"Boa Nova|BA": "2903706",
"Boa Vista do Tupim|BA": "2903805",
"Bom Jesus da Lapa|BA": "2903904",
"Sítio do Mato|BA": "2930758",
"Serra do Ramalho|BA": "2930154",
"Bom Jesus da Serra|BA": "2903953",
"Boninal|BA": "2904001",
"Bonito|BA": "2904050",
"Boquira|BA": "2904100",
"Botuporã|BA": "2904209",
"Brejões|BA": "2904308",
"Brumado|BA": "2904605",
"Malhada de Pedras|BA": "2920304",
"Jussiape|BA": "2918605",
"Pindaí|BA": "2924504",
"Tanhaçu|BA": "2931004",
"Buerarema|BA": "2904704",
"Una|BA": "2932507",
"Caatiba|BA": "2904803",
"Cabaceiras do Paraguaçu|BA": "2904852",
"Cachoeira|BA": "2904902",
"São Félix|BA": "2929008",
"Caculé|BA": "2905008",
"Guajeru|BA": "2911659",
"Caém|BA": "2905107",
"Caetanos|BA": "2905156",
"Caetité|BA": "2905206",
"Lagoa Real|BA": "2918753",
"Riacho de Santana|BA": "2926400",
"Ibiassucê|BA": "2912004",
"Potiraguá|BA": "2925402",
"Mortugaba|BA": "2921807",
"Itambé|BA": "2915809",
"São Félix do Coribe|BA": "2929057",
"Firmino Alves|BA": "2910909",
"Licínio de Almeida|BA": "2919405",
"Palmas de Monte Alto|BA": "2923407",
"Cafarnaum|BA": "2905305",
"Cairu|BA": "2905404",
"Caldeirão Grande|BA": "2905503",
"Camacan|BA": "2905602",
"Pau Brasil|BA": "2923902",
"Santa Luzia|BA": "2928059",
"Pojuca|BA": "2925204",
"Dias d'Ávila|BA": "2910057",
"São Sebastião do Passé|BA": "2929503",
"Itiúba|BA": "2917003",
"Simões Filho|BA": "2930709",
"Morro do Chapéu|BA": "2921708",
"Candeias|BA": "2906501",
"Porto Seguro|BA": "2925303",
"Lauro de Freitas|BA": "2919207",
"Camamu|BA": "2905800",
"Umburanas|BA": "2932457",
"Canudos|BA": "2906824",
"Canápolis|BA": "2906105",
"Canarana|BA": "2906204",
"Canavieiras|BA": "2906303",
"Candeal|BA": "2906402",
"Serrinha|BA": "2930501",
"Madre de Deus|BA": "2919926",
"São José dos Pinhais|PR": "4125506",
"São Francisco do Conde|BA": "2929206",
"Candiba|BA": "2906600",
"Cândido Sales|BA": "2906709",
"Cansanção|BA": "2906808",
"Monte Santo|BA": "2921500",
"Capela do Alto Alegre|BA": "2906857",
"Capim Grosso|BA": "2906873",
"Gavião|BA": "2911253",
"São José do Jacuípe|BA": "2929370",
"Planalto|BA": "2925006",
"Planaltino|BA": "2924900",
"Caraíbas|BA": "2906899",
"Cardeal da Silva|BA": "2907004",
"Carinhanha|BA": "2907103",
"Castro Alves|BA": "2907301",
"Catu|BA": "2907509",
"Caturama|BA": "2907558",
"Central|BA": "2907608",
"Cícero Dantas|BA": "2907806",
"Cipó|BA": "2907905",
"Coaraci|BA": "2908002",
"Cocos|BA": "2908101",
"Conceição da Feira|BA": "2908200",
"Conceição do Almeida|BA": "2908309",
"Conceição do Coité|BA": "2908408",
"Conceição do Jacuípe|BA": "2908507",
"Condeúba|BA": "2908705",
"Contendas do Sincorá|BA": "2908804",
"Coração de Maria|BA": "2908903",
"Cordeiros|BA": "2909000",
"Coribe|BA": "2909109",
"Correntina|BA": "2909307",
"Cravolândia|BA": "2909505",
"Crisópolis|BA": "2909604",
"Cruz das Almas|BA": "2909802",
"Dário Meira|BA": "2910008",
"Dom Basílio|BA": "2910107",
"Dom Macedo Costa|BA": "2910206",
"Elísio Medrado|BA": "2910305",
"Encruzilhada|BA": "2910404",
"Valença|RJ": "3306107",
"Euclides da Cunha|BA": "2910701",
"Eunápolis|BA": "2910727",
"Itapebi|BA": "2916302",
"Itabela|BA": "2914653",
"Guaratinga|BA": "2911808",
"Itamaraju|BA": "2915601",
"Santa Cruz Cabrália|BA": "2927705",
"Salto da Divisa|MG": "3157104",
"Águas Formosas|MG": "3100906",
"Itagimirim|BA": "2915304",
"Pé de Serra|BA": "2924058",
"Santo Estêvão|BA": "2928802",
"Nova Fátima|BA": "2922730",
"Itaberaba|BA": "2914703",
"Tanquinho|BA": "2931103",
"Santo Antônio de Jesus|BA": "2928703",
"São Gonçalo dos Campos|BA": "2929305",
"Serra Preta|BA": "2930402",
"Lençóis|BA": "2919306",
"Santo Amaro|BA": "2928604",
"Itatim|BA": "2916856",
"Irará|BA": "2914505",
"Jacobina|BA": "2917508",
"Rafael Jambeiro|BA": "2925956",
"Teofilândia|BA": "2931509",
"Riachão do Jacuípe|BA": "2926301",
"Santaluz|BA": "2928000",
"São Felipe|BA": "2929107",
"Lamarão|BA": "2919108",
"Ipirá|BA": "2914000",
"Terra Nova|BA": "2931707",
"Gandu|BA": "2911204",
"Nilo Peçanha|BA": "2922607",
"Gentio do Ouro|BA": "2911303",
"Gongogi|BA": "2911501",
"Governador Mangabeira|BA": "2911600",
"Guanambi|BA": "2911709",
"Igaporã|BA": "2913408",
"Malhada|BA": "2920205",
"Sebastião Laranjeiras|BA": "2930006",
"Livramento de Nossa Senhora|BA": "2919504",
"Iaçu|BA": "2911907",
"Ibicaraí|BA": "2912103",
"Ibicuí|BA": "2912301",
"Ibipeba|BA": "2912400",
"Ibipitanga|BA": "2912509",
"Macaúbas|BA": "2919801",
"Ibiquera|BA": "2912608",
"Ibirapitanga|BA": "2912707",
"Ibirapuã|BA": "2912806",
"Ibirataia|BA": "2912905",
"Ubatã|BA": "2932309",
"Ibitiara|BA": "2913002",
"Novo Horizonte|BA": "2923035",
"Ibititá|BA": "2913101",
"Ichu|BA": "2913309",
"Igrapiúna|BA": "2913457",
"Iguaí|BA": "2913507",
"Uruçuca|BA": "2932705",
"Mascote|BA": "2920908",
"Itaju do Colônia|BA": "2915403",
"Maraú|BA": "2920700",
"Itabuna|BA": "2914802",
"Itapé|BA": "2916203",
"Ubaitaba|BA": "2932200",
"Wenceslau Guimarães|BA": "2933505",
"Irecê|BA": "2914604",
"Itajuípe|BA": "2915502",
"Teolândia|BA": "2931608",
"Ipiaú|BA": "2913903",
"Itapitanga|BA": "2916609",
"Nova Itarana|BA": "2922805",
"Taperoá|BA": "2931202",
"Santa Inês|BA": "2927903",
"Valença|BA": "2932903",
"São José da Vitória|BA": "2929354",
"Paramirim|BA": "2923605",
"Belford Roxo|RJ": "3300456",
"Ipecaetá|BA": "2913804",
"Itagibá|BA": "2915205",
"Irajuba|BA": "2914208",
"Iramaia|BA": "2914307",
"Iraquara|BA": "2914406",
"Souto Soares|BA": "2930808",
"Mulungu do Morro|BA": "2922052",
"João Dourado|BA": "2918357",
"Uibaí|BA": "2932408",
"Lapão|BA": "2919157",
"São Gabriel|BA": "2929255",
"Jussara|BA": "2918506",
"Presidente Dutra|BA": "2925600",
"Itaguaçu da Bahia|BA": "2915353",
"Marcionílio Souza|BA": "2920809",
"Lajedinho|BA": "2919009",
"Teodoro Sampaio|BA": "2931400",
"Maracás|BA": "2920502",
"Itororó|BA": "2917102",
"Santa Cruz da Vitória|BA": "2927804",
"Itaeté|BA": "2915007",
"Itagi|BA": "2915106",
"Prado|BA": "2925501",
"Jucuruçu|BA": "2918456",
"Itamari|BA": "2915700",
"Ribeirão do Largo|BA": "2926657",
"Itanagra|BA": "2915908",
"Itanhém|BA": "2916005",
"Itaparica|BA": "2916104",
"Itapetinga|BA": "2916401",
"Itarantim|BA": "2916807",
"Itaquara|BA": "2916708",
"Itiruçu|BA": "2916906",
"Ituaçu|BA": "2917201",
"Ituberá|BA": "2917300",
"Iuiu|BA": "2917334",
"Jacaraci|BA": "2917409",
"Ourolândia|BA": "2923357",
"Mirangaba|BA": "2921401",
"Piritiba|BA": "2924801",
"Jaguaquara|BA": "2917607",
"Jaguaripe|BA": "2917805",
"Jandaíra|BA": "2917904",
"Jequié|BA": "2918001",
"Manoel Vitorino|BA": "2920403",
"Jitaúna|BA": "2918308",
"Lafaiete Coutinho|BA": "2918704",
"Macarani|BA": "2919702",
"Jiquiriçá|BA": "2918209",
"Pedro Alexandre|BA": "2924207",
"Jussari|BA": "2918555",
"Laje|BA": "2918803",
"São Miguel das Matas|BA": "2929404",
"Lajedão|BA": "2918902",
"Lajedo do Tabocal|BA": "2919058",
"Nazaré|BA": "2922508",
"Valente|BA": "2933000",
"Vera Cruz|BA": "2933208",
"Maragogipe|BA": "2920601",
"Mucugê|BA": "2921906",
"Macajuba|BA": "2919603",
"Maetinga|BA": "2919959",
"Maiquinique|BA": "2920007",
"Mairi|BA": "2920106",
"Várzea da Roça|BA": "2933059",
"Matina|BA": "2921054",
"Medeiros Neto|BA": "2921104",
"Miguel Calmon|BA": "2921203",
"Mirante|BA": "2921450",
"Mucuri|BA": "2922003",
"Nova Viçosa|BA": "2923001",
"Mundo Novo|BA": "2922102",
"Muniz Ferreira|BA": "2922201",
"Muritiba|BA": "2922300",
"Mutuípe|BA": "2922409",
"Nordestina|BA": "2922656",
"Nova Canaã|BA": "2922706",
"Poções|BA": "2925105",
"Nova Ibiá|BA": "2922755",
"Teixeira de Freitas|BA": "2931350",
"Oliveira dos Brejinhos|BA": "2923209",
"Ouriçangas|BA": "2923308",
"Palmeiras|BA": "2923506",
"Rio do Pires|BA": "2926905",
"Rodelas|BA": "2927101",
"Pedrão|BA": "2924108",
"Piatã|BA": "2924306",
"Pintadas|BA": "2924652",
"Piraí do Norte|BA": "2924678",
"Piripá|BA": "2924702",
"Itapevi|SP": "3522505",
"Igaraçu do Tietê|SP": "3520004",
"Presidente Jânio Quadros|BA": "2925709",
"Presidente Tancredo Neves|BA": "2925758",
"Quijingue|BA": "2925907",
"Quixabeira|BA": "2925931",
"Retirolândia|BA": "2926103",
"Ribeira do Amparo|BA": "2926509",
"Rio de Contas|BA": "2926707",
"Rio do Antônio|BA": "2926806",
"Ruy Barbosa|BA": "2927200",
"Salinas da Margarida|BA": "2927309",
"Várzea Nova|BA": "2933158",
"Magé|RJ": "3302502",
"Serrolândia|BA": "2930600",
"Santa Bárbara|BA": "2927507",
"Saubara|BA": "2929750",
"Ubaíra|BA": "2932101",
"Utinga|BA": "2932804",
"Varzedo|BA": "2933174",
"Sapeaçu|BA": "2929602",
"Seabra|BA": "2929909",
"Saúde|BA": "2929800",
"Santa Terezinha|BA": "2928505",
"Tapiramutá|BA": "2931301",
"Venâncio Aires|RS": "4322608",
"Serra Dourada|BA": "2930303",
"São Domingos|BA": "2928950",
"Santos|SP": "3548500",
"Guarulhos|SP": "3518800",
"São Luís de Montes Belos|GO": "5220108",
"Santanópolis|BA": "2928307",
"Tanque Novo|BA": "2931053",
"Linhares|ES": "3203205",
"Tremedal|BA": "2931806",
"Urandi|BA": "2932606",
"Várzea do Poço|BA": "2933109",
"Vereda|BA": "2933257",
"Divisa Alegre|MG": "3122355",
"Almenara|MG": "3101706",
"Wagner|BA": "2933406",
"Abadia dos Dourados|MG": "3100104",
"Abaeté|MG": "3100203",
"Sericita|MG": "3166303",
"Abre Campo|MG": "3100302",
"Pedra Bonita|MG": "3148756",
"Matipó|MG": "3140902",
"Acaiaca|MG": "3100401",
"Açucena|MG": "3100500",
"Água Boa|MG": "3100609",
"São Sebastião do Maranhão|MG": "3164506",
"Água Comprida|MG": "3100708",
"Aguanil|MG": "3100807",
"Crisólita|MG": "3120151",
"Fronteira dos Vales|MG": "3127057",
"Pavão|MG": "3148509",
"Novo Oriente de Minas|MG": "3145356",
"Bertópolis|MG": "3106606",
"Águas Vermelhas|MG": "3101003",
"Aimorés|MG": "3101102",
"Baixo Guandu|ES": "3200805",
"Aiuruoca|MG": "3101201",
"Liberdade|MG": "3138500",
"Bocaina de Minas|MG": "3107208",
"Arantina|MG": "3103603",
"Seritinga|MG": "3166402",
"Alagoa|MG": "3101300",
"Albertina|MG": "3101409",
"Hortolândia|SP": "3519071",
"Além Paraíba|MG": "3101508",
"Sapucaia|RJ": "3305406",
"Estrela Dalva|MG": "3124609",
"Volta Grande|MG": "3172103",
"Santo Antônio do Aventureiro|MG": "3160009",
"Leopoldina|MG": "3138401",
"Carmo|RJ": "3301207",
"Lambari|MG": "3137809",
"Alfenas|MG": "3101607",
"Guaxupé|MG": "3128709",
"São Pedro da União|MG": "3163904",
"Guaranésia|MG": "3128303",
"Bambuí|MG": "3105103",
"Machado|MG": "3139003",
"Campo do Meio|MG": "3111309",
"Areado|MG": "3104304",
"Monte Belo|MG": "3143005",
"Alterosa|MG": "3102001",
"Carmo do Rio Claro|MG": "3114402",
"Serrania|MG": "3166907",
"Ilicínea|MG": "3130507",
"Poços de Caldas|MG": "3151800",
"Boa Esperança|MG": "3107109",
"Varginha|MG": "3170701",
"Divisa Nova|MG": "3122405",
"Campos Gerais|MG": "3111606",
"Poço Fundo|MG": "3151701",
"São Gonçalo do Sapucaí|MG": "3162005",
"Muzambinho|MG": "3144102",
"Itaúna|MG": "3133808",
"Caxambu|MG": "3115508",
"Lagoa da Prata|MG": "3137205",
"Botelhos|MG": "3108404",
"Arceburgo|MG": "3104106",
"Fama|MG": "3125200",
"Alfredo Vasconcelos|MG": "3101631",
"Santo Antônio do Jacinto|MG": "3160306",
"Bandeira|MG": "3105202",
"Jordânia|MG": "3136504",
"Palmópolis|MG": "3146750",
"Rio do Prado|MG": "3155108",
"Mata Verde|MG": "3140555",
"Alpercata|MG": "3101805",
"Alpinópolis|MG": "3101904",
"Passos|MG": "3147907",
"Alto Caparaó|MG": "3102050",
"Alto Rio Doce|MG": "3102100",
"Alvarenga|MG": "3102209",
"Alvinópolis|MG": "3102308",
"Barra Longa|MG": "3105707",
"Ponte Nova|MG": "3152105",
"Alvorada de Minas|MG": "3102407",
"Amparo do Serra|MG": "3102506",
"Andradas|MG": "3102605",
"São João da Boa Vista|SP": "3549102",
"Cachoeira de Pajeú|MG": "3102704",
"Andrelândia|MG": "3102803",
"Angelândia|MG": "3102852",
"Antônio Carlos|MG": "3102902",
"Antônio Dias|MG": "3103009",
"Araçaí|MG": "3103207",
"Aracitaba|MG": "3103306",
"Araçuaí|MG": "3103405",
"Coronel Murta|MG": "3119500",
"Jenipapo de Minas|MG": "3135456",
"Virgem da Lapa|MG": "3171600",
"Ponto dos Volantes|MG": "3152170",
"Itinga|MG": "3134004",
"Araguari|MG": "3103504",
"Tupaciguara|MG": "3169604",
"Indianópolis|MG": "3130705",
"São Carlos|SP": "3548906",
"Monte Alegre de Minas|MG": "3142809",
"Araponga|MG": "3103702",
"Araporã|MG": "3103751",
"Arapuá|MG": "3103801",
"Araújos|MG": "3103900",
"Araxá|MG": "3104007",
"Perdizes|MG": "3149804",
"Campos Altos|MG": "3111507",
"Ibiá|MG": "3129509",
"Arcos|MG": "3104205",
"Iguatama|MG": "3130309",
"Argirita|MG": "3104403",
"Juara|MT": "5105101",
"Arinos|MG": "3104502",
"Astolfo Dutra|MG": "3104601",
"Ataléia|MG": "3104700",
"Augusto de Lima|MG": "3104809",
"Baependi|MG": "3104908",
"Madre de Deus de Minas|MG": "3139102",
"São Vicente de Minas|MG": "3165305",
"Virgínia|MG": "3171709",
"Baldim|MG": "3105004",
"Lavras|MG": "3138203",
"Bandeira do Sul|MG": "3105301",
"Barão de Cocais|MG": "3105400",
"Santa Bárbara|MG": "3157203",
"Barão do Monte Alto|MG": "3105509",
"Barbacena|MG": "3105608",
"Ressaquinha|MG": "3154408",
"Ibertioga|MG": "3129400",
"Cipotânea|MG": "3116308",
"Carandaí|MG": "3113206",
"Santa Bárbara do Tugúrio|MG": "3157302",
"Conselheiro Lafaiete|MG": "3118304",
"Dores de Campos|MG": "3123007",
"Senhora dos Remédios|MG": "3166204",
"Desterro do Melo|MG": "3121506",
"Capela Nova|MG": "3112208",
"Paiva|MG": "3146602",
"Coronel Xavier Chaves|MG": "3119708",
"Congonhas|MG": "3118007",
"Caranaíba|MG": "3113107",
"Barroso|MG": "3105905",
"Santana do Garambéu|MG": "3158706",
"Entre Rios de Minas|MG": "3123908",
"Bias Fortes|MG": "3106804",
"Bela Vista de Minas|MG": "3106002",
"Belmiro Braga|MG": "3106101",
"Chapada do Norte|MG": "3116100",
"Medina|MG": "3141405",
"Pará de Minas|MG": "3147105",
"Santa Luzia|MG": "3157807",
"Dom Silvério|MG": "3122702",
"Francisco Badaró|MG": "3126505",
"Rio Casca|MG": "3154903",
"Franciscópolis|MG": "3126752",
"Contagem|MG": "3118601",
"Sabará|MG": "3156700",
"Ibirité|MG": "3129806",
"Caeté|MG": "3110004",
"Nova Lima|MG": "3144805",
"Curvelo|MG": "3120904",
"Mário Campos|MG": "3140159",
"São Joaquim de Bicas|MG": "3162922",
"Três Marias|MG": "3169356",
"Sarzedo|MG": "3165537",
"Jaboticatubas|MG": "3134608",
"Raposos|MG": "3153905",
"Florestal|MG": "3126000",
"Pedra Azul|MG": "3148707",
"Divinópolis|MG": "3122306",
"Vespasiano|MG": "3171204",
"Salinas|MG": "3157005",
"São João Evangelista|MG": "3162807",
"Sardoá|MG": "3165503",
"Lagoa Santa|MG": "3137601",
"Santa Maria de Itabira|MG": "3158003",
"São Domingos do Prata|MG": "3161007",
"Igarapé|MG": "3130101",
"Pitangui|MG": "3151404",
"Itabirito|MG": "3131901",
"Ipatinga|MG": "3131307",
"Mariana|MG": "3140001",
"São José da Lapa|MG": "3162955",
"Coluna|MG": "3116803",
"Ouro Branco|MG": "3145901",
"Governador Valadares|MG": "3127701",
"São Pedro do Suaçuí|MG": "3164100",
"Formiga|MG": "3126109",
"Ouro Preto|MG": "3146107",
"Dionísio|MG": "3121803",
"Mateus Leme|MG": "3140704",
"Teófilo Otoni|MG": "3168606",
"Guanhães|MG": "3128006",
"Nanuque|MG": "3144300",
"Esmeraldas|MG": "3124104",
"Pompéu|MG": "3152006",
"Raul Soares|MG": "3154002",
"Brumadinho|MG": "3109006",
"Carlos Chagas|MG": "3113701",
"Itaguara|MG": "3132206",
"Jequitinhonha|MG": "3135803",
"Juatuba|MG": "3136652",
"Montes Claros|MG": "3143302",
"Itapecerica|MG": "3133501",
"Timóteo|MG": "3168705",
"Manhuaçu|MG": "3139409",
"Paineiras|MG": "3146404",
"Cachoeiro de Itapemirim|ES": "3201209",
"Várzea da Palma|MG": "3170800",
"São Sebastião do Paraíso|MG": "3164704",
"São Gotardo|MG": "3162104",
"Buenópolis|MG": "3109204",
"Inhapim|MG": "3130903",
"Pirapetinga|MG": "3151107",
"Patos de Minas|MG": "3148004",
"Caratinga|MG": "3113404",
"Matozinhos|MG": "3141108",
"Pontes e Lacerda|MT": "5106752",
"Luz|MG": "3138807",
"Rio Doce|MG": "3155009",
"Pequi|MG": "3149606",
"Campo Belo|MG": "3111200",
"Belo Oriente|MG": "3106309",
"São João del Rei|MG": "3162500",
"Pedro Leopoldo|MG": "3149309",
"Prata|MG": "3152808",
"Diamantina|MG": "3121605",
"Mendes Pimentel|MG": "3141504",
"Conceição do Mato Dentro|MG": "3117504",
"Ubá|MG": "3169901",
"João Monlevade|MG": "3136207",
"Minas Novas|MG": "3141801",
"Porteirinha|MG": "3152204",
"Santana dos Montes|MG": "3159100",
"Papagaios|MG": "3146909",
"Nova União|MG": "3136603",
"Oliveira|MG": "3145604",
"Fortaleza de Minas|MG": "3126307",
"Sete Lagoas|MG": "3167202",
"Malacacheta|MG": "3139201",
"Moeda|MG": "3142304",
"Periquito|MG": "3149952",
"Piranga|MG": "3150802",
"Santa Rita do Itueto|MG": "3159506",
"Onça de Pitangui|MG": "3145802",
"Carmópolis de Minas|MG": "3114501",
"Lassance|MG": "3138104",
"Bom Despacho|MG": "3107406",
"Ladainha|MG": "3137007",
"Coronel Fabriciano|MG": "3119401",
"Ubaporanga|MG": "3170057",
"Inimutaba|MG": "3131109",
"Nova Serrana|MG": "3145208",
"Itamarandiba|MG": "3132503",
"Guapé|MG": "3128105",
"Cataguases|MG": "3115300",
"Couto de Magalhães de Minas|MG": "3120102",
"Bocaiúva|MG": "3107307",
"Bonfim|MG": "3108107",
"Martinho Campos|MG": "3140506",
"Candeias|MG": "3112000",
"Felixlândia|MG": "3125705",
"João Pinheiro|MG": "3136306",
"Carmo da Cachoeira|MG": "3113909",
"Belo Vale|MG": "3106408",
"Pedras de Maria da Cruz|MG": "3149150",
"Inhaúma|MG": "3131000",
"Felício dos Santos|MG": "3125408",
"Adamantina|SP": "3500105",
"Corinto|MG": "3119104",
"Presidente Juscelino|MG": "3153202",
"Muriaé|MG": "3143906",
"Uberaba|MG": "3170107",
"Galiléia|MG": "3127305",
"Carangola|MG": "3113305",
"José Gonçalves de Minas|MG": "3136520",
"Janaúba|MG": "3135100",
"Novo Cruzeiro|MG": "3145307",
"Rio Acima|MG": "3154804",
"Morada Nova de Minas|MG": "3143500",
"Paraopeba|MG": "3147402",
"Bom Sucesso|MG": "3108008",
"Visconde do Rio Branco|MG": "3172004",
"Marliéria|MG": "3140308",
"Buritizeiro|MG": "3109402",
"Espinosa|MG": "3124302",
"Juvenília|MG": "3136959",
"Nova Era|MG": "3144706",
"Virgolândia|MG": "3171907",
"Frei Lagonegro|MG": "3126950",
"Ipanema|MG": "3131208",
"Pouso Alto|MG": "3152600",
"Perdões|MG": "3149903",
"Capelinha|MG": "3112307",
"São Sebastião do Anta|MG": "3164472",
"São Francisco de Paula|MG": "3161205",
"Santo Antônio do Monte|MG": "3160405",
"Nacip Raydan|MG": "3144201",
"Confins|MG": "3117876",
"Dom Joaquim|MG": "3122603",
"Rio Piracicaba|MG": "3155702",
"São Bento Abade|MG": "3160801",
"Sabinópolis|MG": "3156809",
"Itajubá|MG": "3132404",
"Pirapora|MG": "3151206",
"Lagoa dos Patos|MG": "3137304",
"Riacho dos Machados|MG": "3154507",
"Serra|ES": "3205002",
"Santana do Riacho|MG": "3159001",
"Rio Vermelho|MG": "3156007",
"Caetanópolis|MG": "3109907",
"São Lourenço|MG": "3163706",
"Bugre|MG": "3109253",
"Felisburgo|MG": "3125606",
"Catas Altas|MG": "3115359",
"Itaverava|MG": "3133907",
"Manhumirim|MG": "3139508",
"Senhora de Oliveira|MG": "3166006",
"Prudente de Morais|MG": "3153608",
"Capitólio|MG": "3112802",
"Rio Manso|MG": "3155306",
"Piracema|MG": "3150604",
"Santana do Manhuaçu|MG": "3158904",
"São Gonçalo do Pará|MG": "3161809",
"Montalvânia|MG": "3142700",
"Dom Cavati|MG": "3122504",
"Recreio|MG": "3154101",
"Bom Jesus do Galho|MG": "3107802",
"Córrego Fundo|MG": "3119955",
"Oratórios|MG": "3145851",
"Santa Cruz de Minas|MG": "3157336",
"Itamonte|MG": "3133006",
"Pains|MG": "3146503",
"Nova Ponte|MG": "3145000",
"Peçanha|MG": "3148608",
"Piumhi|MG": "3151503",
"Dores do Indaiá|MG": "3123205",
"Desterro de Entre Rios|MG": "3121407",
"São José do Goiabal|MG": "3163409",
"Comercinho|MG": "3117009",
"Caputira|MG": "3112901",
"Jequeri|MG": "3135506",
"Naque|MG": "3144359",
"Virginópolis|MG": "3171808",
"Viçosa|MG": "3171303",
"Itambacuri|MG": "3132701",
"Gouveia|MG": "3127602",
"São João do Manhuaçu|MG": "3162559",
"Turmalina|MG": "3169703",
"Cedro do Abaeté|MG": "3115607",
"Santa Maria do Suaçuí|MG": "3158201",
"Resende Costa|MG": "3154200",
"Senador Modestino Gonçalves|MG": "3165909",
"Ribeirão Vermelho|MG": "3154705",
"São Mateus|ES": "3204906",
"Itatiaiuçu|MG": "3133709",
"Capim Branco|MG": "3112505",
"Cachoeira da Prata|MG": "3109600",
"Ninheira|MG": "3144656",
"Itaobim|MG": "3133303",
"Santa Bárbara d'Oeste|SP": "3545803",
"Nazareno|MG": "3144508",
"Igaratinga|MG": "3130200",
"Três Corações|MG": "3169307",
"Casa Grande|MG": "3114907",
"São João Nepomuceno|MG": "3162906",
"Urucânia|MG": "3170503",
"Paracatu|MG": "3147006",
"Veredinha|MG": "3171071",
"Serra Azul de Minas|MG": "3166501",
"Ribeirão Preto|SP": "3543402",
"Rubim|MG": "3156601",
"Poté|MG": "3152402",
"Entre Rios|SC": "4205175",
"Moema|MG": "3142403",
"Vila Velha|ES": "3205200",
"Goiabeira|MG": "3127370",
"Teixeiras|MG": "3168507",
"Mutum|MG": "3144003",
"Japaraíba|MG": "3135308",
"Francisco Morato|SP": "3516309",
"São Gonçalo do Rio Abaixo|MG": "3161908",
"Itabirinha|MG": "3131802",
"Frutal|MG": "3127107",
"São Romão|MG": "3164209",
"Santa Maria do Salto|MG": "3158102",
"Monte Santo de Minas|MG": "3143203",
"Monte Sião|MG": "3143401",
"Campestre|MG": "3111002",
"Santa Vitória|MG": "3159803",
"Taquaraçu de Minas|MG": "3168309",
"Blumenau|SC": "4202404",
"Maravilhas|MG": "3139706",
"Unaí|MG": "3170404",
"Estrela do Sul|MG": "3124807",
"Mesquita|MG": "3141702",
"Francisco Sá|MG": "3126703",
"Jeceaba|MG": "3135407",
"Tocantins|MG": "3169000",
"Bom Jardim de Minas|MG": "3107505",
"Balneário Pinhal|RS": "4301636",
"Cariacica|ES": "3201308",
"Guarani|MG": "3128402",
"Barra de São Francisco|ES": "3200904",
"Congonhas do Norte|MG": "3118106",
"Serro|MG": "3167103",
"Tatuí|SP": "3554003",
"Rio Pomba|MG": "3155801",
"Guarapari|ES": "3202405",
"Eugenópolis|MG": "3124906",
"Passa Tempo|MG": "3147709",
"Morro do Pilar|MG": "3143708",
"Presidente Olegário|MG": "3153400",
"Cantagalo|MG": "3112059",
"Sumaré|SP": "3552403",
"Jacuí|MG": "3134806",
"Brasilândia de Minas|MG": "3108552",
"Muniz Freire|ES": "3203700",
"São Gonçalo do Abaeté|MG": "3161700",
"Vargem Alegre|MG": "3170578",
"Frei Inocêncio|MG": "3126901",
"Materlândia|MG": "3140605",
"Berilo|MG": "3106507",
"Berizal|MG": "3106655",
"Ipaba|MG": "3131158",
"Padre Paraíso|MG": "3146305",
"Cuparaque|MG": "3120839",
"Bicas|MG": "3106903",
"Mar de Espanha|MG": "3139805",
"Biquinhas|MG": "3107000",
"Engenheiro Navarro|MG": "3123809",
"Francisco Dumont|MG": "3126604",
"Joaquim Felício|MG": "3136405",
"Januária|MG": "3135209",
"Guaraciama|MG": "3128253",
"Lima Duarte|MG": "3138609",
"Bom Jesus da Penha|MG": "3107604",
"Bom Jesus do Amparo|MG": "3107703",
"Bom Repouso|MG": "3107901",
"Bonito de Minas|MG": "3108255",
"Borda da Mata|MG": "3108305",
"Brasília de Minas|MG": "3108602",
"Ubaí|MG": "3170008",
"Luislândia|MG": "3138682",
"Japonvar|MG": "3135357",
"Icaraí de Minas|MG": "3130051",
"Patis|MG": "3147956",
"Ibiracatu|MG": "3129657",
"Lontra|MG": "3138658",
"São João da Ponte|MG": "3162401",
"Brás Pires|MG": "3108701",
"Braúnas|MG": "3108800",
"Brazópolis|MG": "3108909",
"Bueno Brandão|MG": "3109105",
"Buritis|MG": "3109303",
"Cabo Verde|MG": "3109501",
"Cachoeira de Minas|MG": "3109709",
"Cachoeira Dourada|MG": "3109808",
"Ribeirão Claro|PR": "4121802",
"Caiana|MG": "3110103",
"Cajuri|MG": "3110202",
"Caldas|MG": "3110301",
"Camacho|MG": "3110400",
"Camanducaia|MG": "3110509",
"Cambuí|MG": "3110608",
"Cambuquira|MG": "3110707",
"Lorena|SP": "3527207",
"Campanário|MG": "3110806",
"Campanha|MG": "3110905",
"Campina Verde|MG": "3111101",
"Campo Azul|MG": "3111150",
"Cana Verde|MG": "3111903",
"Campo Florido|MG": "3111408",
"Canaã|MG": "3111705",
"Canápolis|MG": "3111804",
"Caparaó|MG": "3112109",
"Aricanduva|MG": "3104452",
"Capetinga|MG": "3112406",
"Capinópolis|MG": "3112604",
"Capitão Andrade|MG": "3112653",
"Capitão Enéas|MG": "3112703",
"Caraí|MG": "3113008",
"Catuji|MG": "3115458",
"Santana da Vargem|MG": "3158300",
"Orizânia|MG": "3145877",
"Divino|MG": "3122009",
"Pedra Dourada|MG": "3149002",
"Faria Lemos|MG": "3125309",
"Tombos|MG": "3169208",
"Espera Feliz|MG": "3124203",
"Entre Folhas|MG": "3123858",
"Iapu|MG": "3129301",
"Imbé de Minas|MG": "3130556",
"Santa Bárbara do Leste|MG": "3157252",
"Piedade de Caratinga|MG": "3150158",
"Santa Rita de Minas|MG": "3159357",
"Carbonita|MG": "3113503",
"Careaçu|MG": "3113602",
"Carmésia|MG": "3113800",
"Carmo da Mata|MG": "3114006",
"Carmo de Minas|MG": "3114105",
"Carmo do Cajuru|MG": "3114204",
"Carmo do Paranaíba|MG": "3114303",
"Monte Carmelo|MG": "3143104",
"Carneirinho|MG": "3114550",
"Carrancas|MG": "3114600",
"Carvalhos|MG": "3114808",
"Cascalho Rico|MG": "3115003",
"Cássia|MG": "3115102",
"Ibiraci|MG": "3129707",
"Conceição da Barra de Minas|MG": "3115201",
"Dona Euzébia|MG": "3122900",
"Santana de Cataguases|MG": "3158409",
"Itamarati de Minas|MG": "3132602",
"Laranjal|MG": "3138005",
"Catas Altas da Noruega|MG": "3115409",
"Catuti|MG": "3115474",
"Central de Minas|MG": "3115706",
"Mantenópolis|ES": "3203304",
"Centralina|MG": "3115805",
"Chácara|MG": "3115904",
"Chalé|MG": "3116001",
"Chapada Gaúcha|MG": "3116159",
"Chiador|MG": "3116209",
"Claraval|MG": "3116407",
"Claro dos Poções|MG": "3116506",
"Cláudio|MG": "3116605",
"Coimbra|MG": "3116704",
"Comendador Gomes|MG": "3116902",
"Conceição da Aparecida|MG": "3117108",
"Conceição das Alagoas|MG": "3117306",
"Conceição de Ipanema|MG": "3117405",
"Conceição do Pará|MG": "3117603",
"Conceição do Rio Verde|MG": "3117702",
"Conceição dos Ouros|MG": "3117801",
"Cônego Marinho|MG": "3117836",
"Congonhal|MG": "3117900",
"São Brás do Suaçuí|MG": "3160900",
"Pontal do Paraná|PR": "4119954",
"Conquista|MG": "3118205",
"Cristiano Otoni|MG": "3120409",
"Conselheiro Pena|MG": "3118403",
"Consolação|MG": "3118502",
"Coqueiral|MG": "3118700",
"Coração de Jesus|MG": "3118809",
"São João do Pacuí|MG": "3162658",
"Cordisburgo|MG": "3118908",
"Cordislândia|MG": "3119005",
"Coroaci|MG": "3119203",
"Coromandel|MG": "3119302",
"Joanésia|MG": "3136108",
"Santana do Paraíso|MG": "3158953",
"Pingo-d'Água|MG": "3150539",
"Coronel Pacheco|MG": "3119609",
"Córrego Danta|MG": "3119807",
"Córrego do Bom Jesus|MG": "3119906",
"Córrego Novo|MG": "3120003",
"Cristais|MG": "3120201",
"Cristália|MG": "3120300",
"Cristina|MG": "3120508",
"Crucilândia|MG": "3120607",
"Cruzília|MG": "3120805",
"Minduri|MG": "3141900",
"Curral de Dentro|MG": "3120870",
"Monjolos|MG": "3142502",
"Datas|MG": "3121001",
"Delfim Moreira|MG": "3121100",
"Delfinópolis|MG": "3121209",
"Delta|MG": "3121258",
"Descoberto|MG": "3121308",
"Santo Antônio do Itambé|MG": "3160207",
"São Gonçalo do Rio Preto|MG": "3125507",
"Presidente Kubitschek|MG": "3153301",
"Diogo de Vasconcelos|MG": "3121704",
"Divinésia|MG": "3121902",
"Divino das Laranjeiras|MG": "3122108",
"Divinolândia de Minas|MG": "3122207",
"Pedra do Indaiá|MG": "3148905",
"Leandro Ferreira|MG": "3138302",
"São Sebastião do Oeste|MG": "3164605",
"Divisópolis|MG": "3122454",
"Dom Bosco|MG": "3122470",
"Dom Viçoso|MG": "3122801",
"Dores de Guanhães|MG": "3123106",
"Serra da Saudade|MG": "3166600",
"Dores do Turvo|MG": "3123304",
"Doresópolis|MG": "3123403",
"Douradoquara|MG": "3123502",
"Durandé|MG": "3123528",
"Elói Mendes|MG": "3123601",
"Engenheiro Caldas|MG": "3123700",
"Lagoa Dourada|MG": "3137403",
"Ervália|MG": "3124005",
"Espírito Santo do Dourado|MG": "3124401",
"Estiva|MG": "3124500",
"Estrela do Indaiá|MG": "3124708",
"Ewbank da Câmara|MG": "3125002",
"Extrema|MG": "3125101",
"Itapeva|MG": "3133600",
"Toledo|MG": "3169109",
"Pedra Bela|SP": "3536802",
"Fernandes Tourinho|MG": "3125804",
"Ferros|MG": "3125903",
"Fervedouro|MG": "3125952",
"Pimenta|MG": "3150505",
"Formoso|MG": "3126208",
"Fortuna de Minas|MG": "3126406",
"Frei Gaspar|MG": "3126802",
"Fronteira|MG": "3127008",
"Fruta de Leite|MG": "3127073",
"Itapagipe|MG": "3133402",
"Funilândia|MG": "3127206",
"Gameleiras|MG": "3127339",
"Glaucilândia|MG": "3127354",
"Goianá|MG": "3127388",
"Gonçalves|MG": "3127404",
"Gonzaga|MG": "3127503",
"São João do Manteninha|MG": "3162575",
"Marilac|MG": "3140100",
"Resplendor|MG": "3154309",
"Mantena|MG": "3139607",
"Santa Helena de Minas|MG": "3157658",
"São Geraldo da Piedade|MG": "3161601",
"São Geraldo do Baixio|MG": "3161650",
"Nova Belém|MG": "3144672",
"Água Doce do Norte|ES": "3200169",
"Sobrália|MG": "3167707",
"Itanhomi|MG": "3133204",
"Jampruca|MG": "3135076",
"Tumiritinga|MG": "3169505",
"Águia Branca|ES": "3200136",
"Tarumirim|MG": "3168408",
"Colatina|ES": "3201506",
"Mathias Lobato|MG": "3171501",
"Santa Efigênia de Minas|MG": "3157500",
"Pescador|MG": "3150000",
"São José da Safira|MG": "3163003",
"Grão Mogol|MG": "3127800",
"Josenópolis|MG": "3136579",
"Grupiara|MG": "3127909",
"Guaraciaba|MG": "3128204",
"Guarará|MG": "3128501",
"Guarda-Mor|MG": "3128600",
"Guidoval|MG": "3128808",
"Guimarânia|MG": "3128907",
"Guiricema|MG": "3129004",
"Gurinhatã|MG": "3129103",
"Ituiutaba|MG": "3134202",
"Heliodora|MG": "3129202",
"Ibiaí|MG": "3129608",
"Jardinópolis|SP": "3525102",
"Ibitiúra de Minas|MG": "3129905",
"Ijaci|MG": "3130408",
"Inconfidentes|MG": "3130606",
"Indaiabira|MG": "3130655",
"Ingaí|MG": "3130804",
"São João do Oriente|MG": "3162609",
"São Domingos das Dores|MG": "3160959",
"Mongaguá|SP": "3531100",
"Paulínia|SP": "3536505",
"Barra Mansa|RJ": "3300407",
"Ipiaçu|MG": "3131406",
"Ipuiúna|MG": "3131505",
"Iraí de Minas|MG": "3131604",
"Passabém|MG": "3147501",
"Itambé do Mato Dentro|MG": "3132800",
"Itacambira|MG": "3132008",
"Itacarambi|MG": "3132107",
"Itaipé|MG": "3132305",
"Pedralva|MG": "3149101",
"Piranguçu|MG": "3150901",
"Pouso Alegre|MG": "3152501",
"Santa Rita do Sapucaí|MG": "3159605",
"São José dos Campos|SP": "3549904",
"Munhoz|MG": "3143807",
"Piranguinho|MG": "3151008",
"Paraisópolis|MG": "3147303",
"Maria da Fé|MG": "3139904",
"Sapucaí-Mirim|MG": "3165404",
"Wenceslau Braz|MG": "3172202",
"Campos do Jordão|SP": "3509700",
"Marmelópolis|MG": "3140407",
"Nova Módica|MG": "3144904",
"Itamogi|MG": "3132909",
"Itanhandu|MG": "3133105",
"Joaíma|MG": "3136009",
"Itaú de Minas|MG": "3133758",
"Itueta|MG": "3134103",
"São Simão|GO": "5220405",
"Itumirim|MG": "3134301",
"Limeira do Oeste|MG": "3138625",
"Itutinga|MG": "3134509",
"Jacinto|MG": "3134707",
"Jacutinga|MG": "3134905",
"Jaguaraçu|MG": "3135001",
"Jaíba|MG": "3135050",
"Verdelândia|MG": "3171030",
"Nova Porteirinha|MG": "3145059",
"Monte Azul|MG": "3142908",
"Matias Cardoso|MG": "3140852",
"São João das Missões|MG": "3162450",
"Manga|MG": "3139300",
"Miravânia|MG": "3142254",
"Jequitaí|MG": "3135605",
"Jequitibá|MG": "3135704",
"Jesuânia|MG": "3135902",
"José Raydan|MG": "3136553",
"Matias Barbosa|MG": "3140803",
"Santos Dumont|MG": "3160702",
"Mercês|MG": "3141603",
"Rodeiro|MG": "3156304",
"Rio Novo|MG": "3155405",
"Piau|MG": "3150109",
"Piraúba|MG": "3151305",
"São Geraldo|MG": "3161502",
"Pequeri|MG": "3149507",
"Volta Redonda|RJ": "3306305",
"Piedade do Rio Grande|MG": "3150307",
"Paraíba do Sul|RJ": "3303708",
"Santana do Deserto|MG": "3158607",
"Três Rios|RJ": "3306008",
"Santo Antônio de Pádua|RJ": "3304706",
"Simão Pereira|MG": "3167509",
"Vassouras|RJ": "3306206",
"Olaria|MG": "3145406",
"Comendador Levy Gasparian|RJ": "3300951",
"Tabuleiro|MG": "3167905",
"Presidente Bernardes|MG": "3153103",
"Santa Rita de Jacutinga|MG": "3159308",
"Rochedo de Minas|MG": "3156205",
"Maripá de Minas|MG": "3140209",
"Rio Preto|MG": "3155900",
"Passa Vinte|MG": "3147808",
"Pedro Teixeira|MG": "3149408",
"Nova Iguaçu|RJ": "3303500",
"Pinheiral|RJ": "3303955",
"São José do Vale do Rio Preto|RJ": "3305158",
"Martins Soares|MG": "3140530",
"Miraí|MG": "3142205",
"Juramento|MG": "3136801",
"Juruaia|MG": "3136900",
"Lagamar|MG": "3137106",
"Lagoa Formosa|MG": "3137502",
"Lagoa Grande|MG": "3137536",
"Lajinha|MG": "3137700",
"Lamim|MG": "3137908",
"Luminárias|MG": "3138708",
"Santo Antônio do Amparo|MG": "3159902",
"Nepomuceno|MG": "3144607",
"Leme do Prado|MG": "3138351",
"Palma|MG": "3146701",
"Luisburgo|MG": "3138674",
"Machacalis|MG": "3138906",
"Setubinha|MG": "3165552",
"Mamonas|MG": "3139250",
"Pocrane|MG": "3151909",
"Simonésia|MG": "3167608",
"Reduto|MG": "3154150",
"Iúna|ES": "3203007",
"Santa Margarida|MG": "3157906",
"Ibatiba|ES": "3202454",
"São José do Mantimento|MG": "3163607",
"Alto Jequitibá|MG": "3153509",
"Mato Verde|MG": "3141009",
"Matutina|MG": "3141207",
"Tiros|MG": "3168903",
"Medeiros|MG": "3141306",
"Mirabela|MG": "3142007",
"Miradouro|MG": "3142106",
"Monsenhor Paulo|MG": "3142601",
"Monte Formoso|MG": "3143153",
"Varzelândia|MG": "3170909",
"Santo Antônio do Retiro|MG": "3160454",
"Pai Pedro|MG": "3146552",
"Rubelita|MG": "3156502",
"São Francisco|MG": "3161106",
"São João do Paraíso|MG": "3162708",
"Rio Pardo de Minas|MG": "3155603",
"São João da Lagoa|MG": "3162252",
"Serranópolis de Minas|MG": "3166956",
"Taiobeiras|MG": "3168002",
"Montezuma|MG": "3143450",
"Novorizonte|MG": "3145372",
"Ponto Chique|MG": "3152131",
"Vargem Grande do Rio Pardo|MG": "3170651",
"Padre Carvalho|MG": "3146255",
"Pintópolis|MG": "3150570",
"Olhos-d'Água|MG": "3145455",
"Jacareí|SP": "3524402",
"Botumirim|MG": "3108503",
"São Sebastião da Vargem Alegre|MG": "3164431",
"Silveirânia|MG": "3167301",
"Bom Jesus do Itabapoana|RJ": "3300605",
"São Francisco do Glória|MG": "3161403",
"Vieiras|MG": "3171402",
"Patrocínio do Muriaé|MG": "3148202",
"Serra dos Aimorés|MG": "3166709",
"Natalândia|MG": "3144375",
"Natércia|MG": "3144409",
"Carapicuíba|SP": "3510609",
"Nova Resende|MG": "3145109",
"Olímpio Noronha|MG": "3145505",
"São Tiago|MG": "3165008",
"Ouro Fino|MG": "3146008",
"Ouro Verde de Minas|MG": "3146206",
"Bonfinópolis de Minas|MG": "3108206",
"Passa Quatro|MG": "3147600",
"São João Batista do Glória|MG": "3162203",
"São José da Barra|MG": "3162948",
"Serra do Salitre|MG": "3166808",
"Varjão de Minas|MG": "3170750",
"Rio Paranaíba|MG": "3155504",
"Vazante|MG": "3171006",
"Patrocínio|MG": "3148103",
"Paula Cândido|MG": "3148301",
"Paulistas|MG": "3148400",
"Pedra do Anta|MG": "3148806",
"Pedrinópolis|MG": "3149200",
"Piedade de Ponte Nova|MG": "3150208",
"Piedade dos Gerais|MG": "3150406",
"Pirajuba|MG": "3150703",
"Santa Fé de Minas|MG": "3157609",
"Planura|MG": "3151602",
"Águas da Prata|SP": "3500402",
"Sem-Peixe|MG": "3165560",
"São Pedro dos Ferros|MG": "3164001",
"Santo Antônio do Grama|MG": "3160108",
"Irupi|ES": "3202652",
"Porto Firme|MG": "3152303",
"Tocos do Moji|MG": "3169059",
"Santa Rita de Caldas|MG": "3159209",
"Turvolândia|MG": "3169802",
"Senador José Bento|MG": "3165800",
"São Sebastião da Bela Vista|MG": "3164407",
"São João da Mata|MG": "3162302",
"Prados|MG": "3152709",
"Pratápolis|MG": "3152907",
"Pratinha|MG": "3153004",
"Quartel Geral|MG": "3153707",
"Riachinho|MG": "3154457",
"Rio Espera|MG": "3155207",
"Campos dos Goytacazes|RJ": "3301009",
"Ritápolis|MG": "3156106",
"Romaria|MG": "3156403",
"Rosário da Limeira|MG": "3156452",
"Sacramento|MG": "3156908",
"Santa Cruz de Salinas|MG": "3157377",
"Santa Bárbara do Monte Verde|MG": "3157278",
"Santa Cruz do Escalvado|MG": "3157401",
"Santa Juliana|MG": "3157708",
"Santana do Jacaré|MG": "3158805",
"Santa Rita de Ibitipoca|MG": "3159407",
"Santa Rosa da Serra|MG": "3159704",
"Santo Hipólito|MG": "3160603",
"Oliveira Fortes|MG": "3145703",
"São Félix de Minas|MG": "3161056",
"São Francisco de Sales|MG": "3161304",
"Tiradentes|MG": "3168804",
"Silvianópolis|MG": "3167400",
"Cotia|SP": "3513009",
"São José da Varginha|MG": "3163102",
"São José do Alegre|MG": "3163201",
"São José do Divino|MG": "3163300",
"São José do Jacuri|MG": "3163508",
"Rio das Ostras|RJ": "3304524",
"Soledade de Minas|MG": "3167806",
"São Roque de Minas|MG": "3164308",
"São Tomás de Aquino|MG": "3165107",
"São Sebastião do Rio Preto|MG": "3164803",
"São Tomé das Letras|MG": "3165206",
"Senador Amaral|MG": "3165578",
"Senador Cortes|MG": "3165602",
"Senador Firmino|MG": "3165701",
"Serranos|MG": "3167004",
"Santana de Pirapama|MG": "3158508",
"Taparuba|MG": "3168051",
"Tapira|MG": "3168101",
"Tapiraí|MG": "3168200",
"Umburatiba|MG": "3170305",
"Três Pontas|MG": "3169406",
"Veríssimo|MG": "3171105",
"Igarapava|SP": "3520103",
"Miguelópolis|SP": "3529708",
"Cruzeiro da Fortaleza|MG": "3120706",
"Catalão|GO": "5205109",
"Itumbiara|GO": "5211503",
"Cachoeira Dourada|GO": "5204250",
"Cachoeira Alta|GO": "5204102",
"Cabeceira Grande|MG": "3109451",
"Uruana de Minas|MG": "3170479",
"União de Minas|MG": "3170438",
"Urucuia|MG": "3170529",
"Vargem Bonita|MG": "3170602",
"Cláudia|MT": "5103056",
"São Miguel do Anta|MG": "3163805",
"Afonso Cláudio|ES": "3200102",
"Brejetuba|ES": "3201159",
"Marechal Floriano|ES": "3203346",
"Alegre|ES": "3200201",
"Alfredo Chaves|ES": "3200300",
"Alto Rio Novo|ES": "3200359",
"Anchieta|ES": "3200409",
"Piúma|ES": "3204203",
"Apiacá|ES": "3200508",
"Aracruz|ES": "3200607",
"Ibiraçu|ES": "3202504",
"João Neiva|ES": "3203130",
"Atílio Vivácqua|ES": "3200706",
"Santa Leopoldina|ES": "3204500",
"Nova Venécia|ES": "3203908",
"Ecoporanga|ES": "3202108",
"Boa Esperança|ES": "3201001",
"Bom Jesus do Norte|ES": "3201100",
"Venda Nova do Imigrante|ES": "3205069",
"Muqui|ES": "3203809",
"Conceição do Castelo|ES": "3201704",
"Jerônimo Monteiro|ES": "3203106",
"Mimoso do Sul|ES": "3203403",
"Marataízes|ES": "3203320",
"Vargem Alta|ES": "3205036",
"Itapemirim|ES": "3202801",
"Rio Novo do Sul|ES": "3204401",
"Castelo|ES": "3201407",
"Presidente Kennedy|ES": "3204302",
"Iconha|ES": "3202603",
"Itaboraí|RJ": "3301900",
"São José do Calçado|ES": "3204807",
"Ibitirama|ES": "3202553",
"Guaçuí|ES": "3202306",
"Viana|ES": "3205101",
"Montanha|ES": "3203502",
"Monções|SP": "3531001",
"Vila Valério|ES": "3205176",
"São Domingos do Norte|ES": "3204658",
"Marilândia|ES": "3203353",
"Itarana|ES": "3202900",
"São Gabriel da Palha|ES": "3204708",
"Governador Lindenberg|ES": "3202256",
"Pancas|ES": "3204005",
"Rio Bananal|ES": "3204351",
"Conceição da Barra|ES": "3201605",
"Itatiba|SP": "3523404",
"Laranja da Terra|ES": "3203163",
"Pinheiros|ES": "3204104",
"Domingos Martins|ES": "3201902",
"Fundão|ES": "3202207",
"Sooretama|ES": "3205010",
"Pedro Canário|ES": "3204054",
"Itaguaçu|ES": "3202702",
"Santa Teresa|ES": "3204609",
"Porciúncula|RJ": "3304102",
"Divino de São Lourenço|ES": "3201803",
"Dores do Rio Preto|ES": "3202009",
"Jaguaré|ES": "3203056",
"São Roque do Canaã|ES": "3204955",
"Ponto Belo|ES": "3204252",
"Mucurici|ES": "3203601",
"Santa Maria de Jetibá|ES": "3204559",
"Viamão|RS": "4323002",
"Vila Pavão|ES": "3205150",
"São Francisco de Itabapoana|RJ": "3304755",
"Matelândia|PR": "4115606",
"Osasco|SP": "3534401",
"Varre-Sai|RJ": "3306156",
"Salto|SP": "3545209",
"Angra dos Reis|RJ": "3300100",
"Paraty|RJ": "3303807",
"Seropédica|RJ": "3305554",
"Mangaratiba|RJ": "3302601",
"Rio Claro|RJ": "3304409",
"Aperibé|RJ": "3300159",
"Araruama|RJ": "3300209",
"Saquarema|RJ": "3305505",
"São Pedro da Aldeia|RJ": "3305208",
"Iguaba Grande|RJ": "3301876",
"Cabo Frio|RJ": "3300704",
"Rio Bonito|RJ": "3304300",
"Armação dos Búzios|RJ": "3300233",
"Areal|RJ": "3300225",
"Petrópolis|RJ": "3303906",
"Arraial do Cabo|RJ": "3300258",
"Barra do Piraí|RJ": "3300308",
"Bananal|SP": "3504909",
"Queimados|RJ": "3304144",
"Mesquita|RJ": "3302858",
"Nilópolis|RJ": "3303203",
"Bom Jardim|RJ": "3300506",
"Duas Barras|RJ": "3301603",
"Itaperuna|RJ": "3302205",
"Laje do Muriaé|RJ": "3302304",
"Cardoso Moreira|RJ": "3301157",
"Cachoeiras de Macacu|RJ": "3300803",
"Cambuci|RJ": "3300902",
"Carapebus|RJ": "3300936",
"São Fidélis|RJ": "3304805",
"Macaé|RJ": "3302403",
"São João da Barra|RJ": "3305000",
"Miracema|RJ": "3303005",
"Quissamã|RJ": "3304151",
"Cantagalo|RJ": "3301108",
"Macuco|RJ": "3302452",
"Casimiro de Abreu|RJ": "3301306",
"Conceição de Macabu|RJ": "3301405",
"Santa Maria Madalena|RJ": "3304607",
"Cordeiro|RJ": "3301504",
"Paracambi|RJ": "3303609",
"Guapimirim|RJ": "3301850",
"Maricá|RJ": "3302700",
"Japeri|RJ": "3302270",
"São Gonçalo|RJ": "3304904",
"Engenheiro Paulo de Frontin|RJ": "3301801",
"Tanguá|RJ": "3305752",
"Itaguaí|RJ": "3302007",
"Italva|RJ": "3302056",
"Itaocara|RJ": "3302106",
"Natividade|RJ": "3303104",
"São José de Ubá|RJ": "3305133",
"São Sebastião do Alto|RJ": "3305307",
"Itatiaia|RJ": "3302254",
"Trajano de Moraes|RJ": "3305901",
"Mendes|RJ": "3302809",
"Miguel Pereira|RJ": "3302908",
"Paty do Alferes|RJ": "3303856",
"Silva Jardim|RJ": "3305604",
"Nova Friburgo|RJ": "3303401",
"Teresópolis|RJ": "3305802",
"Sumidouro|RJ": "3305703",
"Porto Real|RJ": "3304110",
"Caçapava|SP": "3508504",
"Piraí|RJ": "3304003",
"Antônio Prado de Minas|MG": "3103108",
"Quatis|RJ": "3304128",
"Roncador|PR": "4122503",
"Rio das Flores|RJ": "3304508",
"Cruzeiro|SP": "3513405",
"Peruíbe|SP": "3537602",
"Cachoeira do Sul|RS": "4303004",
"Santo Antônio do Palma|RS": "4317558",
"Ladário|MS": "5005202",
"Morungaba|SP": "3532009",
"Descalvado|SP": "3513702",
"Luziânia|GO": "5212501",
"Adolfo|SP": "3500204",
"Aguaí|SP": "3500303",
"Águas de Lindóia|SP": "3500501",
"Águas de Santa Bárbara|SP": "3500550",
"Águas de São Pedro|SP": "3500600",
"Agudos|SP": "3500709",
"Arealva|SP": "3503406",
"Marília|SP": "3529005",
"Alambari|SP": "3500758",
"Alfredo Marcondes|SP": "3500808",
"Altair|SP": "3500907",
"Altinópolis|SP": "3501004",
"Alto Alegre|SP": "3501103",
"Alumínio|SP": "3501152",
"Álvares Machado|SP": "3501301",
"Presidente Bernardes|SP": "3541208",
"Álvaro de Carvalho|SP": "3501400",
"Cerqueira César|SP": "3511409",
"Serra Azul|SP": "3551405",
"Itapecerica da Serra|SP": "3522208",
"Avanhandava|SP": "3504404",
"Diadema|SP": "3513801",
"Tremembé|SP": "3554805",
"Getulina|SP": "3517000",
"Bernardino de Campos|SP": "3506300",
"Alvinlândia|SP": "3501509",
"Tupi Paulista|SP": "3555109",
"Americana|SP": "3501608",
"Lavínia|SP": "3526506",
"Itapetininga|SP": "3522307",
"Iperó|SP": "3521002",
"Mineiros do Tietê|SP": "3529807",
"Cosmópolis|SP": "3512803",
"Artur Nogueira|SP": "3503802",
"São Vicente|SP": "3551009",
"Américo Brasiliense|SP": "3501707",
"Araraquara|SP": "3503208",
"Ibitinga|SP": "3519600",
"Lençóis Paulista|SP": "3526803",
"Ribeirão Bonito|SP": "3542909",
"Ibaté|SP": "3519303",
"Santa Lúcia|SP": "3546900",
"Boa Esperança do Sul|SP": "3506706",
"Nova Europa|SP": "3532900",
"Jaboticabal|SP": "3524303",
"Indaiatuba|SP": "3520509",
"Serrana|SP": "3551504",
"São José do Rio Pardo|SP": "3549706",
"Barra Bonita|SP": "3505302",
"Porto Ferreira|SP": "3540705",
"Motuca|SP": "3532058",
"Severínia|SP": "3551900",
"Dobrada|SP": "3514007",
"Itápolis|SP": "3522703",
"Cravinhos|SP": "3513108",
"Pradópolis|SP": "3540903",
"Dourado|SP": "3514304",
"Santa Cruz das Palmeiras|SP": "3546306",
"Américo de Campos|SP": "3501806",
"Amparo|SP": "3501905",
"Pedreira|SP": "3537107",
"Analândia|SP": "3502002",
"Andradina|SP": "3502101",
"Mirandópolis|SP": "3530102",
"Iaras|SP": "3519253",
"Nova Aliança|SP": "3532801",
"Castilho|SP": "3511003",
"Pereira Barreto|SP": "3537404",
"Gastão Vidigal|SP": "3516804",
"Guareí|SP": "3518503",
"Ribeirão Pires|SP": "3543303",
"Presidente Prudente|SP": "3541406",
"Guaíra|SP": "3517406",
"Guaraçaí|SP": "3517802",
"Angatuba|SP": "3502200",
"Anhembi|SP": "3502309",
"Anhumas|SP": "3502408",
"Aparecida|SP": "3502507",
"Guaratinguetá|SP": "3518404",
"Palmeira d'Oeste|SP": "3535200",
"Aparecida d'Oeste|SP": "3502606",
"Apiaí|SP": "3502705",
"Araçariguama|SP": "3502754",
"Mairinque|SP": "3528403",
"Araçatuba|SP": "3502804",
"Santo Antônio do Aracanguá|SP": "3548054",
"Buritama|SP": "3508108",
"Lins|SP": "3527108",
"Bilac|SP": "3506409",
"Suzanápolis|SP": "3552551",
"Ilha Solteira|SP": "3520442",
"Fernandópolis|SP": "3515509",
"Birigui|SP": "3506508",
"Braúna|SP": "3507704",
"Riolândia|SP": "3544202",
"Araçoiaba da Serra|SP": "3502903",
"Aramina|SP": "3503000",
"Arandu|SP": "3503109",
"Arapeí|SP": "3503158",
"Matão|SP": "3529302",
"Araras|SP": "3503307",
"Leme|SP": "3526704",
"Conchal|SP": "3512209",
"Arco-Íris|SP": "3503356",
"Areias|SP": "3503505",
"Areiópolis|SP": "3503604",
"Ariranha|SP": "3503703",
"Arujá|SP": "3503901",
"Itaquaquecetuba|SP": "3523107",
"Santa Isabel|SP": "3546801",
"Aspásia|SP": "3503950",
"Assis|SP": "3504008",
"Ourinhos|SP": "3534708",
"São José do Rio Preto|SP": "3549805",
"Palmital|SP": "3535309",
"Tarumã|SP": "3553955",
"Cândido Mota|SP": "3510005",
"Maracaí|SP": "3528809",
"Guarantã|SP": "3518107",
"Marabá Paulista|SP": "3528700",
"Florínea|SP": "3516101",
"Irapuru|SP": "3521606",
"Porangaba|SP": "3540507",
"Flórida Paulista|SP": "3516002",
"Paraguaçu Paulista|SP": "3535507",
"Atibaia|SP": "3504107",
"Mairiporã|SP": "3528502",
"Bragança Paulista|SP": "3507605",
"Nazaré Paulista|SP": "3532405",
"Piracaia|SP": "3538600",
"Jarinu|SP": "3525201",
"Itupeva|SP": "3524006",
"Bom Jesus dos Perdões|SP": "3507100",
"Auriflama|SP": "3504206",
"Avaí|SP": "3504305",
"Embu das Artes|SP": "3515004",
"Pirajuí|SP": "3538907",
"Balbinos|SP": "3504701",
"Botucatu|SP": "3507506",
"Avaré|SP": "3504503",
"São Manuel|SP": "3550100",
"Fartura|SP": "3515400",
"Itaí|SP": "3521804",
"Piraju|SP": "3538808",
"Franca|SP": "3516200",
"Manduri|SP": "3528601",
"Rio Claro|SP": "3543907",
"Itirapina|SP": "3523602",
"Bady Bassitt|SP": "3504602",
"Várzea Paulista|SP": "3556503",
"Presidente Venceslau|SP": "3541505",
"Bariri|SP": "3505203",
"Mauá|SP": "3529401",
"Sertãozinho|SP": "3551702",
"Bálsamo|SP": "3504800",
"Barão de Antonina|SP": "3505005",
"Barbosa|SP": "3505104",
"Barra do Chapéu|SP": "3505351",
"Barra do Turvo|SP": "3505401",
"Barretos|SP": "3505500",
"Olímpia|SP": "3533908",
"Guaraci|SP": "3517901",
"Colômbia|SP": "3512100",
"Colina|SP": "3512001",
"Jaborandi|SP": "3524204",
"Vista Alegre do Alto|SP": "3556909",
"Terra Roxa|SP": "3554409",
"Bebedouro|SP": "3506102",
"Monte Azul Paulista|SP": "3531506",
"Piedade|SP": "3537800",
"Barrinha|SP": "3505609",
"Barueri|SP": "3505708",
"Santana de Parnaíba|SP": "3547304",
"Jandira|SP": "3525003",
"Pirapora do Bom Jesus|SP": "3539103",
"Cajamar|SP": "3509205",
"Urânia|SP": "3555802",
"Bofete|SP": "3506904",
"Jaguariúna|SP": "3524709",
"Bastos|SP": "3505807",
"Batatais|SP": "3505906",
"Piratininga|SP": "3539400",
"Pederneiras|SP": "3536703",
"Duartina|SP": "3514502",
"Macatuba|SP": "3528007",
"Paulistânia|SP": "3536570",
"Presidente Alves|SP": "3541109",
"Reginópolis|SP": "3542503",
"Taquaritinga|SP": "3553708",
"Lucianópolis|SP": "3527504",
"Santa Cruz do Rio Pardo|SP": "3546405",
"Rio Grande da Serra|SP": "3544103",
"Cabreúva|SP": "3508405",
"Itaju|SP": "3522000",
"Itajobi|SP": "3521903",
"Santo André|SP": "3547809",
"Franco da Rocha|SP": "3516408",
"Guarujá|SP": "3518701",
"Mococa|SP": "3530508",
"Pacaembu|SP": "3534906",
"Cubatão|SP": "3513504",
"Ubatuba|SP": "3555406",
"São Bernardo do Campo|SP": "3548708",
"Itatinga|SP": "3523503",
"São Sebastião|SP": "3550704",
"Taquarituba|SP": "3553807",
"Porto Feliz|SP": "3540606",
"Promissão|SP": "3541604",
"Borebi|SP": "3507456",
"Taquaral|SP": "3553658",
"Taiaçu|SP": "3553104",
"Taiúva|SP": "3553203",
"Viradouro|SP": "3556800",
"Paraíso|SP": "3535705",
"Bento de Abreu|SP": "3506201",
"Óleo|SP": "3533809",
"Bertioga|SP": "3506359",
"Registro|SP": "3542602",
"Catanduva|SP": "3511102",
"Santópolis do Aguapeí|SP": "3548401",
"Biritiba Mirim|SP": "3506607",
"Bocaina|SP": "3506805",
"Boituva|SP": "3507001",
"Bom Sucesso de Itararé|SP": "3507159",
"Borá|SP": "3507209",
"Boracéia|SP": "3507308",
"Borborema|SP": "3507407",
"Conchas|SP": "3512308",
"Pardinho|SP": "3536109",
"Laranjal Paulista|SP": "3526407",
"Tejupá|SP": "3554201",
"Paranapanema|SP": "3535804",
"Torre de Pedra|SP": "3554656",
"Pereiras|SP": "3537503",
"Itapeva|SP": "3522406",
"Taguaí|SP": "3553005",
"Pratânia|SP": "3541059",
"São Roque|SP": "3550605",
"Itu|SP": "3523909",
"São Pedro|SP": "3550407",
"Valparaíso|SP": "3556305",
"Tietê|SP": "3554508",
"São Pedro do Turvo|SP": "3550506",
"Penápolis|SP": "3537305",
"Tupã|SP": "3555000",
"Pinhalzinho|SP": "3538204",
"Socorro|SP": "3552106",
"Tuiuti|SP": "3554953",
"Joanópolis|SP": "3525508",
"Vargem|SP": "3556354",
"Louveira|SP": "3527306",
"Brejo Alegre|SP": "3507753",
"Brodowski|SP": "3507803",
"Pitangueiras|SP": "3539509",
"Brotas|SP": "3507902",
"Buri|SP": "3508009",
"Lourdes|SP": "3527256",
"Buritizal|SP": "3508207",
"Cabrália Paulista|SP": "3508306",
"Jundiaí|SP": "3525904",
"Taubaté|SP": "3554102",
"Jambeiro|SP": "3524907",
"Cachoeira Paulista|SP": "3508603",
"Caconde|SP": "3508702",
"Cafelândia|SP": "3508801",
"Pongaí|SP": "3540101",
"Caiabu|SP": "3508900",
"Caieiras|SP": "3509007",
"Caiuá|SP": "3509106",
"Osvaldo Cruz|SP": "3534609",
"Pracinha|SP": "3540853",
"Junqueirópolis|SP": "3526001",
"Campo Limpo Paulista|SP": "3509601",
"Cajati|SP": "3509254",
"Cajobi|SP": "3509304",
"Cajuru|SP": "3509403",
"Campina do Monte Alegre|SP": "3509452",
"Itapira|SP": "3522604",
"Mogi Guaçu|SP": "3530706",
"Vinhedo|SP": "3556701",
"Valinhos|SP": "3556206",
"Santo Antônio de Posse|SP": "3548005",
"Nova Odessa|SP": "3533403",
"Capela do Alto|SP": "3510302",
"Monte Mor|SP": "3531803",
"Mombuca|SP": "3530904",
"Lucélia|SP": "3527405",
"Mogi Mirim|SP": "3530805",
"Espírito Santo do Pinhal|SP": "3515186",
"Capivari|SP": "3510401",
"Limeira|SP": "3526902",
"Holambra|SP": "3519055",
"Iracemápolis|SP": "3521408",
"Capão Bonito|SP": "3510203",
"Serra Negra|SP": "3551603",
"Lindóia|SP": "3527009",
"Tambaú|SP": "3553302",
"Santa Maria da Serra|SP": "3547007",
"Tapiratiba|SP": "3553609",
"Vargem Grande do Sul|SP": "3556404",
"Casa Branca|SP": "3510807",
"Elias Fausto|SP": "3514908",
"Santa Clara d'Oeste|SP": "3546108",
"Engenheiro Coelho|SP": "3515152",
"São Sebastião da Grama|SP": "3550803",
"Divinolândia|SP": "3513900",
"Santa Gertrudes|SP": "3546702",
"Itobi|SP": "3523800",
"Santo Antônio do Pinhal|SP": "3548203",
"Paraibuna|SP": "3535606",
"Campos Novos Paulista|SP": "3509809",
"Cananéia|SP": "3509908",
"Canas|SP": "3509957",
"Cândido Rodrigues|SP": "3510104",
"Canitar|SP": "3510153",
"Cesário Lange|SP": "3511607",
"Rafard|SP": "3542107",
"Caraguatatuba|SP": "3510500",
"Miracatu|SP": "3529906",
"Cardoso|SP": "3510708",
"Pedregulho|SP": "3537008",
"Cássia dos Coqueiros|SP": "3510906",
"Palmares Paulista|SP": "3535101",
"Novo Horizonte|SP": "3533502",
"Fernando Prestes|SP": "3515608",
"Tabapuã|SP": "3552601",
"Irapuã|SP": "3521507",
"Pindorama|SP": "3538105",
"Sales|SP": "3544806",
"Embaúba|SP": "3514957",
"Nova Granada|SP": "3533007",
"Ibirá|SP": "3519402",
"Catiguá|SP": "3511201",
"Pirangi|SP": "3539004",
"Cedral|SP": "3511300",
"Cerquilho|SP": "3511508",
"Charqueada|SP": "3511706",
"Clementina|SP": "3511904",
"Cordeirópolis|SP": "3512407",
"Coroados|SP": "3512506",
"Coronel Macedo|SP": "3512605",
"Corumbataí|SP": "3512704",
"Cosmorama|SP": "3512902",
"Ibiúna|SP": "3519709",
"Vargem Grande Paulista|SP": "3556453",
"Cristais Paulista|SP": "3513207",
"Cruzália|SP": "3513306",
"São José do Barreiro|SP": "3549607",
"Lavrinhas|SP": "3526605",
"Queluz|SP": "3541901",
"Pindamonhangaba|SP": "3538006",
"Cunha|SP": "3513603",
"Votorantim|SP": "3557006",
"Dirce Reis|SP": "3513850",
"Dois Córregos|SP": "3514106",
"Dolcinópolis|SP": "3514205",
"Dracena|SP": "3514403",
"Chavantes|SP": "3557204",
"Presidente Epitácio|SP": "3541307",
"Martinópolis|SP": "3529203",
"São João do Pau d'Alho|SP": "3549300",
"Dumont|SP": "3514601",
"Echaporã|SP": "3514700",
"Eldorado|SP": "3514809",
"Elisiário|SP": "3514924",
"Juquitiba|SP": "3526209",
"Embu-Guaçu|SP": "3515103",
"Emilianópolis|SP": "3515129",
"Espírito Santo do Turvo|SP": "3515194",
"Estrela d'Oeste|SP": "3515202",
"Estrela do Norte|SP": "3515301",
"Euclides da Cunha Paulista|SP": "3515350",
"Jales|SP": "3524808",
"Pedranópolis|SP": "3536901",
"Guarani d'Oeste|SP": "3518008",
"Santa Fé do Sul|SP": "3546603",
"Paranapuã|SP": "3535903",
"Macedônia|SP": "3528205",
"São João das Duas Pontes|SP": "3549201",
"Fernão|SP": "3515657",
"Poá|SP": "3539806",
"Flora Rica|SP": "3515806",
"Floreal|SP": "3515905",
"Morro Agudo|SP": "3531902",
"São Caetano do Sul|SP": "3548807",
"Gabriel Monteiro|SP": "3516507",
"Gália|SP": "3516606",
"Garça|SP": "3516705",
"Ocauçu|SP": "3533700",
"Ubirajara|SP": "3555505",
"Gavião Peixoto|SP": "3516853",
"General Salgado|SP": "3516903",
"Guaimbê|SP": "3517307",
"Glicério|SP": "3517109",
"Guaiçara|SP": "3517208",
"Guapiaçu|SP": "3517505",
"Guapiara|SP": "3517604",
"Guará|SP": "3517703",
"Guararapes|SP": "3518206",
"Guararema|SP": "3518305",
"Potim|SP": "3540754",
"Guariba|SP": "3518602",
"Mogi das Cruzes|SP": "3530607",
"Guatapará|SP": "3518859",
"Guzolândia|SP": "3518909",
"Herculândia|SP": "3519006",
"Mirassol|SP": "3530300",
"Iacanga|SP": "3519105",
"Iacri|SP": "3519204",
"Ibirarema|SP": "3519501",
"Icém|SP": "3519808",
"Iepê|SP": "3519907",
"Igaratá|SP": "3520202",
"Iguape|SP": "3520301",
"Ilha Comprida|SP": "3520426",
"Ilhabela|SP": "3520400",
"Indiana|SP": "3520608",
"Indiaporã|SP": "3520707",
"Inúbia Paulista|SP": "3520806",
"Ipaussu|SP": "3520905",
"Ipeúna|SP": "3521101",
"Ipiguá|SP": "3521150",
"Iporanga|SP": "3521200",
"Ipuã|SP": "3521309",
"Rancharia|SP": "3542206",
"Itaberá|SP": "3521705",
"Itariri|SP": "3523305",
"Pedro de Toledo|SP": "3537206",
"Itaoca|SP": "3522158",
"São Miguel Arcanjo|SP": "3550209",
"Sarapuí|SP": "3551108",
"Ribeirão Branco|SP": "3543006",
"Nova Campina|SP": "3532827",
"Itapirapuã Paulista|SP": "3522653",
"Itapuí|SP": "3522901",
"Itapura|SP": "3523008",
"Itararé|SP": "3523206",
"Pirassununga|SP": "3539301",
"Salto de Pirapora|SP": "3545308",
"Itirapuã|SP": "3523701",
"Ituverava|SP": "3524105",
"Monte Alto|SP": "3531308",
"São Luiz do Paraitinga|SP": "3550001",
"Santa Branca|SP": "3546009",
"Jaci|SP": "3524501",
"Jacupiranga|SP": "3524600",
"Nova Canaã Paulista|SP": "3532843",
"Santa Albertina|SP": "3545704",
"São Francisco|SP": "3549003",
"Santa Salete|SP": "3547650",
"Pontal|SP": "3540200",
"Jeriquara|SP": "3525409",
"João Ramalho|SP": "3525607",
"José Bonifácio|SP": "3525706",
"Júlio Mesquita|SP": "3525805",
"Jumirim|SP": "3525854",
"Juquiá|SP": "3526100",
"Lagoinha|SP": "3526308",
"Santa Cruz da Conceição|SP": "3546207",
"Luís Antônio|SP": "3527603",
"Luiziânia|SP": "3527702",
"Lupércio|SP": "3527801",
"Lutécia|SP": "3527900",
"Macaubal|SP": "3528106",
"Magda|SP": "3528304",
"Marapoama|SP": "3528858",
"Mariápolis|SP": "3528908",
"Oriente|SP": "3534104",
"Vera Cruz|SP": "3556602",
"Oscar Bressane|SP": "3534500",
"Pompéia|SP": "3540002",
"Rinópolis|SP": "3543808",
"Parapuã|SP": "3536000",
"Mendonça|SP": "3529500",
"Meridiano|SP": "3529609",
"Mesópolis|SP": "3529658",
"Mira Estrela|SP": "3530003",
"Murutinga do Sul|SP": "3532108",
"Mirante do Paranapanema|SP": "3530201",
"Tanabi|SP": "3553401",
"Monte Aprazível|SP": "3531407",
"Mirassolândia|SP": "3530409",
"Estiva Gerbi|SP": "3557303",
"Monte Alegre do Sul|SP": "3531209",
"Monte Castelo|SP": "3531605",
"Monteiro Lobato|SP": "3531704",
"Nantes|SP": "3532157",
"Narandiba|SP": "3532207",
"Natividade da Serra|SP": "3532306",
"Neves Paulista|SP": "3532504",
"Nhandeara|SP": "3532603",
"Nipoã|SP": "3532702",
"Nova Guataporanga|SP": "3533106",
"Nova Independência|SP": "3533205",
"Novais|SP": "3533254",
"Nova Luzitânia|SP": "3533304",
"Nuporanga|SP": "3533601",
"Onda Verde|SP": "3534005",
"Orindiúva|SP": "3534203",
"Orlândia|SP": "3534302",
"São Joaquim da Barra|SP": "3549409",
"Salto Grande|SP": "3545407",
"Ribeirão do Sul|SP": "3543204",
"Ouroeste|SP": "3534757",
"Ouro Verde|SP": "3534807",
"Palestina|SP": "3535002",
"Panorama|SP": "3535408",
"Pariquera-Açu|SP": "3536208",
"Sete Barras|SP": "3551801",
"Parisi|SP": "3536257",
"Patrocínio Paulista|SP": "3536307",
"Paulicéia|SP": "3536406",
"Paulo de Faria|SP": "3536604",
"Pedrinhas Paulista|SP": "3537156",
"Piacatu|SP": "3537701",
"Pilar do Sul|SP": "3537909",
"Piquerobi|SP": "3538303",
"Piquete|SP": "3538501",
"Saltinho|SP": "3545159",
"Rio das Pedras|SP": "3544004",
"Sarutaiá|SP": "3551207",
"Pirapozinho|SP": "3539202",
"Planalto|SP": "3539608",
"Platina|SP": "3539707",
"Poloni|SP": "3539905",
"Quintana|SP": "3542008",
"Pontalinda|SP": "3540259",
"Pontes Gestal|SP": "3540309",
"Populina|SP": "3540408",
"Potirendaba|SP": "3540804",
"Santo Anastácio|SP": "3547700",
"Regente Feijó|SP": "3542404",
"Teodoro Sampaio|SP": "3554300",
"Taciba|SP": "3552908",
"Sandovalina|SP": "3545506",
"Tarabai|SP": "3553906",
"Quatá|SP": "3541703",
"Santo Expedito|SP": "3548302",
"Rosana|SP": "3544251",
"Quadra|SP": "3541653",
"Queiroz|SP": "3541802",
"Redenção da Serra|SP": "3542305",
"Restinga|SP": "3542701",
"Ribeira|SP": "3542800",
"Ribeirão Corrente|SP": "3543105",
"Ribeirão dos Índios|SP": "3543238",
"Ribeirão Grande|SP": "3543253",
"Santa Rosa de Viterbo|SP": "3547601",
"Santo Antônio da Alegria|SP": "3547908",
"São Simão|SP": "3550902",
"Santa Rita do Passa Quatro|SP": "3547502",
"Santa Cruz da Esperança|SP": "3546256",
"São José da Bela Vista|SP": "3549508",
"Sales Oliveira|SP": "3544905",
"Riversul|SP": "3543501",
"Rifaina|SP": "3543600",
"Rincão|SP": "3543709",
"Roseira|SP": "3544301",
"Rubiácea|SP": "3544400",
"Rubinéia|SP": "3544509",
"Sabino|SP": "3544608",
"Sagres|SP": "3544707",
"Salesópolis|SP": "3545001",
"Salmourão|SP": "3545100",
"Santa Adélia|SP": "3545605",
"Santa Rita d'Oeste|SP": "3547403",
"Santa Ernestina|SP": "3546504",
"Três Fronteiras|SP": "3554904",
"Santa Mercedes|SP": "3547106",
"Santana da Ponte Pensa|SP": "3547205",
"Santo Antônio do Jardim|SP": "3548104",
"São Bento do Sapucaí|SP": "3548609",
"São João de Iracema|SP": "3549250",
"Uchoa|SP": "3555604",
"Valentim Gentil|SP": "3556107",
"Votuporanga|SP": "3557105",
"Ubarana|SP": "3555356",
"União Paulista|SP": "3555703",
"Urupês|SP": "3556008",
"São Lourenço da Serra|SP": "3549953",
"Taquarivaí|SP": "3553856",
"Torrinha|SP": "3554706",
"Sebastianópolis do Sul|SP": "3551306",
"Silveiras|SP": "3552007",
"Sud Mennucci|SP": "3552304",
"Tabatinga|SP": "3552700",
"Tapiraí|SP": "3553500",
"Timburi|SP": "3554607",
"Trabiju|SP": "3554755",
"Turiúba|SP": "3555208",
"Turmalina|SP": "3555307",
"Uru|SP": "3555901",
"Vitória Brasil|SP": "3556958",
"Zacarias|SP": "3557154",
"Abatiá|PR": "4100103",
"Adrianópolis|PR": "4100202",
"Agudos do Sul|PR": "4100301",
"Almirante Tamandaré|PR": "4100400",
"Paranaguá|PR": "4118204",
"Altamira do Paraná|PR": "4100459",
"Altônia|PR": "4100509",
"Alto Paraná|PR": "4100608",
"Alvorada do Sul|PR": "4100806",
"Amaporã|PR": "4100905",
"Ampére|PR": "4101002",
"Realeza|PR": "4121406",
"Anahy|PR": "4101051",
"Andirá|PR": "4101101",
"Ventania|PR": "4128534",
"Ibaiti|PR": "4109708",
"Santo Antônio da Platina|PR": "4124103",
"Nova Fátima|PR": "4117008",
"Ângulo|PR": "4101150",
"Antonina|PR": "4101200",
"Antônio Olinto|PR": "4101309",
"Apucarana|PR": "4101408",
"Cambira|PR": "4103800",
"São João do Ivaí|PR": "4125001",
"Califórnia|PR": "4103503",
"Bom Sucesso|PR": "4103206",
"Marumbi|PR": "4115507",
"Borrazópolis|PR": "4103305",
"Faxinal|PR": "4107603",
"Marilândia do Sul|PR": "4114906",
"São Pedro do Ivaí|PR": "4125803",
"Mauá da Serra|PR": "4115754",
"Jandaia do Sul|PR": "4112108",
"Arapongas|PR": "4101507",
"Godoy Moreira|PR": "4108551",
"Sabáudia|PR": "4122701",
"Rolândia|PR": "4122404",
"Manoel Ribas|PR": "4114500",
"Arapoti|PR": "4101606",
"Jaguariaíva|PR": "4112009",
"Arapuã|PR": "4101655",
"Araruna|PR": "4101705",
"Lapa|PR": "4113205",
"Araucária|PR": "4101804",
"Matinhos|PR": "4115705",
"Contenda|PR": "4106209",
"Curiúva|PR": "4107009",
"Piraquara|PR": "4119509",
"Fazenda Rio Grande|PR": "4107652",
"Ariranha do Ivaí|PR": "4101853",
"São Jerônimo da Serra|PR": "4124707",
"Assaí|PR": "4101903",
"Assis Chateaubriand|PR": "4102000",
"Tupãssi|PR": "4127957",
"Porecatu|PR": "4120002",
"Astorga|PR": "4102109",
"Ibiporã|PR": "4109807",
"Atalaia|PR": "4102208",
"Balsa Nova|PR": "4102307",
"Campo Largo|PR": "4104204",
"Bandeirantes|PR": "4102406",
"Jacarezinho|PR": "4111803",
"Londrina|PR": "4113700",
"Itambaracá|PR": "4111001",
"Santa Amélia|PR": "4123105",
"Ribeirão do Pinhal|PR": "4121901",
"Corumbataí do Sul|PR": "4106555",
"Barbosa Ferraz|PR": "4102505",
"Barracão|PR": "4102604",
"Campos Novos|SC": "4203600",
"Barra do Jacaré|PR": "4102703",
"Bela Vista da Caroba|PR": "4102752",
"Bela Vista do Paraíso|PR": "4102802",
"Bituruna|PR": "4102901",
"Boa Esperança|PR": "4103008",
"Boa Esperança do Iguaçu|PR": "4103024",
"Boa Ventura de São Roque|PR": "4103040",
"Boa Vista da Aparecida|PR": "4103057",
"Bocaiúva do Sul|PR": "4103107",
"Lunardelli|PR": "4113759",
"Bom Jesus do Sul|PR": "4103156",
"Bom Sucesso do Sul|PR": "4103222",
"Braganey|PR": "4103354",
"Brasilândia do Sul|PR": "4103370",
"Cafeara|PR": "4103404",
"Cafelândia|PR": "4103453",
"Toledo|PR": "4127700",
"Cafezal do Sul|PR": "4103479",
"Cambará|PR": "4103602",
"Cambé|PR": "4103701",
"Lupionópolis|PR": "4113809",
"Florestópolis|PR": "4108007",
"Campina da Lagoa|PR": "4103909",
"Nova Cantu|PR": "4116802",
"Guaraniaçu|PR": "4109302",
"Campina do Simão|PR": "4103958",
"Campina Grande do Sul|PR": "4104006",
"Cândido de Abreu|PR": "4104402",
"Colombo|PR": "4105805",
"Quatro Barras|PR": "4120804",
"Pinhais|PR": "4119152",
"Guaratuba|PR": "4109609",
"Itaperuçu|PR": "4111258",
"Morretes|PR": "4116208",
"Colorado|PR": "4105904",
"Jundiaí do Sul|PR": "4112900",
"Rio Branco do Sul|PR": "4122206",
"Ivatuba|PR": "4111605",
"Telêmaco Borba|PR": "4127106",
"Sarandi|PR": "4126256",
"Guaraqueçaba|PR": "4109500",
"Castro|PR": "4104907",
"Tijucas do Sul|PR": "4127601",
"Cerro Azul|PR": "4105201",
"Mandirituba|PR": "4114302",
"Piên|PR": "4119103",
"Rio Negro|PR": "4122305",
"Sengés|PR": "4126306",
"Clevelândia|PR": "4105706",
"Palmeira|PR": "4117701",
"Ponta Grossa|PR": "4119905",
"Cruz Machado|PR": "4106803",
"Campo Bonito|PR": "4104055",
"Campo do Tenente|PR": "4104105",
"Campo Magro|PR": "4104253",
"Carambeí|PR": "4104659",
"Carlópolis|PR": "4104709",
"Ipiranga|PR": "4110508",
"Piraí do Sul|PR": "4119400",
"Espigão Alto do Iguaçu|PR": "4107546",
"Quitandinha|PR": "4121208",
"Prudentópolis|PR": "4120606",
"Terra Rica|PR": "4127304",
"Turvo|PR": "4127965",
"Mallet|PR": "4113908",
"Paranavaí|PR": "4118402",
"Dois Vizinhos|PR": "4107207",
"Reserva|PR": "4121703",
"Laranjeiras do Sul|PR": "4113304",
"Várzea Grande|MT": "5108402",
"Ortigueira|PR": "4117305",
"Ivaí|PR": "4111407",
"São João do Triunfo|PR": "4125100",
"José Boiteux|SC": "4209151",
"Irati|PR": "4110706",
"Guarapuava|PR": "4109401",
"Porto Amazonas|PR": "4120101",
"Tibagi|PR": "4127502",
"União da Vitória|PR": "4128203",
"Santa Maria do Oeste|PR": "4123857",
"General Carneiro|PR": "4108502",
"São José da Boa Vista|PR": "4125407",
"Palmital|PR": "4117800",
"Pitanga|PR": "4119608",
"Campo Mourão|PR": "4104303",
"Peabiru|PR": "4118808",
"Ubiratã|PR": "4128005",
"Goioerê|PR": "4108601",
"Candói|PR": "4104428",
"Cantagalo|PR": "4104451",
"Capanema|PR": "4104501",
"Capitão Leônidas Marques|PR": "4104600",
"Palotina|PR": "4117909",
"Guaíra|PR": "4108809",
"Corbélia|PR": "4106308",
"Nova Andradina|MS": "5006200",
"Terra Roxa|PR": "4127403",
"Formosa do Oeste|PR": "4108205",
"Cotriguaçu|MT": "5103379",
"Quedas do Iguaçu|PR": "4120903",
"Santa Lúcia|PR": "4123824",
"Marechal Cândido Rondon|PR": "4114609",
"Três Barras do Paraná|PR": "4127858",
"Iracema do Oeste|PR": "4110656",
"Iguatu|PR": "4110052",
"São Miguel do Iguaçu|PR": "4125704",
"Santa Tereza do Oeste|PR": "4124020",
"Novo Hamburgo|RS": "4313409",
"Cianorte|PR": "4105508",
"Nova Aurora|PR": "4116703",
"Ibema|PR": "4109757",
"Terra Boa|PR": "4127205",
"Nova Laranjeiras|PR": "4117057",
"Alto Piquiri|PR": "4100707",
"Dourados|MS": "5003702",
"Catanduvas|PR": "4105003",
"Dom Pedrito|RS": "4306601",
"Chopinzinho|PR": "4105409",
"Itaipulândia|PR": "4110953",
"Maripá|PR": "4115358",
"Juranda|PR": "4112959",
"Céu Azul|PR": "4105300",
"Pranchita|PR": "4120358",
"Francisco Beltrão|PR": "4108403",
"Pato Branco|PR": "4118501",
"Vera Cruz do Oeste|PR": "4128559",
"Diamante D'Oeste|PR": "4107157",
"Pato Bragado|PR": "4118451",
"Lindoeste|PR": "4113452",
"Mundo Novo|MS": "5005681",
"Rebouças|PR": "4121505",
"Centenário do Sul|PR": "4105102",
"São João|PR": "4124806",
"Japurá|PR": "4112405",
"Tapejara|PR": "4126801",
"Cidade Gaúcha|PR": "4105607",
"Criciúma|SC": "4204608",
"Tunas do Paraná|PR": "4127882",
"Paranacity|PR": "4118105",
"Santo Inácio|PR": "4124509",
"Nossa Senhora das Graças|PR": "4116406",
"Munhoz de Melo|PR": "4116307",
"Jardim Olinda|PR": "4112603",
"Itaguajé|PR": "4110904",
"Paranapoema|PR": "4118303",
"Lobato|PR": "4113601",
"Congonhinhas|PR": "4106001",
"Conselheiro Mairinck|PR": "4106100",
"Ponta Porã|MS": "5006606",
"Cornélio Procópio|PR": "4106407",
"Santa Mariana|PR": "4123907",
"São Sebastião da Amoreira|PR": "4126009",
"Santa Cecília do Pavão|PR": "4123204",
"Uraí|PR": "4128401",
"Figueira|PR": "4107751",
"Nova América da Colina|PR": "4116604",
"Nova Santa Bárbara|PR": "4117214",
"Coronel Domingos Soares|PR": "4106456",
"Coronel Vivida|PR": "4106506",
"Cruzeiro do Iguaçu|PR": "4106571",
"Cruzeiro do Oeste|PR": "4106605",
"Cruzeiro do Sul|PR": "4106704",
"Cruzmaltina|PR": "4106852",
"São Francisco do Sul|SC": "4216206",
"Barra do Bugres|MT": "5101704",
"Itapema|SC": "4208302",
"Pinhão|PR": "4119301",
"Mariópolis|PR": "4115309",
"Ivaiporã|PR": "4111506",
"Itajaí|SC": "4208203",
"Imbaú|PR": "4110078",
"Marmeleiro|PR": "4115408",
"Rio Bonito do Iguaçu|PR": "4122156",
"Paraíso do Norte|PR": "4118006",
"São Mateus do Sul|PR": "4125605",
"Fênix|PR": "4107702",
"Imbituva|PR": "4110102",
"Goioxim|PR": "4108650",
"Cristalina|GO": "5206206",
"Wenceslau Braz|PR": "4128500",
"Mato Rico|PR": "4115739",
"Inácio Martins|PR": "4110201",
"Valparaíso de Goiás|GO": "5221858",
"Curitibanos|SC": "4204806",
"Laranjal|PR": "4113254",
"Rio Azul|PR": "4122008",
"Siqueira Campos|PR": "4126603",
"Vitorino|PR": "4128708",
"Mafra|SC": "4210100",
"Primavera do Leste|MT": "5107040",
"Jardim Alegre|PR": "4112504",
"Rio Negrinho|SC": "4215000",
"Nova Esperança|PR": "4116901",
"Kaloré|PR": "4113106",
"Umuarama|PR": "4128104",
"Itapoá|SC": "4208450",
"Marialva|PR": "4114807",
"Querência do Norte|PR": "4121000",
"Sapiranga|RS": "4319901",
"Penha|SC": "4212502",
"Diamante do Norte|PR": "4107108",
"Diamante do Sul|PR": "4107124",
"Douradina|PR": "4107256",
"Paiçandu|PR": "4117503",
"Doutor Camargo|PR": "4107306",
"Enéas Marques|PR": "4107405",
"Engenheiro Beltrão|PR": "4107504",
"Esperança Nova|PR": "4107520",
"Entre Rios do Oeste|PR": "4107538",
"Farol|PR": "4107553",
"Fernandes Pinheiro|PR": "4107736",
"Floraí|PR": "4107801",
"Flor da Serra do Sul|PR": "4107850",
"Floresta|PR": "4107900",
"Flórida|PR": "4108106",
"Santa Terezinha de Itaipu|PR": "4124053",
"Naviraí|MS": "5005707",
"Medianeira|PR": "4115804",
"Missal|PR": "4116059",
"Santana do Itararé|PR": "4124004",
"Navegantes|SC": "4211306",
"São Jorge d'Oeste|PR": "4125209",
"Santa Helena|PR": "4123501",
"Ramilândia|PR": "4121257",
"Francisco Alves|PR": "4108320",
"Salto do Lontra|PR": "4123006",
"Planalto|PR": "4119806",
"Santo Antônio do Sudoeste|PR": "4124400",
"Dionísio Cerqueira|SC": "4205001",
"Verê|PR": "4128609",
"Renascença|PR": "4121604",
"Foz do Jordão|PR": "4108452",
"Moreira Sales|PR": "4116109",
"Rancho Alegre D'Oeste|PR": "4121356",
"Grandes Rios|PR": "4108700",
"Rondonópolis|MT": "5107602",
"Eldorado|MS": "5003751",
"Guairaçá|PR": "4108908",
"Guamiranga|PR": "4108957",
"Guapirama|PR": "4109005",
"Guaporema|PR": "4109104",
"Guaraci|PR": "4109203",
"Reserva do Iguaçu|PR": "4121752",
"Paranatinga|MT": "5106307",
"Porto Barreiro|PR": "4120150",
"Virmond|PR": "4128658",
"Garuva|SC": "4205803",
"Honório Serpa|PR": "4109658",
"Pinhalão|PR": "4119202",
"Jataizinho|PR": "4112702",
"Icaraíma|PR": "4109906",
"Iguaraçu|PR": "4110003",
"Inajá|PR": "4110300",
"São João do Caiuá|PR": "4124905",
"Indianópolis|PR": "4110409",
"Iporã|PR": "4110607",
"Teixeira Soares|PR": "4127007",
"Iretama|PR": "4110805",
"Itambé|PR": "4111100",
"Itapejara d'Oeste|PR": "4111209",
"Itaúna do Sul|PR": "4111308",
"Lidianópolis|PR": "4113429",
"Rio Branco do Ivaí|PR": "4122172",
"Rosário do Ivaí|PR": "4122651",
"Nova Tebas|PR": "4117271",
"Ivaté|PR": "4111555",
"Japira|PR": "4112306",
"Jaguapitã|PR": "4111902",
"Janiópolis|PR": "4112207",
"Jesuítas|PR": "4112751",
"Joaquim Távora|PR": "4112801",
"Jussara|PR": "4113007",
"Porto União|SC": "4213609",
"Leópolis|PR": "4113403",
"Loanda|PR": "4113502",
"Sertanópolis|PR": "4126504",
"Tamarana|PR": "4126678",
"Primeiro de Maio|PR": "4120507",
"Pitangueiras|PR": "4119657",
"Quatiguá|PR": "4120705",
"Mandaguari|PR": "4114203",
"Prado Ferreira|PR": "4120333",
"Rio Bom|PR": "4122107",
"Miraselva|PR": "4116000",
"Novo Itacolomi|PR": "4117297",
"Luiziana|PR": "4113734",
"Mamborê|PR": "4114005",
"Mandaguaçu|PR": "4114104",
"Manfrinópolis|PR": "4114351",
"Mangueirinha|PR": "4114401",
"Maria Helena|PR": "4114708",
"Marilena|PR": "4115002",
"Mariluz|PR": "4115101",
"Santa Inês|PR": "4123600",
"Porto Rico|PR": "4120200",
"Presidente Castelo Branco|PR": "4120408",
"Mirador|PR": "4115903",
"São Sebastião do Caí|RS": "4319505",
"Costa Rica|MS": "5003256",
"Tuneiras do Oeste|PR": "4127908",
"Ourizona|PR": "4117404",
"Ilhota|SC": "4207106",
"Serranópolis do Iguaçu|PR": "4126355",
"Mercedes|PR": "4115853",
"Brusque|SC": "4202909",
"Nova Aliança do Ivaí|PR": "4116505",
"Nova Esperança do Sudoeste|PR": "4116950",
"Nova Londrina|PR": "4117107",
"Nova Olímpia|PR": "4117206",
"Nova Santa Rosa|PR": "4117222",
"Nova Prata do Iguaçu|PR": "4117255",
"Ouro Verde do Oeste|PR": "4117453",
"Lacerdópolis|SC": "4209201",
"Faxinalzinho|RS": "4308052",
"Iguatemi|MS": "5004304",
"São Carlos do Ivaí|PR": "4124608",
"Planaltina do Paraná|PR": "4119707",
"Pinhal de São Bento|PR": "4119251",
"Paula Freitas|PR": "4118600",
"Paulo Frontin|PR": "4118709",
"Perobal|PR": "4118857",
"Pérola|PR": "4118907",
"Pérola d'Oeste|PR": "4119004",
"Sertaneja|PR": "4126405",
"Porto Vitória|PR": "4120309",
"Quarto Centenário|PR": "4120655",
"Quatro Pontes|PR": "4120853",
"Quinta do Sol|PR": "4121109",
"Rancho Alegre|PR": "4121307",
"Salto do Itararé|PR": "4122909",
"Rondon|PR": "4122602",
"Salgado Filho|PR": "4122800",
"Araricá|RS": "4300877",
"Santa Cruz de Monte Castelo|PR": "4123303",
"Santa Fé|PR": "4123402",
"Santa Isabel do Ivaí|PR": "4123709",
"Santa Mônica|PR": "4123956",
"Santo Antônio do Caiuá|PR": "4124202",
"Santo Antônio do Paraíso|PR": "4124301",
"São Jorge do Ivaí|PR": "4125308",
"São Jorge do Patrocínio|PR": "4125357",
"São José das Palmeiras|PR": "4125456",
"São Manoel do Paraná|PR": "4125555",
"São Pedro do Iguaçu|PR": "4125753",
"São Pedro do Paraná|PR": "4125902",
"São Tomé|PR": "4126108",
"Sapopema|PR": "4126207",
"Saudade do Iguaçu|PR": "4126272",
"Sulina|PR": "4126652",
"Tamboara|PR": "4126702",
"Tapira|PR": "4126900",
"São Bento do Sul|SC": "4215802",
"Tomazina|PR": "4127809",
"Alto Paraíso|PR": "4128625",
"Xambrê|PR": "4128807",
"Uniflor|PR": "4128302",
"Doutor Ulysses|PR": "4128633",
"Abdon Batista|SC": "4200051",
"Abelardo Luz|SC": "4200101",
"Agrolândia|SC": "4200200",
"Água Doce|SC": "4200408",
"Águas de Chapecó|SC": "4200507",
"Águas Frias|SC": "4200556",
"Águas Mornas|SC": "4200606",
"Alfredo Wagner|SC": "4200705",
"Anchieta|SC": "4200804",
"Angelina|SC": "4200903",
"Anita Garibaldi|SC": "4201000",
"Anitápolis|SC": "4201109",
"Antônio Carlos|SC": "4201208",
"Apiúna|SC": "4201257",
"Arabutã|SC": "4201273",
"Araquari|SC": "4201307",
"Araranguá|SC": "4201406",
"Balneário Arroio do Silva|SC": "4201950",
"Balneário Gaivota|SC": "4202073",
"Sombrio|SC": "4217709",
"Passo de Torres|SC": "4212254",
"Santa Rosa do Sul|SC": "4215653",
"Maracajá|SC": "4210407",
"São João do Sul|SC": "4216404",
"Jacinto Machado|SC": "4208708",
"Imbituba|SC": "4207304",
"Turvo|SC": "4218806",
"Alvorada|RS": "4300604",
"Timbé do Sul|SC": "4218103",
"Nova Veneza|SC": "4211603",
"Gravatal|SC": "4206207",
"Cocal do Sul|SC": "4204251",
"Jaguaruna|SC": "4208807",
"Armazém|SC": "4201505",
"Arroio Trinta|SC": "4201604",
"Ascurra|SC": "4201703",
"Aurora|SC": "4201901",
"Porto Belo|SC": "4213500",
"Camboriú|SC": "4203204",
"Rio Grande|RS": "4315602",
"Barra Velha|SC": "4202107",
"Balneário Piçarras|SC": "4212809",
"Tijucas|SC": "4218004",
"Indaial|SC": "4207502",
"Bombinhas|SC": "4202453",
"Balneário Barra do Sul|SC": "4202057",
"Bandeirante|SC": "4202081",
"Bela Vista do Toldo|SC": "4202131",
"Belmonte|SC": "4202156",
"Benedito Novo|SC": "4202206",
"Timbó|SC": "4218202",
"Biguaçu|SC": "4202305",
"Palhoça|SC": "4211900",
"Gaspar|SC": "4205902",
"Guabiruba|SC": "4206306",
"Pomerode|SC": "4213203",
"Rio dos Cedros|SC": "4214706",
"Presidente Getúlio|SC": "4214003",
"Sorriso|MT": "5107925",
"Videira|SC": "4219309",
"São José|SC": "4216602",
"Major Gercino|SC": "4210209",
"São João Batista|SC": "4216305",
"Rio do Sul|SC": "4214805",
"Bom Jardim da Serra|SC": "4202503",
"Bom Jesus|SC": "4202537",
"Bom Retiro|SC": "4202602",
"Botuverá|SC": "4202701",
"São Ludgero|SC": "4217006",
"Braço do Norte|SC": "4202800",
"Santa Rosa de Lima|SC": "4215604",
"Grão-Pará|SC": "4206108",
"Braço do Trombudo|SC": "4202859",
"Brunópolis|SC": "4202875",
"Nova Trento|SC": "4211504",
"Caçador|SC": "4203006",
"Rio das Antas|SC": "4214409",
"Lebon Régis|SC": "4209706",
"Santa Cecília|SC": "4215505",
"Calmon|SC": "4203154",
"Caibi|SC": "4203105",
"Capão Alto|SC": "4203253",
"Campo Alegre|SC": "4203303",
"Campo Belo do Sul|SC": "4203402",
"Campo Erê|SC": "4203501",
"Canelinha|SC": "4203709",
"Canoinhas|SC": "4203808",
"Três Barras|SC": "4218301",
"Irineópolis|SC": "4207908",
"Major Vieira|SC": "4210308",
"Capinzal|SC": "4203907",
"Governador Celso Ramos|SC": "4206009",
"Capivari de Baixo|SC": "4203956",
"Catanduvas|SC": "4204004",
"Caxambu do Sul|SC": "4204103",
"Celso Ramos|SC": "4204152",
"Cerro Negro|SC": "4204178",
"Chapadão do Lageado|SC": "4204194",
"Chapecó|SC": "4204202",
"Xaxim|SC": "4219705",
"Planalto Alegre|SC": "4213153",
"Pinhalzinho|SC": "4212908",
"Maravilha|SC": "4210506",
"Seara|SC": "4217501",
"Ponte Serrada|SC": "4213401",
"São Domingos|SC": "4216107",
"Cunha Porã|SC": "4204707",
"Faxinal dos Guedes|SC": "4205308",
"Xavantina|SC": "4219606",
"Palmitos|SC": "4212106",
"São Carlos|SC": "4216008",
"São Miguel da Boa Vista|SC": "4217154",
"Quilombo|SC": "4214201",
"Irati|SC": "4207858",
"Entre Rios do Sul|RS": "4306957",
"São Miguel do Oeste|SC": "4217204",
"Nova Erechim|SC": "4211405",
"Ipuaçu|SC": "4207684",
"Arvoredo|SC": "4201653",
"Vargem|SC": "4219150",
"Formosa do Sul|SC": "4205431",
"Xanxerê|SC": "4219507",
"Nova Itaberaba|SC": "4211454",
"Saudades|SC": "4217303",
"Ipumirim|SC": "4207700",
"Concórdia|SC": "4204301",
"Joaçaba|SC": "4209003",
"Itá|SC": "4208005",
"Cordilheira Alta|SC": "4204350",
"Coronel Freitas|SC": "4204400",
"Coronel Martins|SC": "4204459",
"Corupá|SC": "4204509",
"Correia Pinto|SC": "4204558",
"Forquilhinha|SC": "4205456",
"Orleans|SC": "4211702",
"Meleiro|SC": "4210803",
"Cunhataí|SC": "4204756",
"Frei Rogério|SC": "4205555",
"São Cristóvão do Sul|SC": "4216057",
"Monte Carlo|SC": "4211058",
"Timbó Grande|SC": "4218251",
"Descanso|SC": "4204905",
"Dona Emma|SC": "4205100",
"Doutor Pedrinho|SC": "4205159",
"Erval Velho|SC": "4205209",
"Flor do Sertão|SC": "4205357",
"Alegrete|RS": "4300406",
"São Pedro de Alcântara|SC": "4217253",
"Santo Amaro da Imperatriz|SC": "4215703",
"Garopaba|SC": "4205704",
"Paulo Lopes|SC": "4212304",
"Pouso Redondo|SC": "4213708",
"Laguna|SC": "4209409",
"Imaruí|SC": "4207205",
"Monte Castelo|SC": "4211108",
"Tubarão|SC": "4218707",
"Morro da Fumaça|SC": "4211207",
"Urussanga|SC": "4219002",
"Urubici|SC": "4218905",
"Rodeio|SC": "4215109",
"Trombudo Central|SC": "4218608",
"Fraiburgo|SC": "4205506",
"Itapiranga|SC": "4208401",
"Ituporanga|SC": "4208500",
"Caxias do Sul|RS": "4305108",
"Urupema|SC": "4218954",
"Mirim Doce|SC": "4210852",
"Ibirama|SC": "4206900",
"Içara|SC": "4207007",
"São Leopoldo|RS": "4318705",
"Schroeder|SC": "4217402",
"Rio Rufino|SC": "4215059",
"Lauro Müller|SC": "4209607",
"Nova Hartz|RS": "4313060",
"Herval d'Oeste|SC": "4206702",
"Jaraguá do Sul|SC": "4208906",
"Santa Vitória do Palmar|RS": "4317301",
"Laurentino|SC": "4209508",
"Balneário Rincão|SC": "4220000",
"Rancho Queimado|SC": "4214300",
"Galvão|SC": "4205605",
"Guaraciaba|SC": "4206405",
"Guaramirim|SC": "4206504",
"Guarujá do Sul|SC": "4206603",
"Guatambú|SC": "4206652",
"Ibicaré|SC": "4206801",
"Vitor Meireles|SC": "4219358",
"Lontras|SC": "4209904",
"Siderópolis|SC": "4217600",
"Ipira|SC": "4207601",
"Iporã do Oeste|SC": "4207650",
"Iraceminha|SC": "4207759",
"Irani|SC": "4207809",
"Itaiópolis|SC": "4208104",
"Luiz Alves|SC": "4210001",
"Soledade|RS": "4320800",
"Santa Rosa|RS": "4317202",
"Salete|SC": "4215307",
"Leoberto Leal|SC": "4209805",
"Jaborá|SC": "4208609",
"Massaranduba|SC": "4210605",
"Treze Tílias|SC": "4218509",
"Luzerna|SC": "4210035",
"Ouro|SC": "4211801",
"Vargem Bonita|SC": "4219176",
"Papanduva|SC": "4212205",
"Maximiliano de Almeida|RS": "4312203",
"Jupiá|SC": "4209177",
"São José do Cerrito|SC": "4216800",
"Otacílio Costa|SC": "4211751",
"São Joaquim|SC": "4216503",
"Bocaina do Sul|SC": "4202438",
"Ponte Alta|SC": "4213302",
"Painel|SC": "4211892",
"Pescaria Brava|SC": "4212650",
"Lajeado Grande|SC": "4209458",
"Lindóia do Sul|SC": "4209854",
"Macieira|SC": "4210050",
"Ermo|SC": "4205191",
"Morro Grande|SC": "4211256",
"Modelo|SC": "4210902",
"Mondaí|SC": "4211009",
"Sangão|SC": "4215455",
"Novo Horizonte|SC": "4211652",
"Ouro Verde|SC": "4211850",
"Paial|SC": "4211876",
"Palma Sola|SC": "4212007",
"Palmeira|SC": "4212056",
"Paraíso|SC": "4212239",
"Passos Maia|SC": "4212270",
"Pedras Grandes|SC": "4212403",
"Petrolândia|SC": "4212700",
"Pinheiro Preto|SC": "4213005",
"Piratuba|SC": "4213104",
"Ponte Alta do Norte|SC": "4213351",
"Matos Costa|SC": "4210704",
"Praia Grande|SC": "4213807",
"Princesa|SC": "4214151",
"Rio do Campo|SC": "4214508",
"Rio do Oeste|SC": "4214607",
"Agronômica|SC": "4200309",
"Presidente Nereu|SC": "4214102",
"Witmarsum|SC": "4219408",
"Imbuia|SC": "4207403",
"Vidal Ramos|SC": "4219200",
"Santa Terezinha|SC": "4215679",
"Taió|SC": "4217808",
"Rio Fortuna|SC": "4214904",
"São Martinho|SC": "4217105",
"Riqueza|SC": "4215075",
"Romelândia|SC": "4215208",
"Saltinho|SC": "4215356",
"Salto Veloso|SC": "4215406",
"Santa Helena|SC": "4215554",
"Santa Terezinha do Progresso|SC": "4215687",
"São João do Oeste|SC": "4216255",
"São João do Itaperiú|SC": "4216354",
"São José do Cedro|SC": "4216701",
"São Lourenço do Oeste|SC": "4216909",
"Serra Alta|SC": "4217550",
"Sul Brasil|SC": "4217758",
"Tangará|SC": "4217907",
"Tigrinhos|SC": "4217956",
"Treviso|SC": "4218350",
"Treze de Maio|SC": "4218400",
"Tramandaí|RS": "4321600",
"Tunápolis|SC": "4218756",
"União do Oeste|SC": "4218855",
"Vargeão|SC": "4219101",
"Zortéa|SC": "4219853",
"Aceguá|RS": "4300034",
"Água Santa|RS": "4300059",
"Agudo|RS": "4300109",
"Ajuricaba|RS": "4300208",
"Alecrim|RS": "4300307",
"Manoel Viana|RS": "4311759",
"Rosário do Sul|RS": "4316402",
"Uruguaiana|RS": "4322400",
"Cruz Alta|RS": "4306106",
"Alegria|RS": "4300455",
"Almirante Tamandaré do Sul|RS": "4300471",
"Alpestre|RS": "4300505",
"Alto Alegre|RS": "4300554",
"Alto Feliz|RS": "4300570",
"Gravataí|RS": "4309209",
"Amaral Ferrador|RS": "4300638",
"Ametista do Sul|RS": "4300646",
"André da Rocha|RS": "4300661",
"Anta Gorda|RS": "4300703",
"Antônio Prado|RS": "4300802",
"Ipê|RS": "4310439",
"Farroupilha|RS": "4307906",
"Arambaré|RS": "4300851",
"Aratiba|RS": "4300901",
"Arroio do Meio|RS": "4301008",
"Canudos do Vale|RS": "4304614",
"Putinga|RS": "4315206",
"Lajeado|RS": "4311403",
"Arroio do Sal|RS": "4301057",
"Arroio do Padre|RS": "4301073",
"Arroio dos Ratos|RS": "4301107",
"Barão do Triunfo|RS": "4301750",
"Barão|RS": "4301651",
"Arroio do Tigre|RS": "4301206",
"Lagoão|RS": "4311254",
"Arroio Grande|RS": "4301305",
"Arvorezinha|RS": "4301404",
"Itapuca|RS": "4310579",
"Augusto Pestana|RS": "4301503",
"Áurea|RS": "4301552",
"Bagé|RS": "4301602",
"Barão de Cotegipe|RS": "4301701",
"Barracão|RS": "4301800",
"Barra do Quaraí|RS": "4301875",
"Barra do Ribeiro|RS": "4301909",
"Barra do Rio Azul|RS": "4301925",
"Barra Funda|RS": "4301958",
"Barros Cassal|RS": "4302006",
"Benjamin Constant do Sul|RS": "4302055",
"Bento Gonçalves|RS": "4302105",
"Tupanciretã|RS": "4322202",
"Bom Retiro do Sul|RS": "4302402",
"Parobé|RS": "4314050",
"Nova Bassano|RS": "4312906",
"Charrua|RS": "4305371",
"São Miguel das Missões|RS": "4319158",
"Canela|RS": "4304408",
"Guaporé|RS": "4309407",
"Santa Tereza|RS": "4317251",
"Serafina Corrêa|RS": "4320404",
"São Francisco de Paula|RS": "4318200",
"Carlos Barbosa|RS": "4304804",
"Taquari|RS": "4321303",
"Nova Prata|RS": "4313300",
"Monte Belo do Sul|RS": "4312385",
"Osório|RS": "4313508",
"Boa Vista das Missões|RS": "4302154",
"Boa Vista do Buricá|RS": "4302204",
"Boa Vista do Incra|RS": "4302238",
"Boa Vista do Sul|RS": "4302253",
"Bom Jesus|RS": "4302303",
"Bom Princípio|RS": "4302352",
"Boqueirão do Leão|RS": "4302451",
"Bossoroca|RS": "4302501",
"Bozano|RS": "4302584",
"Braga|RS": "4302600",
"Brochier|RS": "4302659",
"Butiá|RS": "4302709",
"Caçapava do Sul|RS": "4302808",
"Candiota|RS": "4304358",
"Cacequi|RS": "4302907",
"Santa Maria|RS": "4316907",
"Novo Cabrais|RS": "4313391",
"Cerro Branco|RS": "4305132",
"Encruzilhada do Sul|RS": "4306908",
"Capão da Canoa|RS": "4304630",
"Cachoeirinha|RS": "4303103",
"Cidreira|RS": "4305454",
"Cacique Doble|RS": "4303202",
"Caibaté|RS": "4303301",
"Caiçara|RS": "4303400",
"Camaquã|RS": "4303509",
"Sentinela do Sul|RS": "4320354",
"São Lourenço do Sul|RS": "4318804",
"Sete de Setembro|RS": "4320578",
"Dom Feliciano|RS": "4306502",
"Cerro Grande do Sul|RS": "4305173",
"Camargo|RS": "4303558",
"Cambará do Sul|RS": "4303608",
"Campestre da Serra|RS": "4303673",
"Campina das Missões|RS": "4303707",
"Cerro Largo|RS": "4305207",
"Campinas do Sul|RS": "4303806",
"Campo Bom|RS": "4303905",
"Sapucaia do Sul|RS": "4320008",
"Taquara|RS": "4321204",
"Campo Novo|RS": "4304002",
"Campos Borges|RS": "4304101",
"Candelária|RS": "4304200",
"Cândido Godói|RS": "4304309",
"Gramado|RS": "4309100",
"Nova Petrópolis|RS": "4313201",
"Canguçu|RS": "4304507",
"Pedro Osório|RS": "4314209",
"Pelotas|RS": "4314407",
"Nova Santa Rita|RS": "4313375",
"Guaíba|RS": "4309308",
"Esteio|RS": "4307708",
"Eldorado do Sul|RS": "4306767",
"Estância Velha|RS": "4307609",
"Teutônia|RS": "4321451",
"Santa Maria do Herval|RS": "4316956",
"Portão|RS": "4314803",
"Charqueadas|RS": "4305355",
"Triunfo|RS": "4322004",
"Torres|RS": "4321501",
"Salvador do Sul|RS": "4316501",
"Montenegro|RS": "4312401",
"Dois Irmãos|RS": "4306403",
"Capão Bonito do Sul|RS": "4304622",
"Terra de Areia|RS": "4321436",
"Xangri-lá|RS": "4323804",
"Lagoa Vermelha|RS": "4311304",
"Capela de Santana|RS": "4304689",
"Morro Reuter|RS": "4312476",
"Maquiné|RS": "4311775",
"Capão do Cipó|RS": "4304655",
"Capão do Leão|RS": "4304663",
"Capivari do Sul|RS": "4304671",
"Capitão|RS": "4304697",
"Carazinho|RS": "4304705",
"Chapada|RS": "4305306",
"Caraá|RS": "4304713",
"Casca|RS": "4304903",
"Catuípe|RS": "4305009",
"Vacaria|RS": "4322509",
"Flores da Cunha|RS": "4308201",
"São Marcos|RS": "4319000",
"São José dos Ausentes|RS": "4318622",
"Veranópolis|RS": "4322806",
"Imbé|RS": "4310330",
"Nova Araçá|RS": "4312807",
"Garibaldi|RS": "4308607",
"Coronel Pilar|RS": "4305934",
"Jaquirana|RS": "4311122",
"Centenário|RS": "4305116",
"Cerrito|RS": "4305124",
"São Pedro do Butiá|RS": "4319372",
"São Jerônimo|RS": "4318408",
"General Câmara|RS": "4308805",
"Chiapetta|RS": "4305405",
"Chuí|RS": "4305439",
"Chuvisca|RS": "4305447",
"Ciríaco|RS": "4305504",
"Colinas|RS": "4305587",
"Colorado|RS": "4305603",
"Condor|RS": "4305702",
"Constantina|RS": "4305801",
"Coqueiro Baixo|RS": "4305835",
"Coqueiros do Sul|RS": "4305850",
"Coronel Barros|RS": "4305871",
"Coronel Bicaco|RS": "4305900",
"Cotiporã|RS": "4305959",
"Coxilha|RS": "4305975",
"Crissiumal|RS": "4306007",
"Cristal|RS": "4306056",
"Cristal do Sul|RS": "4306072",
"Derrubadas|RS": "4306320",
"Júlio de Castilhos|RS": "4311205",
"Cruzaltense|RS": "4306130",
"Cruzeiro do Sul|RS": "4306205",
"David Canabarro|RS": "4306304",
"Dezesseis de Novembro|RS": "4306353",
"Dilermando de Aguiar|RS": "4306379",
"Dois Irmãos das Missões|RS": "4306429",
"Dois Lajeados|RS": "4306452",
"Dona Francisca|RS": "4306700",
"Doutor Maurício Cardoso|RS": "4306734",
"Doutor Ricardo|RS": "4306759",
"Erechim|RS": "4307005",
"Encantado|RS": "4306809",
"Roca Sales|RS": "4315800",
"Relvado|RS": "4315453",
"Muçum|RS": "4312609",
"Engenho Velho|RS": "4306924",
"Entre-Ijuís|RS": "4306932",
"Getúlio Vargas|RS": "4308904",
"Jacutinga|RS": "4310900",
"Passo Fundo|RS": "4314100",
"Gramado dos Loureiros|RS": "4309126",
"Nonoai|RS": "4312708",
"Viadutos|RS": "4322905",
"Marcelino Ramos|RS": "4311908",
"Severiano de Almeida|RS": "4320602",
"São Valentim|RS": "4319703",
"Ernestina|RS": "4307054",
"Herval|RS": "4307104",
"Erval Grande|RS": "4307203",
"Erval Seco|RS": "4307302",
"Esmeralda|RS": "4307401",
"Esperança do Sul|RS": "4307450",
"Espumoso|RS": "4307500",
"Tapera|RS": "4321006",
"Não-Me-Toque|RS": "4312658",
"Estação|RS": "4307559",
"Estrela|RS": "4307807",
"Fazenda Vilanova|RS": "4308078",
"Imigrante|RS": "4310363",
"Estrela Velha|RS": "4307815",
"Eugênio de Castro|RS": "4307831",
"Fagundes Varela|RS": "4307864",
"Nova Roma do Sul|RS": "4313359",
"São Martinho|RS": "4319109",
"Faxinal do Soturno|RS": "4308003",
"Silveira Martins|RS": "4320651",
"Feliz|RS": "4308102",
"Fontoura Xavier|RS": "4308300",
"Formigueiro|RS": "4308409",
"Forquetinha|RS": "4308433",
"Fortaleza dos Valos|RS": "4308458",
"Frederico Westphalen|RS": "4308508",
"Redentora|RS": "4315404",
"Palmitinho|RS": "4313805",
"Miraguaí|RS": "4312302",
"Novo Tiradentes|RS": "4313441",
"Taquaruçu do Sul|RS": "4321329",
"Planalto|RS": "4314704",
"Rodeio Bonito|RS": "4315909",
"Três Passos|RS": "4321907",
"Garruchos|RS": "4308656",
"Gaurama|RS": "4308706",
"Gentil|RS": "4308854",
"Giruá|RS": "4309001",
"Glorinha|RS": "4309050",
"Gramado Xavier|RS": "4309159",
"Guabiju|RS": "4309258",
"Sertão Santana|RS": "4320552",
"Mariana Pimentel|RS": "4311981",
"São Nicolau|RS": "4319208",
"Guarani das Missões|RS": "4309506",
"Harmonia|RS": "4309555",
"Herveiras|RS": "4309571",
"Horizontina|RS": "4309605",
"Hulha Negra|RS": "4309654",
"Humaitá|RS": "4309704",
"Ibarama|RS": "4309753",
"Ibiaçá|RS": "4309803",
"Ibiraiaras|RS": "4309902",
"Ibirapuitã|RS": "4309951",
"Ibirubá|RS": "4310009",
"Quinze de Novembro|RS": "4315354",
"Igrejinha|RS": "4310108",
"Três Coroas|RS": "4321709",
"Ijuí|RS": "4310207",
"Roque Gonzales|RS": "4316303",
"Panambi|RS": "4313904",
"Jóia|RS": "4311155",
"Sarandi|RS": "4320107",
"Ilópolis|RS": "4310306",
"Independência|RS": "4310405",
"Ipiranga do Sul|RS": "4310462",
"Iraí|RS": "4310504",
"Itaara|RS": "4310538",
"Itacurubi|RS": "4310553",
"Itaqui|RS": "4310603",
"Maçambará|RS": "4311718",
"Itati|RS": "4310652",
"Itatiba do Sul|RS": "4310702",
"Ivorá|RS": "4310751",
"Ivoti|RS": "4310801",
"Lindolfo Collor|RS": "4311627",
"Jaboticaba|RS": "4310850",
"Jacuizinho|RS": "4310876",
"Jaguarão|RS": "4311007",
"Jaguari|RS": "4311106",
"Jari|RS": "4311130",
"Lagoa Bonita do Sul|RS": "4311239",
"Lagoa dos Três Cantos|RS": "4311270",
"Sant'Ana do Livramento|RS": "4317103",
"Marques de Souza|RS": "4312054",
"Passo do Sobrado|RS": "4314076",
"Lajeado do Bugre|RS": "4311429",
"Palmeira das Missões|RS": "4313706",
"Lavras do Sul|RS": "4311502",
"Liberato Salzano|RS": "4311601",
"Linha Nova|RS": "4311643",
"Machadinho|RS": "4311700",
"Mampituba|RS": "4311734",
"Maratá|RS": "4311791",
"Marau|RS": "4311809",
"Nicolau Vergueiro|RS": "4312674",
"Montauri|RS": "4312351",
"Vila Maria|RS": "4323408",
"Mariano Moro|RS": "4312005",
"Mata|RS": "4312104",
"Mato Castelhano|RS": "4312138",
"Mato Leitão|RS": "4312153",
"Mato Queimado|RS": "4312179",
"Minas do Leão|RS": "4312252",
"Monte Alegre dos Campos|RS": "4312377",
"Pareci Novo|RS": "4314035",
"São José do Sul|RS": "4318614",
"Santo Antônio da Patrulha|RS": "4317608",
"Tabaí|RS": "4320859",
"Mormaço|RS": "4312427",
"Morrinhos do Sul|RS": "4312443",
"Morro Redondo|RS": "4312450",
"Mostardas|RS": "4312500",
"Muitos Capões|RS": "4312617",
"Muliterno|RS": "4312625",
"Rio dos Índios|RS": "4315552",
"Sete Quedas|MS": "5007703",
"Nova Alvorada|RS": "4312757",
"Nova Boa Vista|RS": "4312955",
"Nova Bréscia|RS": "4313003",
"Nova Esperança do Sul|RS": "4313037",
"Nova Pádua|RS": "4313086",
"Pinhal Grande|RS": "4314472",
"Nova Palma|RS": "4313102",
"Vanini|RS": "4322558",
"São Jorge|RS": "4318440",
"São José do Hortêncio|RS": "4318481",
"Picada Café|RS": "4314423",
"Novo Machado|RS": "4313425",
"Novo Barreiro|RS": "4313490",
"Palmares do Sul|RS": "4313656",
"Pinhal|RS": "4314456",
"Paim Filho|RS": "4313607",
"São Pedro das Missões|RS": "4319364",
"Sagrada Família|RS": "4316428",
"Pantano Grande|RS": "4313953",
"Paraí|RS": "4314001",
"Paraíso do Sul|RS": "4314027",
"Passa Sete|RS": "4314068",
"Sananduva|RS": "4316600",
"Tapejara|RS": "4320909",
"Tio Hugo|RS": "4321469",
"Rondinha|RS": "4316204",
"Tupanci do Sul|RS": "4322186",
"Pontão|RS": "4314779",
"Santa Bárbara do Sul|RS": "4316709",
"Ronda Alta|RS": "4316105",
"Seberi|RS": "4320206",
"Victor Graeff|RS": "4323200",
"São João da Urtiga|RS": "4318424",
"Saldanha Marinho|RS": "4316436",
"Tenente Portela|RS": "4321402",
"São Domingos do Sul|RS": "4318051",
"Pouso Novo|RS": "4315131",
"São Luiz Gonzaga|RS": "4318903",
"Sertão|RS": "4320503",
"Pinhal da Serra|RS": "4314464",
"Santo Antônio das Missões|RS": "4317707",
"São José do Ouro|RS": "4318606",
"Tuparendi|RS": "4322301",
"Trindade do Sul|RS": "4321956",
"Paulo Bento|RS": "4314134",
"Paverama|RS": "4314159",
"Pejuçara|RS": "4314308",
"Pinheiro Machado|RS": "4314506",
"Piratini|RS": "4314605",
"Santana da Boa Vista|RS": "4317004",
"Pinheirinho do Vale|RS": "4314498",
"Pinto Bandeira|RS": "4314548",
"Pirapó|RS": "4314555",
"Poço das Antas|RS": "4314753",
"Rolante|RS": "4316006",
"Tavares|RS": "4321352",
"Riozinho|RS": "4315750",
"Porto Xavier|RS": "4315107",
"Vera Cruz|RS": "4322707",
"São Borja|RS": "4318002",
"São Sepé|RS": "4319604",
"Tapes|RS": "4321105",
"Santa Cruz do Sul|RS": "4316808",
"Vale Verde|RS": "4322525",
"Três Cachoeiras|RS": "4321667",
"Sinimbu|RS": "4320677",
"Sobradinho|RS": "4320701",
"Cerro Grande|RS": "4305157",
"São Francisco de Assis|RS": "4318101",
"São Gabriel|RS": "4318309",
"Santo Ângelo|RS": "4317509",
"Tupandi|RS": "4322251",
"São José do Norte|RS": "4318507",
"São José do Herval|RS": "4318465",
"Santiago|RS": "4317400",
"São Paulo das Missões|RS": "4319307",
"Três Forquilhas|RS": "4321832",
"Santo Cristo|RS": "4317905",
"Salto do Jacuí|RS": "4316451",
"Dom Pedro de Alcântara|RS": "4306551",
"Lucas do Rio Verde|MT": "5105259",
"Vale do Sol|RS": "4322533",
"São Pedro da Serra|RS": "4319356",
"Presidente Lucena|RS": "4315149",
"Pedras Altas|RS": "4314175",
"Porto Lucena|RS": "4315008",
"Porto Mauá|RS": "4315057",
"Progresso|RS": "4315156",
"Protásio Alves|RS": "4315172",
"Quaraí|RS": "4315305",
"Quevedos|RS": "4315321",
"Restinga Sêca|RS": "4315503",
"Rolador|RS": "4315958",
"Salvador das Missões|RS": "4316477",
"Santa Cecília do Sul|RS": "4316733",
"Santa Clara do Sul|RS": "4316758",
"São Pedro do Sul|RS": "4319406",
"Vila Nova do Sul|RS": "4323457",
"São Martinho da Serra|RS": "4319125",
"São Vicente do Sul|RS": "4319802",
"Santa Margarida do Sul|RS": "4316972",
"Unistalda|RS": "4322376",
"Santo Antônio do Planalto|RS": "4317756",
"Santo Augusto|RS": "4317806",
"Santo Expedito do Sul|RS": "4317954",
"São João do Polêsine|RS": "4318432",
"São José das Missões|RS": "4318457",
"Turuçu|RS": "4322327",
"São Valentim do Sul|RS": "4319711",
"São Valério do Sul|RS": "4319737",
"São Vendelino|RS": "4319752",
"Sede Nova|RS": "4320230",
"Segredo|RS": "4320263",
"Selbach|RS": "4320305",
"Senador Salgado Filho|RS": "4320321",
"Sério|RS": "4320453",
"Tunas|RS": "4322152",
"Barra do Guarita|RS": "4301859",
"Vicente Dutra|RS": "4323101",
"Westfália|RS": "4323770",
"Tiradentes do Sul|RS": "4321477",
"Toropi|RS": "4321493",
"Travesseiro|RS": "4321626",
"Três Arroios|RS": "4321634",
"Três de Maio|RS": "4321808",
"Três Palmeiras|RS": "4321857",
"Tucunduva|RS": "4322103",
"União da Serra|RS": "4322350",
"Vale Real|RS": "4322541",
"Vila Flores|RS": "4323309",
"Vespasiano Corrêa|RS": "4322855",
"Vila Lângaro|RS": "4323358",
"Vista Alegre|RS": "4323507",
"Vista Alegre do Prata|RS": "4323606",
"Vista Gaúcha|RS": "4323705",
"Vitória das Missões|RS": "4323754",
"Água Clara|MS": "5000203",
"Alcinópolis|MS": "5000252",
"Alto Araguaia|MT": "5100300",
"Amambai|MS": "5000609",
"Aral Moreira|MS": "5001243",
"Paranhos|MS": "5006358",
"Coronel Sapucaia|MS": "5003157",
"Anastácio|MS": "5000708",
"Nioaque|MS": "5005806",
"Anaurilândia|MS": "5000807",
"Angélica|MS": "5000856",
"Antônio João|MS": "5000906",
"Bela Vista|MS": "5002100",
"Aparecida do Taboado|MS": "5001003",
"Aquidauana|MS": "5001102",
"Guia Lopes da Laguna|MS": "5004106",
"Miranda|MS": "5005608",
"Dois Irmãos do Buriti|MS": "5003488",
"Três Lagoas|MS": "5008305",
"Camapuã|MS": "5002605",
"Bandeirantes|MS": "5001508",
"Bataguassu|MS": "5001904",
"Batayporã|MS": "5002001",
"Bodoquena|MS": "5002159",
"Porto Murtinho|MS": "5006903",
"Jardim|MS": "5005004",
"Brasilândia|MS": "5002308",
"Caarapó|MS": "5002407",
"Ribas do Rio Pardo|MS": "5007109",
"Maracaju|MS": "5005400",
"Rio Negro|MS": "5007307",
"Terenos|MS": "5008008",
"Rio Verde de Mato Grosso|MS": "5007406",
"Rochedo|MS": "5007505",
"Coxim|MS": "5003306",
"São Gabriel do Oeste|MS": "5007695",
"Cassilândia|MS": "5002902",
"Chapadão do Sul|MS": "5002951",
"Vicentina|MS": "5008404",
"Nova Alvorada do Sul|MS": "5006002",
"Sonora|MS": "5007935",
"Paranaíba|MS": "5006309",
"Inocência|MS": "5004403",
"Glória de Dourados|MS": "5004007",
"Figueirão|MS": "5003900",
"Jaraguari|MS": "5004908",
"Pedro Gomes|MS": "5006408",
"Corguinho|MS": "5003108",
"Rio Brilhante|MS": "5007208",
"Mineiros|GO": "5213103",
"Ivinhema|MS": "5004700",
"Goiás|GO": "5208905",
"Caracol|MS": "5002803",
"Deodápolis|MS": "5003454",
"Japorã|MS": "5004809",
"Chapada dos Guimarães|MT": "5103007",
"Tacuru|MS": "5007950",
"Piranhas|GO": "5217203",
"Douradina|MS": "5003504",
"Itaquiraí|MS": "5004601",
"Laguna Carapã|MS": "5005251",
"Taquarussu|MS": "5007976",
"Fátima do Sul|MS": "5003801",
"Itaporã|MS": "5004502",
"Juti|MS": "5005152",
"Jateí|MS": "5005103",
"Novo Horizonte do Sul|MS": "5006259",
"Paraíso das Águas|MS": "5006275",
"Santa Rita do Pardo|MS": "5007554",
"Acorizal|MT": "5100102",
"Água Boa|MT": "5100201",
"Nova Nazaré|MT": "5106174",
"Cocalinho|MT": "5103106",
"Campinápolis|MT": "5102603",
"Ribeirão Cascalheira|MT": "5107180",
"Canarana|MT": "5102702",
"Bom Jesus do Araguaia|MT": "5101852",
"Goianápolis|GO": "5208400",
"Gaúcha do Norte|MT": "5103858",
"Querência|MT": "5107065",
"Novo Santo Antônio|MT": "5106315",
"Alta Floresta|MT": "5100250",
"Carlinda|MT": "5102793",
"Apiacás|MT": "5100805",
"Nova Canaã do Norte|MT": "5106216",
"Alto Taquari|MT": "5100607",
"Alto Boa Vista|MT": "5100359",
"Alto Garças|MT": "5100409",
"Pedra Preta|MT": "5106372",
"Alto Paraguai|MT": "5100508",
"Araguaiana|MT": "5101001",
"Araputanga|MT": "5101258",
"Arenápolis|MT": "5101308",
"Barão de Melgaço|MT": "5101605",
"Pontal do Araguaia|MT": "5106653",
"General Carneiro|MT": "5103908",
"Aragarças|GO": "5201702",
"Novo São Joaquim|MT": "5106281",
"Rio Verde|GO": "5218805",
"São José do Xingu|MT": "5107354",
"Brasnorte|MT": "5101902",
"Jauru|MT": "5105002",
"Porto Esperidião|MT": "5106828",
"Mirassol d'Oeste|MT": "5105622",
"São José dos Quatro Marcos|MT": "5107107",
"Indiavaí|MT": "5104500",
"Campos de Júlio|MT": "5102686",
"Vila Bela da Santíssima Trindade|MT": "5105507",
"Glória D'Oeste|MT": "5103957",
"Rio Branco|MT": "5107206",
"Curvelândia|MT": "5103437",
"Santa Terezinha|MT": "5107776",
"Salto do Céu|MT": "5107750",
"Colíder|MT": "5103205",
"Lambari D'Oeste|MT": "5105234",
"Reserva do Cabaçal|MT": "5107156",
"Rosário Oeste|MT": "5107701",
"Campo Verde|MT": "5102678",
"Canabrava do Norte|MT": "5102694",
"Feliz Natal|MT": "5103700",
"Castanheira|MT": "5102850",
"Guarantã do Norte|MT": "5104104",
"Nova Santa Helena|MT": "5106190",
"Sinop|MT": "5107909",
"Marcelândia|MT": "5105580",
"Nova Bandeirantes|MT": "5106158",
"Itaúba|MT": "5104559",
"Nova Mutum|MT": "5106224",
"União do Sul|MT": "5108303",
"Porto Alegre do Norte|MT": "5106778",
"Santa Cruz do Xingu|MT": "5107743",
"Tangará da Serra|MT": "5107958",
"Trindade|GO": "5221403",
"Conquista D'Oeste|MT": "5103361",
"São José do Rio Claro|MT": "5107305",
"Diamantino|MT": "5103502",
"Poconé|MT": "5106505",
"Santo Antônio de Leverger|MT": "5107800",
"Juruena|MT": "5105176",
"Nova Xavantina|MT": "5106257",
"Jangada|MT": "5104906",
"Nova Marilândia|MT": "5108857",
"Nobres|MT": "5105903",
"Nova Brasilândia|MT": "5106208",
"Sapezal|MT": "5107875",
"Jaciara|MT": "5104807",
"Nortelândia|MT": "5106000",
"Nossa Senhora do Livramento|MT": "5106109",
"Guiratinga|MT": "5104203",
"Juscimeira|MT": "5105200",
"Poxoréu|MT": "5107008",
"Nova Olímpia|MT": "5106232",
"Terra Nova do Norte|MT": "5108055",
"Santa Carmem|MT": "5107248",
"Porto Estrela|MT": "5106851",
"São Félix do Araguaia|MT": "5107859",
"Denise|MT": "5103452",
"Nova Lacerda|MT": "5106182",
"Planalto da Serra|MT": "5106455",
"Luciara|MT": "5105309",
"Nova Ubiratã|MT": "5106240",
"Dom Aquino|MT": "5103601",
"Figueirópolis D'Oeste|MT": "5103809",
"São José do Povo|MT": "5107297",
"Ipiranga do Norte|MT": "5104526",
"Itanhangá|MT": "5104542",
"Porto dos Gaúchos|MT": "5106802",
"Itiquira|MT": "5104609",
"Tabaporã|MT": "5107941",
"Novo Mundo|MT": "5106265",
"Novo Horizonte do Norte|MT": "5106273",
"Paranaíta|MT": "5106299",
"Ponte Branca|MT": "5106703",
"Nazário|GO": "5214408",
"Santo Antônio do Leste|MT": "5107792",
"Ribeirãozinho|MT": "5107198",
"Santo Afonso|MT": "5107263",
"São Pedro da Cipa|MT": "5107404",
"Tesouro|MT": "5108105",
"Santa Rita do Trivelato|MT": "5107768",
"Vera|MT": "5108501",
"Tapurah|MT": "5108006",
"Nova Guarita|MT": "5108808",
"Torixoréu|MT": "5108204",
"Vale de São Domingos|MT": "5108352",
"São Miguel do Araguaia|GO": "5220207",
"Nova Maringá|MT": "5108907",
"Nova Monte Verde|MT": "5108956",
"Abadia de Goiás|GO": "5200050",
"Abadiânia|GO": "5200100",
"Acreúna|GO": "5200134",
"Adelândia|GO": "5200159",
"Água Fria de Goiás|GO": "5200175",
"Água Limpa|GO": "5200209",
"Cocalzinho de Goiás|GO": "5205513",
"Itaberaí|GO": "5210406",
"Alexânia|GO": "5200308",
"Alto Horizonte|GO": "5200555",
"Amaralina|GO": "5200829",
"Alto Paraíso de Goiás|GO": "5200605",
"Alvorada do Norte|GO": "5200803",
"Mambaí|GO": "5212709",
"Americano do Brasil|GO": "5200852",
"Crixás|GO": "5206404",
"Campo Limpo de Goiás|GO": "5204854",
"Corumbá de Goiás|GO": "5205802",
"Ouro Verde de Goiás|GO": "5215405",
"Rubiataba|GO": "5218904",
"Leopoldo de Bulhões|GO": "5212303",
"Jaraguá|GO": "5211800",
"Padre Bernardo|GO": "5215603",
"Terezópolis de Goiás|GO": "5221197",
"Pires do Rio|GO": "5217401",
"Goianésia|GO": "5208608",
"Campos Verdes|GO": "5204953",
"Pirenópolis|GO": "5217302",
"Campinaçu|GO": "5204656",
"Nova Veneza|GO": "5215009",
"Campinorte|GO": "5204706",
"Uruaçu|GO": "5221601",
"Porangatu|GO": "5218003",
"Minaçu|GO": "5213087",
"Carmo do Rio Verde|GO": "5205000",
"São Francisco de Goiás|GO": "5219902",
"Niquelândia|GO": "5214606",
"Posse|GO": "5218300",
"Planaltina|GO": "5217609",
"Iaciara|GO": "5209903",
"Anicuns|GO": "5201306",
"Hidrolândia|GO": "5209705",
"São Domingos|GO": "5219803",
"Indiara|GO": "5209952",
"Piracanjuba|GO": "5217104",
"Silvânia|GO": "5220603",
"Aragoiânia|GO": "5201801",
"Edéia|GO": "5207402",
"Itaguari|GO": "5210562",
"Ceres|GO": "5205406",
"Aurilândia|GO": "5202601",
"Varjão|GO": "5221908",
"Santa Bárbara de Goiás|GO": "5219100",
"Goiatuba|GO": "5209101",
"Professor Jamil|GO": "5218391",
"Aparecida do Rio Doce|GO": "5201454",
"Aporé|GO": "5201504",
"Araçu|GO": "5201603",
"Araguapaz|GO": "5202155",
"Arenópolis|GO": "5202353",
"Aruanã|GO": "5202502",
"Avelinópolis|GO": "5202809",
"Baliza|GO": "5203104",
"Barro Alto|GO": "5203203",
"Bela Vista de Goiás|GO": "5203302",
"Bom Jardim de Goiás|GO": "5203401",
"Bom Jesus de Goiás|GO": "5203500",
"Bonfinópolis|GO": "5203559",
"Bonópolis|GO": "5203575",
"Brazabrantes|GO": "5203609",
"Britânia|GO": "5203807",
"Buriti Alegre|GO": "5203906",
"Buriti de Goiás|GO": "5203939",
"Buritinópolis|GO": "5203962",
"Cabeceiras|GO": "5204003",
"Cachoeira de Goiás|GO": "5204201",
"Caçu|GO": "5204300",
"Caiapônia|GO": "5204409",
"Caldas Novas|GO": "5204508",
"Morrinhos|GO": "5213806",
"Caldazinha|GO": "5204557",
"Campestre de Goiás|GO": "5204607",
"Campo Alegre de Goiás|GO": "5204805",
"Campos Belos|GO": "5204904",
"Divinópolis de Goiás|GO": "5208301",
"Castelândia|GO": "5205059",
"Ouvidor|GO": "5215504",
"Três Ranchos|GO": "5221304",
"Ipameri|GO": "5210109",
"Corumbaíba|GO": "5205901",
"Cumari|GO": "5206602",
"Nova Aurora|GO": "5214804",
"Anhanguera|GO": "5201207",
"Caturaí|GO": "5205208",
"Cavalcante|GO": "5205307",
"Ipiranga de Goiás|GO": "5210158",
"São Luiz do Norte|GO": "5220157",
"São Patrício|GO": "5220280",
"Nova América|GO": "5214705",
"Mara Rosa|GO": "5212808",
"Santa Terezinha de Goiás|GO": "5219704",
"Rialma|GO": "5218607",
"Uruana|GO": "5221700",
"Itapaci|GO": "5210901",
"Nova Glória|GO": "5214861",
"Rianápolis|GO": "5218706",
"Cezarina|GO": "5205455",
"Chapadão do Céu|GO": "5205471",
"Cidade Ocidental|GO": "5205497",
"Colinas do Sul|GO": "5205521",
"Córrego do Ouro|GO": "5205703",
"Cristianópolis|GO": "5206305",
"Cromínia|GO": "5206503",
"Damianópolis|GO": "5206701",
"Damolândia|GO": "5206800",
"Davinópolis|GO": "5206909",
"Diorama|GO": "5207105",
"Doverlândia|GO": "5207253",
"Edealina|GO": "5207352",
"Estrela do Norte|GO": "5207501",
"Faina|GO": "5207535",
"Fazenda Nova|GO": "5207600",
"Firminópolis|GO": "5207808",
"Flores de Goiás|GO": "5207907",
"Formosa|GO": "5208004",
"Santo Antônio do Descoberto|GO": "5219753",
"Formoso|GO": "5208103",
"Goiandira|GO": "5208509",
"Nerópolis|GO": "5214507",
"Iporá|GO": "5210208",
"Novo Planalto|GO": "5215256",
"Sanclerlândia|GO": "5219001",
"Itauçu|GO": "5211404",
"Jandaia|GO": "5211701",
"Petrolina de Goiás|GO": "5216809",
"Paraúna|GO": "5216403",
"Mossâmedes|GO": "5213905",
"Itaguaru|GO": "5210604",
"Vicentinópolis|GO": "5222054",
"Urutaí|GO": "5221809",
"Inhumas|GO": "5210000",
"Jussara|GO": "5212204",
"Maurilândia|GO": "5213004",
"Palmeiras de Goiás|GO": "5215702",
"Santa Fé de Goiás|GO": "5219258",
"Mairipotaba|GO": "5212600",
"Santa Rita do Araguaia|GO": "5219407",
"Simolândia|GO": "5220686",
"Nova Crixás|GO": "5214838",
"Turvelândia|GO": "5221551",
"Paranaiguara|GO": "5216304",
"Pilar de Goiás|GO": "5216908",
"Aloândia|GO": "5200506",
"Montes Claros de Goiás|GO": "5213707",
"Goianira|GO": "5208806",
"Itapirapuã|GO": "5211008",
"Itapuranga|GO": "5211206",
"Novo Brasil|GO": "5215207",
"Mozarlândia|GO": "5214002",
"Santa Helena de Goiás|GO": "5219308",
"Heitoraí|GO": "5209606",
"São João da Paraúna|GO": "5220058",
"São Miguel do Passa Quatro|GO": "5220264",
"Jataí|GO": "5211909",
"Guarani de Goiás|GO": "5209408",
"Mundo Novo|GO": "5214051",
"Vianópolis|GO": "5222005",
"Guapó|GO": "5209200",
"Moiporá|GO": "5213400",
"Santa Isabel|GO": "5219357",
"Santo Antônio de Goiás|GO": "5219738",
"Nova Iguaçu de Goiás|GO": "5214879",
"Montividiu do Norte|GO": "5213772",
"Guarinos|GO": "5209457",
"Orizona|GO": "5215306",
"Gameleira de Goiás|GO": "5208152",
"Gouvelândia|GO": "5209150",
"Trombas|GO": "5221452",
"Monte Alegre de Goiás|GO": "5213509",
"Vila Propício|GO": "5222302",
"Santa Rosa de Goiás|GO": "5219506",
"Panamá|GO": "5216007",
"Santa Tereza de Goiás|GO": "5219605",
"Mutunópolis|GO": "5214101",
"Joviânia|GO": "5212105",
"Israelândia|GO": "5210307",
"Montividiu|GO": "5213756",
"Pontalina|GO": "5217708",
"Porteirão|GO": "5218052",
"Palmelo|GO": "5215801",
"Santa Cruz de Goiás|GO": "5219209",
"Itajá|GO": "5210802",
"Serranópolis|GO": "5220504",
"Novo Gama|GO": "5215231",
"Nova Roma|GO": "5214903",
"Vila Boa|GO": "5222203",
"Turvânia|GO": "5221502",
"São João d'Aliança|GO": "5220009",
"Guaraíta|GO": "5209291",
"Hidrolina|GO": "5209804",
"Inaciolândia|GO": "5209937",
"Jaupaci|GO": "5212006",
"Itarumã|GO": "5211305",
"Ivolândia|GO": "5211602",
"Jesúpolis|GO": "5212055",
"Marzagão|GO": "5212907",
"Matrinchã|GO": "5212956",
"Mimoso de Goiás|GO": "5213053",
"Perolândia|GO": "5216452",
"Morro Agudo de Goiás|GO": "5213855",
"Palminópolis|GO": "5215900",
"Portelândia|GO": "5218102",
"Rio Quente|GO": "5218789",
"Santo Antônio da Barra|GO": "5219712",
"Santa Rita do Novo Destino|GO": "5219456",
"Uirapuru|GO": "5221577",
"Sítio d'Abadia|GO": "5220702",
"Taquaral de Goiás|GO": "5221007",
"Teresina de Goiás|GO": "5221080"
};

export default municipioCodigos;